export const sv = { 
    translation: {
            "project_selector.favorites": "Favoriter",
            "project_selector.suggested": "Föreslagna projekt",
            "project_selector.search_results": "Sökresultat",
            "project_selector.projects": "Projekt",
            "project_selector.no_projects_found": "Inga projekt hittades",
            "project_selector.no_projects_to_show": "Inga projekt att visa",
            "project_selector.offer": "Anbud",
            "project_selector.sub_of": "Under",
            "project_list.scope.projects": "Projekt",
            "project_list.scope.offers": "Anbud",
            "project_list.scope.all": "Alla",
            "project_list.badge.offer": "Anbud",
            "project_list.badge.subproject": "Delprojekt",
            "project_list.sub_of": "Hör till",
            "project.parent_project": "Överordnat projekt",
            "project.parent_project.none": "Inget överordnat projekt",
            "Case guide": "Caseguide",
            "Guider": "Guider",
            "Guider tilgjengelig": "Guider tillgängliga",
            "guider": "guider",
            "Velg hvilken guide du vil bruke for etterspurt info.": "Välj vilken guide du vill använda för begärd information.",
            "Velg hvilken guide du vil starte for denne saken.": "Välj vilken guide du vill starta för detta ärende.",
            "Dupliser guide": "Duplicera guide",
            "kopi": "kopia",
            "Uten navn": "Utan namn",
            "Rapportguide": "Rapportguide",
            "Rapportguider": "Rapportguider",
            "Opprett og rediger guidede flyter for rapportarbeid.": "Skapa och redigera guidade flöden för rapportarbete.",
            "Guideomfang": "Guideomfång",
            "Velg om du vil redigere generelle rapportguider eller guider for en spesifikk rapporttype.": "Välj om du vill redigera generella rapportguider eller guider för en specifik rapporttyp.",
            "Tilbake til serviceinnstillinger": "Tillbaka till serviceinställningar",
            "Generelle rapportguider": "Generella rapportguider",
            "Opprett og rediger guidede flyter for rapportarbeid på egen side.": "Skapa och redigera guidade rapportflöden på en egen sida.",
            "Åpne rapportguider": "Öppna rapportguider",
            "Caseguider": "Caseguider",
            "Opprett og rediger guidede flyter for saker.": "Skapa och redigera guidade flöden för ärenden.",
            "Guideomfang case": "Guideomfång (ärendetyp)",
            "Velg case type for å redigere guideflyten.": "Välj ärendetyp för att redigera guideflödet.",
            "Case guides scope intro":
              "Välj om du vill redigera generella caseguider (alla typer) eller guider för en specifik ärendetyp — samma mönster som rapportguider.",
            "Generelle caseguider": "Generella caseguider",
            "Generell caseguide": "Generell",
            "Case guide scope general hint": "Guider som gäller alla ärendetyper.",
            "Case guide scope type hint":
              "Visar guider för denna ärendetyp plus eventuella generella guider. Typspecifika guider listas först.",
            "Tilbake til caseinnstillinger": "Tillbaka till ärendeinställningar",
            "Åpne caseguider": "Öppna caseguider",
            "Opprett og rediger guidede flyter for saker på egen side.": "Skapa och redigera guidade ärendeflöden på en egen sida.",
            "Ingen case typer er opprettet ennå.": "Inga ärendetyper har skapats ännu.",
            "Caseguide-bygger på egen side": "Caseguide-byggaren öppnas på en egen sida.",
            "Åpne guidebygger": "Öppna guidebyggaren",
            "Case guide options connect to effect nodes":
              "Svarsalternativ har bara etikett och värde. Använd Koppla på ett alternativ och länka till en effektnod på arbetsytan (etiketter, prioritet, datum osv.).",
            "Velg rapportguide": "Välj rapportguide",
            "Velg guiden som passer best med oppdraget.": "Välj guiden som passar uppdraget bäst.",
            "Velg guide": "Välj guide",
            "Ny rapportguide": "Ny rapportguide",
            "Ny guide": "Ny guide",
            "Generell": "Generell",
            "Generell rapportguide": "Generell rapportguide",
            "Kan brukes på alle rapporttyper": "Kan användas på alla rapporttyper",
            "spørsmål": "frågor",
            "Avslutt etter dette svaret": "Avsluta efter detta svar",
            "Guide builder": "Guidebyggare",
            "Effekter": "Effekter",
            "Effekt": "Effekt",
            "Effect-node": "Effektnod",
            "Guide flow palette effect id line": "Lägger en nod på arbetsytan med effekt-id:",
            "Guide flow effect editor palette link": "Samma palettblock / effekt-id",
            "Guide flow option connection": "Detta svar leder till",
            "Rapporttekst": "Rapporttext",
            "Intern tekst": "Intern text",
            "Case oppfølging": "Case-uppföljning",
            "Sjekkliste": "Checklista",
            "Videre": "Vidare",
            "Avslutt etter denne effekten": "Avsluta efter denna effekt",
            "Rediger effekt": "Redigera effekt",
            "Opprett spørsmål som noder og koble svar til neste spørsmål.": "Skapa frågor som noder och koppla svar till nästa fråga.",
            "Dra inn eller klikk for å opprette.": "Dra in eller klicka för att skapa.",
            "Guide flow": "Guideflöde",
            "guide.flow.json_dialog_title": "Guideflöde — JSON och AI-instruktion",
            "guide.flow.json_tab": "JSON",
            "guide.flow.ai_guide_tab": "Instruktion till AI",
            "guide.flow.json_hint":
              "Kanter byggs om automatiskt från `next_node_id` på svar och effekter. Klistra in eller redigera JSON och tillämpa.",
            "guide.flow.copy_json": "Kopiera JSON",
            "guide.flow.apply_json": "Applicera på arbetsytan",
            "guide.flow.reload_from_canvas": "Läs om från arbetsytan",
            "guide.flow.reload_from_canvas_success": "Textfältet uppdaterades från arbetsytan.",
            "guide.flow.copy_json_success": "JSON kopierad till urklipp.",
            "guide.flow.clipboard_failed": "Kunde inte använda urklipp.",
            "guide.flow.json_invalid": "Ogiltig JSON eller flöde: {{message}}",
            "guide.flow.json_applied": "Guideflödet uppdaterades.",
            "guide.flow.copy_ai_guide": "Kopiera AI-instruktion",
            "guide.flow.ai_guide_copied": "AI-instruktion kopierad.",
            "guide.flow.ai_empty": "AI returnerade tom flödes-JSON.",
            "guide.flow.ai_applied": "Guideflöde uppdaterat från AI.",
            "guide.flow.open_json": "JSON",
            "guide.flow.open_json_tooltip": "Visa, kopiera, klistra in eller redigera guideflödet som JSON",
            "guide.flow.generate_with_ai": "Generera med AI",
            "guide.flow.ai_guide_intro":
              "Klistra in i externa AI-verktyg eller använd Promangs inbyggda generator. Tekniska nycklar matchar `settings.flow` i API:et.",

            "Velg neste spørsmål for valgt svar.": "Välj nästa fråga för valt svar.",
            "Koble svar til neste spørsmål ved å bruke Koble-knappen på et svar.": "Koppla svar till nästa fråga med Koppla-knappen på ett svar.",
            "Nytt spørsmål": "Ny fråga",
            "Koble": "Koppla",
            "Koble om": "Koppla om",
            "Slett kobling": "Ta bort koppling",
            "Sett som start": "Sätt som start",
            "Rediger spørsmål": "Redigera fråga",
            "Svarvalg": "Svarsalternativ",
            "Velg en node for å redigere.": "Välj en nod för att redigera.",
            "Dato": "Datum",
            "Tid": "Tid",
            "Guidet rapport": "Guidad rapport",
            "Ingen rapportguide er tilgjengelig": "Ingen rapportguide är tillgänglig",
            "Rapportguide lagret": "Rapportguide sparad",
            "Guiden kan fylle rapporttekst og lagrer svar for administrasjon.": "Guiden kan fylla rapporttext och sparar svar för administration.",
            "Lagre rapporttypen før du konfigurerer guide.": "Spara rapporttypen innan du konfigurerar guide.",
            "Konfigurer spørsmål som kan fylle rapporttekst og lagre svar for administrasjon.": "Konfigurera frågor som kan fylla rapporttext och spara svar för administration.",
            "Ta med svar i rapporttekst": "Ta med svar i rapporttext",
            "Rapporttekst ved valg": "Rapporttext vid val",
            "Intern tekst ved valg": "Intern text vid val",
            "Case oppfølging tittel": "Case-uppföljning titel",
            "Case oppfølging tekst": "Case-uppföljning text",
            "Krever tiltak": "Kräver åtgärd",
            "Reklamasjon": "Reklamation",
            "Ingen sjekkliste": "Ingen checklista",
            "Opprett sjekkliste": "Skapa checklista",
            "Opprett oppfølger": "Skapa uppföljare",
            "Oppfølger beskrivelse": "Uppföljarens beskrivning",
            "Oppfølger intern beskrivelse": "Uppföljarens interna beskrivning",
            "Ingen sjekkliste på oppfølger": "Ingen checklista på uppföljare",
            "Opprett avtale på oppfølger": "Skapa avtal på uppföljare",
            "Bruk samme avtaledato og tid som nåværende rapport": "Använd samma avtalsdatum och tid som nuvarande rapport",
            "Guidet case-opprettelse": "Guidad ärendeskapning",
            "Etterspørre info": "Begär information",
            "Etterspurt info": "Begärd information",
            "Guidet opprettelse": "Guidad skapning",
            "Spørsmål": "Fråga",
            "Steg": "Steg",
            "Oppsummering": "Sammanfattning",
            "guide.case_view_summary": "Visa sammanfattning",
            "guide.case_summary_review_intro": "Kontrollera svaren innan du använder guiden.",
            "guide.case_chain_effect_title": "Starta en annan caseguide",
            "guide.case_chain_effect_help":
              "När denna guide har tillämpats på ärendet öppnas den valda guiden automatiskt (denna guide slutförs först).",
            "guide.case_chain_pick_guide": "Nästa guide",
            "guide.case_chain_none": "— ingen —",
            "guide.case_chain_started": "Öppnar nästa guide…",
            "guide.case_chain_summary_hint":
              "När du har använt guiden startas en annan guide automatiskt på samma ärende.",
            "Ingen guide-spørsmål er konfigurert.": "Inga guidefrågor är konfigurerade.",
            "Guiden foreslår": "Guiden föreslår",
            "etiketter": "etiketter",
            "Bruk guide": "Använd guide",
            "Åpne guide": "Öppna guide",
            "Tilbake": "Tillbaka",
            "Neste": "Nästa",
            "Besvart": "Besvarad",
            "Automatiske etiketter brukt": "Automatiska etiketter använda",
            "Automatiske etiketter lagt til": "Automatiska etiketter tillagda",
            "Antall": "Antal",
            "Denne case typen krever guide før opprettelse": "Denna ärendetyp kräver guiden innan skapande",
            "Fyll ut guide": "Fyll i guide",
            "Fyll ut guiden før saken opprettes": "Fyll i guiden innan ärendet skapas",
            "besvarte etterspurt info": "besvarade begärd information",
            "fullførte guide": "slutförde guide",
            "Konfigurer spørsmål, valg og automatiske etiketter for denne case typen.": "Konfigurera frågor, val och automatiska etiketter för denna ärendetyp.",
            "Lagre case type før du konfigurerer guide.": "Spara ärendetypen innan du konfigurerar guiden.",
            "Guide title": "Guidetitel",
            "Guide description": "Guidebeskrivning",
            "Legg til spørsmål": "Lägg till fråga",
            "Lagre guide": "Spara guide",
            "Spørsmålstekst": "Frågetext",
            "Påkrevd": "Obligatorisk",
            "Valg": "Val",
            "Valg 1": "Val 1",
            "Valg label": "Valtext",
            "Verdi": "Värde",
            "Fjern valg": "Ta bort val",
            "Automatiske etiketter": "Automatiska etiketter",
            "Legg til valg": "Lägg till val",
            "Select case type": "Välj ärendetyp",
            "Case Type": "Ärendetyp",
            "No results": "Inga träffar",
            "Select case type first": "Välj ärendetyp först",
            "No guide configured for this case type": "Ingen guide är konfigurerad för denna ärendetyp",
            "Ny case": "Nytt ärende",
            "Velg case type først. Guiden hjelper deg å stille riktige spørsmål og foreslår etiketter automatisk.": "Välj ärendetyp först. Guiden hjälper dig att ställa rätt frågor och föreslår etiketter automatiskt.",
            "Title and case type are required": "Titel och ärendetyp är obligatoriskt",
            "Case type is required": "Ärendetyp är obligatoriskt",
            "Velg case type først. Tittel genereres automatisk med AI etter opprettelse.": "Välj ärendetyp först. Titeln genereras automatiskt med AI efter skapande.",
            "Guide åpnes etter opprettelse": "Guiden öppnas efter skapande",
            "Etter opprettelse": "Efter skapande",
            "Velg case type først. Hvis typen har en guide kan du besvare den før saken opprettes.": "Välj ärendetyp först. Om typen har en guide kan du besvara den innan ärendet skapas.",
            "Valgfri guide for denne case typen": "Valfri guide för denna ärendetyp",
            "Type": "Typ",
            "Detaljer": "Detaljer",
            "Opprett": "Skapa",
            "Velg type": "Välj typ",
            "Saksdetaljer": "Ärendedetaljer",
            "Guide besvart": "Guide besvarad",
            "Klar til opprettelse": "Klar att skapa",
            "Se guide igjen": "Visa guide igen",
            "Start guide": "Starta guide",
            "Hva slags case oppretter du?": "Vilken typ av ärende skapar du?",
            "Case typen styrer hvilke spørsmål og automatiske forslag som vises.": "Ärendetypen styr vilka frågor och automatiska förslag som visas.",
            "Guide": "Guide",
            "Ikke brukt": "Inte använd",
            "Ja": "Ja",
            "Nei": "Nej",
            "templates.title": "Mallar",
            "templates.new": "Ny mall",
            "templates.edit": "Redigera mall",
            "templates.empty": "Inga mallar hittades.",
            "templates.search_placeholder": "Sök i mallar...",
            "templates.editor_placeholder": "Skriv mallens innehåll...",
            "templates.editor_hint": "Skapa återanvändbart rich text-innehåll och koppla det till en kategori.",
            "templates.form.title": "Malldetaljer",
            "templates.form.subtitle": "Ge mallen en tydlig titel, kategori och rich text-innehåll.",
            "templates.insert.append": "Klistra in tillsammans med befintlig text",
            "templates.insert.replace": "Ersätt hela texten",
            "templates.insert.use": "Använd mall",
            "templates.hero.kicker": "Innehållsbibliotek",
            "templates.hero.subtitle": "Organisera återanvändbara textmallar i kategorier och infoga dem från rich text-redigerare.",
            "templates.filters.heading": "Sök och filter",
            "templates.filters.description": "Sök i mallar eller filtrera på kategori.",
            "templates.categories.title": "Kategorier",
            "templates.categories.all": "Alla mallar",
            "templates.categories.new": "Ny kategori",
            "templates.categories.edit": "Redigera kategori",
            "templates.categories.name": "Namn",
            "templates.categories.parent": "Överordnad kategori",
            "templates.categories.no_parent": "Ingen överordnad kategori",
            "templates.categories.description": "Beskrivning",
            "templates.categories.uncategorized": "Inte kategoriserad",
            "templates.section.kicker": "Mallar",
            "templates.section.title": "Alla mallar",
            "templates.section.subtitle": "Välj en kategori för att se mallarna som är kopplade till den.",
            "templates.section.category_title": "Mallar i kategorin",
            "templates.section.category_subtitle": "Mallar kopplade till vald kategori.",
            "company.settings.tabs.company": "Företag",
            "company.settings.tabs.employment_agreement": "Anställningsavtal",
            "company.employment_agreement.title": "Standard avtalstext",
            "company.employment_agreement.description": "Denna text läggs in som gemensam avtalstext i PDF:en för anställningsavtal.",
            "company.employment_agreement.placeholder": "Skriv standardtext för anställningsavtal...",
            "pagination.previous": "Föregående",
            "pagination.next": "Nästa",
            "pagination.showing": "Visar {{current}} av {{total}}",
            "pagination.loadMore": "Ladda mer",
            "payslips.kicker": "Tripletex lön",
            "payslips.title": "Lön",
            "payslips.mine_title": "Mina lönespecifikationer",
            "payslips.admin_title": "Lönespecifikationer",
            "payslips.stats_title": "Statistik",
            "payslips.description": "Se lönespecifikationer som gjorts tillgängliga från Tripletex utan att logga in i Tripletex.",
            "payslips.admin_description": "Hantera och filtrera lönespecifikationer för anställda. Kräver rollen Lön Admin (företagsadministratörer ser bara egna lönespecifikationer utan denna roll).",
            "payslips.stats_description": "Översikt över lönespecifikationer som ingår i summorna nedan (egna om du inte har Lön Admin).",
            "payslips.admin_forbidden": "Du behöver rollen Lön Admin för att hantera alla lönespecifikationer för företaget. Be en administratör tilldela Lön Admin för detta företag.",
            "payslips.role_view_override_warning":
              "Rollvy-simulering är aktiv — den ändrar bara menyer/UI. API:et använder fortfarande dina riktiga roller. Stäng av rollvy (DevOps-menyn) så att behörighet stämmer.",
            "payslips.loading": "Laddar lönespecifikationer...",
            "payslips.empty": "Inga lönespecifikationer är tillgängliga ännu.",
            "payslips.error": "Kunde inte hämta lönespecifikationer.",
            "payslips.period": "Period",
            "payslips.employee": "Anställd",
            "payslips.voucher_date": "Verifikationsdatum",
            "payslips.available_date": "Tillgänglig",
            "payslips.gross_amount": "Brutto",
            "payslips.amount": "Netto",
            "payslips.actions": "Åtgärder",
            "payslips.open": "Öppna",
            "payslips.opening": "Öppnar...",
            "payslips.sync_now": "Synkronisera nu",
            "payslips.syncing": "Synkroniserar...",
            "payslips.employee_filter": "Anställd",
            "payslips.stats_count": "Lönespecifikationer",
            "payslips.stats_gross": "Brutto totalt",
            "payslips.stats_net": "Netto totalt",
            "payslips.stats_average_net": "Snitt netto",
            "listbox.none": "Inte valt",
            "user_info.address": "Adress",
            "user_info.address_hint": "Sparas på användarprofilen och används som adressunderlag i anställningsflödet.",
            "user_employment.option_not_selected": "Inte valt",
            "user_employment.section_basic": "Anställningsunderlag",
            "user_employment.section_basic_hint": "Grunddata för anställningsförhållandet och anställningsavtalet.",
            "user_employment.employee_number": "Anställningsnummer",
            "user_employment.employment_starts": "Anställning startar",
            "user_employment.social_security": "Personnummer",
            "user_employment.working_posistion": "Befattning",
            "user_employment.workplace": "Arbetsplats",
            "user_employment.agreement_type": "Avtalstyp",
            "user_employment.agreement_type_permanent": "Fast",
            "user_employment.agreement_type_temporary": "Tillfällig",
            "user_employment.agreement_type_hourly": "Tim-/behovsanställd",
            "user_employment.agreement_type_seasonal": "Säsong",
            "user_employment.agreement_type_other": "Annat",
            "user_employment.section_worktime": "Arbetstid",
            "user_employment.section_worktime_hint": "Tidsintervall som kan användas i anställningsavtalet.",
            "user_employment.worktime_regular_from": "Ordinarie från",
            "user_employment.worktime_regular_too": "Ordinarie till",
            "user_employment.worktime_weekend_from": "Helg från",
            "user_employment.worktime_weekend_too": "Helg till",
            "user_employment.worktime_regular_range": "Ordinarie arbetstid",
            "user_employment.worktime_weekend_range": "Helgarbete",
            "user_employment.section_wages": "Lön och tillägg",
            "user_employment.section_wages_hint": "Avtalade lönevillkor. Lönetabellen nedan behålls för historik och tidsberäkningar.",
            "user_employment.wages": "Lön",
            "user_employment.wages_unit": "Lön per",
            "user_employment.wage_unit_hour": "Timme",
            "user_employment.wage_unit_month": "Månad",
            "user_employment.wage_unit_year": "År",
            "user_employment.wage_unit_fixed": "Fast avtalat",
            "user_employment.overtime_pay": "Övertidsersättning",
            "user_employment.dismissal": "Uppsägningstid",
            "user_employment.wage_other_addition": "Övriga tillägg",
            "user_employment.wage_weekend_and_night_addition": "Helg-/natttillägg",
            "user_employment.collective_agreement": "Kollektivavtal",
            "user_employment.section_contract_text": "Avtalstext",
            "user_employment.section_contract_text_hint": "Textfält som används som underlag för anställningsavtal och intern dokumentation.",
            "user_employment.employment_instructions": "Befattningsinstruktion",
            "user_employment.employment_allowance": "Ersättning",
            "user_employment.notes": "Anteckningar",
            "user_employment.other": "Annat",
            "user_employment.section_signature": "Signatur och betalning",
            "user_employment.section_signature_hint": "Signerings- och betalningsunderlag för anställningsavtalet.",
            "user_employment.signed_place": "Signeringsort",
            "user_employment.signed_at": "Signeringsdatum",
            "user_employment.account_number": "Kontonummer",
            "user_employment.hourly_costs_title": "Timpriser och kostnader",
            "user_employment.section_contract_actions": "Anställningsavtal",
            "user_employment.section_contract_actions_hint": "Utskrift och signering använder avtalsunderlaget när PDF/signering finns tillgängligt.",
            "user_employment.contract_actions_notice_title": "Redo för nästa fas",
            "user_employment.contract_actions_notice": "Dataunderlaget kan nu fyllas i. Utskrift av anställningsavtal och Posten-signering kopplas på i separat implementation.",
            "user_employment.print_contract": "Skriv ut anställningsavtal",
            "user_employment.print_contract_unavailable": "PDF-rutt för anställningsavtal är inte ansluten ännu.",
            "user_employment.send_to_signing": "Skicka för signering",
            "user_employment.signing_unavailable": "Posten-signering implementeras av separat agent.",
            "user_employment.contract_title": "Anställningsavtal",
            "user_employment.contract_description": "Anställningsavtal för digital signering",
            "user_employment.preview_contract_draft": "Förhandsvisa utkast till anställningsavtal",
            "user_employment.download_contract_draft_pdf": "Ladda ner PDF-utkast",
            "user_employment.draft_pdf_download_failed": "Kunde inte ladda ner PDF-utkast.",
            "user_employment.contract_draft_label": "Utkast",
            "user_employment.contract_draft_for": "För {{name}}",
            "user_employment.draft_notice_title": "Kontrollera före signering",
            "user_employment.draft_notice": "Detta är en förhandsvisning baserad på sparade och ifyllda fält i formuläret. Spara ändringar innan du skickar för signering.",
            "user_employment.employee_name": "Arbetstagare",
            "signing.title": "Digital signering",
            "signing.description": "Skicka dokumentet till Posten Signering och följ signeringsstatus.",
            "signing.new_request": "Ny signeringsförfrågan",
            "signing.empty": "Inga signeringsförfrågningar har skapats ännu.",
            "signing.sender_reference": "Referens",
            "signing.signer_name": "Signerarnamn",
            "signing.national_identity_number": "Personnummer / D-nummer",
            "signing.email": "E-post",
            "signing.mobile": "Mobil",
            "signing.identity_warning": "Använd personnummer/D-nummer när det finns. E-post/SMS-signering är giltig, men Promang måste då verifiera att rätt person signerade.",
            "signing.send": "Skicka för signering",
            "signing.created": "Signeringsförfrågan skapad",
            "signing.refreshed": "Signeringsstatus uppdaterad",
            "signing.refresh_status": "Uppdatera status",
            "signing.download_signed": "Ladda ner signerad PDF",
            "signing.errors.load_failed": "Kunde inte hämta signeringsförfrågningar.",
            "signing.errors.create_failed": "Kunde inte skapa signeringsförfrågan.",
            "signing.errors.poll_failed": "Kunde inte uppdatera signeringsstatus.",
            "signing.errors.download_failed": "Kunde inte ladda ner signerat dokument.",
            "signing.status.draft": "Utkast",
            "signing.status.queued": "I kö",
            "signing.status.sent": "Skickad",
            "signing.status.in_progress": "Pågår",
            "signing.status.completed": "Slutförd",
            "signing.status.failed": "Misslyckades",
            "signing.status.rejected": "Avvisad",
            "signing.status.expired": "Utgången",
            "signing.status.cancelled": "Avbruten",
            "signing.status.waiting": "Väntar",
            "signing.status.available": "Tillgänglig",
            "signing.status.signed": "Signerad",
            "webpage.editor.open_live": "Visa live",
            "webpage.editor.open_live_title": "Öppna sidan i webbutiken (ny flik)",
            "webpage.editor.open_live_title_unpublished":
              "Öppna webbutiks-URL:en. Publicera sidan så att kunder kan se innehållet.",
            "webpage.editor.import_blocks": "JSON / AI",
            "webpage.editor.import_tooltip": "Klistra in JSON-block eller kopiera AI-instruktion",
            "webpage.editor.import_dialog_title": "Importera block eller AI-guide",
            "webpage.editor.import_tab_paste": "Klistra in JSON",
            "webpage.editor.import_tab_guide": "AI-instruktion (kopiera)",
            "webpage.editor.import_hint":
              "JSON som { \"blocks\": [ ... ] }, rå array eller content.blocks. ```json ... ``` fungerar.",
            "webpage.editor.import_replace": "Ersätt alla block",
            "webpage.editor.import_append": "Lägg till längst ner",
            "webpage.editor.import_sample": "Infoga exempel",
            "webpage.editor.import_apply": "Bygg block",
            "webpage.editor.import_success": "Importerade {{count}} block. Glöm inte att spara sidan.",
            "webpage.editor.import_error_empty": "Ingen text att läsa.",
            "webpage.editor.import_error_invalid_json": "Ogiltig JSON.",
            "webpage.editor.import_error_no_blocks_array": "Förväntade blocks-array, rå array eller content.blocks.",
            "webpage.editor.import_error_no_valid_blocks": "Inga giltiga block (type måste vara text, image, header, section, button eller columns).",
            "webpage.editor.import_error_unknown": "Import misslyckades.",
            "webpage.editor.ai_guide_intro":
              "Kopiera texten nedan till din AI som systemprompt. Modellen ska svara med ren JSON utan markdown.",
            "webpage.editor.copy_ai_guide": "Kopiera AI-instruktion",
            "webpage.editor.ai_guide_copied": "Instruktion kopierad till urklipp",
            "webpage.editor.ai_guide_copy_failed": "Kunde inte kopiera (webbläsarrättigheter)",
            "webpage.editor.generate_with_ai": "Generera med ChatGPT",
            "webpage.editor.ai_apply_success": "AI lade till {{count}} block i editorn. Glöm inte att spara sidan.",
            "webpage.editor.ai_parse_error": "AI returnerade inte giltig sida-JSON. Försök igen eller klistra in JSON under fliken Klistra in JSON.",
            "histories.title": "Historik",
            "histories.subtitle": "Aktivitet och ändringar",
            "histories.last_updated": "Senast uppdaterad",
            "histories.last_edited": "Senast redigerad",
            "histories.by_prefix": "av",
            "histories.no_data": "Ingen data ännu",
            "histories.filter_action": "Filtrera på åtgärd",
            "histories.filter_all": "Alla",
            "histories.empty_filter": "Inga händelser för detta filter.",
            "histories.load_more": "Ladda mer",
            "histories.loading_more": "Laddar …",
            "histories.close": "Stäng",
            "histories.system_user": "Systemet",
            "histories.unknown_user": "Okänd",
            "histories.sync_changes_heading": "Synkmetadata",
            "histories.action.tripletex_sync_attempt": "försökte Tripletex-synk för",
            "histories.action.tripletex_sync": "slutförde Tripletex-synk för",
            "histories.action.tripletex_sync_skipped": "skippade Tripletex-synk för",
            "histories.deviation_scope.deviation": "Avvikelse · tidslinje",
            "histories.deviation_scope.project": "Projekt · tidslinje",
            "histories.deviation_scope.customer": "Kund · tidslinje",
            "deviation.work_order.link_dialog_title": "Koppla arbetsorder",
            "deviation.work_order.section_title": "Kopplad arbetsorder",
            "deviation.work_order.link_submit": "Spara",
            "deviation.work_order.link_open": "Koppla arbetsorder",
            "deviation.work_order.open_linked": "Öppna arbetsorder",
            "deviation.work_order.unlink": "Ta bort koppling",
            "deviation.work_order.change": "Byt",
            "deviation.work_order.mode_existing": "Välj befintlig",
            "deviation.work_order.mode_create": "Skapa ny",
            "deviation.work_order.existing_intro":
              "Endast arbetsorder utan annat kopplat avvik visas. Den arbetsorder som redan är kopplad till detta avvik kan väljas eller tas bort.",
            "deviation.work_order.create_intro":
              "Skapa en ny arbetsorder — den kopplas till detta avvik när du sparar.",
            "deviation.work_order.create_button": "Skapa arbetsorder",
            "deviation.work_order.linked_after_create":
              "Arbetsorder skapad och kopplad till avvikelsen",
            "deviation.work_order.link_failed_after_create":
              "Arbetsorder skapades men kunde inte kopplas till avvikelsen. Öppna avvikelsen och koppla arbetsordern manuellt.",
            "deviation.work_order.suggested_wo_title_full":
              "Avvikelse {{number}} · {{title}}",
            "deviation.work_order.suggested_wo_title_number_only":
              "Avvikelse {{number}}",
            "deviation.work_order.toast_saved": "Arbetsorder uppdaterad",
            "deviation.form.work_order_heading": "Arbetsorder från avvikelse",
            "deviation.form.work_order_mode_none": "Inte kopplad",
            "deviation.form.work_order_mode_existing": "Välj befintlig",
            "deviation.form.work_order_mode_create": "Skapa ny",
            "deviation.form.work_order_create_timing_intro": "Hur ska uppdraget starta?",
            "deviation.form.work_order_perform_now": "Arbete görs nu",
            "deviation.form.work_order_plan_later": "Arbete ska planeras",
            "deviation.form.work_order_perform_now_help":
              "Arbetsorder skapas från avvikelsens rubrik och beskrivning, kopplas till avvikelsen, och ett kalender-/uppdragsevenemang skapas för vald utförare – nu, i 2 timmar.",
            "deviation.form.work_order_plan_later_help":
              "Avvikelsen sparas. Du fortsätter för att skapa arbetsorder; den kopplas till avvikelsen när du sparar den nya ordern.",
            "deviation.form.executor_label": "Utföraren av uppdraget",
            "deviation.form.executor_pick": "Välj utförare",
            "deviation.form.executor_hint": "Händelsen knyts till den här användaren.",
            "deviation.form.executor_dialog_help":
              "Personen som ska stå för uppdraget när arbete görs nu.",
            "deviation.form.need_project_customer_for_work_order":
              "Välj projekt och kund för avvikelsen innan du skapar eller skjuter upp arbetsorder här.",
            "deviation.form.work_order_create_failed": "Kunde inte skapa arbetsorder.",
            "deviation.form.event_creation_failed":
              "Arbetsorden skapades men händelsen kunde inte skapas automatiskt — lägg till den manuellt på arbetsordern.",
            "deviation.form.work_order_and_event_saved":
              "Arbetsorder och händelse skapades och kopplades till avvikelsen.",
            "deviation.form.saved": "Sparat",
            "deviation.form.save_failed": "Något gick fel vid sparning.",
            "deviation.form.default_wo_title": "Avvikelse – arbetsorder",
            "deviations.list.notified_none": "Inga utskick gjorda",
            "deviations.list.notified_compact_suffix": " (+{{count}})",
      
            "Dashboard": "Dashboard",
            "Overview of your workspace": "Översikt över ditt arbetsområde",
            "Collapse": "Dölj",
            "Expand": "Visa",
            "case": "Ärende",
            "Resource Hub": "Resurscenter",
            "resource_hub.faq.linked_records_title": "Länkade resurser",
            "resource_hub.faq.linked_records_help":
              "Koppla inlägget till andra poster (HMS/KS-dokument, fordon, produkt, rapport, kund, projekt). Välj typ och sök fram posten — du behöver inte skriva in numeriskt ID. För HMS/KS: skriv minst två tecken i sökfältet.",
            "resource_hub.faq.linked_records_add": "Lägg till länk",
            "resource_hub.faq.linked_records_type": "Resurstyp",
            "resource_hub.faq.linked_records_id": "ID",
            "resource_hub.faq.linked_records_pick": "Sök och välj …",
            "resource_hub.faq.linked_records_existing": "Titel (sparad)",
            "resource_hub.faq.link_type.hse_document": "HMS / KS-dokument",
            "resource_hub.faq.link_type.vehicle": "Fordon",
            "resource_hub.faq.link_type.product": "Produkt",
            "resource_hub.faq.link_type.report": "Rapport",
            "resource_hub.faq.link_type.customer": "Kund",
            "resource_hub.faq.link_type.project": "Projekt",
            "resource_hub.faq.linked_records_placeholder_type": "Välj typ",
            "service.agreements.list.hero_kicker": "Service",
            "service.agreements.list.subtitle":
              "Sök, filtrera på vy och hantera återkommande serviceavtal.",
            "service.agreements.list.meta.total": "Avtal",
            "service.agreements.list.meta.new": "Nya",
            "service.agreements.list.new": "Nytt avtal",
            "service.agreements.list.filters_heading": "Filter",
            "service.agreements.list.filters_description":
              "Förfina listan med sök och fördefinierade vyer.",
            "service.agreements.list.search_placeholder": "Sök avtal …",
            "service.agreements.list.sort_label": "Sortering",
            "service.agreements.list.per_page": "Per sida",
            "service.agreements.list.table_kicker": "Lista",
            "service.agreements.list.table_title": "Avtal",
            "service.agreements.list.table_description":
              "Markera rader för massåtgärder i verktygsfältet ovan.",
            "service.agreements.filter.view": "Vy",
            "service.agreements.view.service_soon": "Service snart (5 dagar)",
            "service.agreements.view.active": "Aktiva",
            "service.agreements.sort.next_service_asc":
              "Nästa service — tidigast först",
            "service.agreements.sort.next_service_desc":
              "Nästa service — senast först",
            "service.agreements.sort.created_desc": "Skapad — nyast först",
            "service.agreements.sort.created_asc": "Skapad — äldst först",
            "service.agreements.table.col_title": "Titel",
            "service.agreements.table.col_type": "Typ",
            "service.agreements.table.col_project": "Projekt",
            "service.agreements.table.col_customer": "Kund",
            "service.agreements.table.col_delivery": "Leveransadress",
            "service.agreements.table.col_next": "Nästa service",
            "service.agreements.table.col_interval": "Intervall",
            "service.agreements.table.col_status": "Status",
            "service.agreements.table.col_days": "Dagar till service",
            "service.agreements.table.missing_address": "Ingen leveransadress",
            "service.agreements.table.col_next_job": "Nästa uppdrag",
            "service.agreements.next_job.section_title": "Nästa uppdrag",
            "service.agreements.next_job.next_on": "Nästa uppdrag ska utföras",
            "service.agreements.next_job.days_until":
              "Det är {{count}} dagar till nästa uppdrag.",
            "service.agreements.next_job.in_progress": "Uppdrag pågår",
            "service.agreements.actions.missing_type":
              "Typ saknas; avtalet kan inte utföras",
            "service.agreements.actions.create_report": "Skapa ny rapport",
            "service.agreements.actions.create_order": "Skapa order",
            "service.agreements.actions.go_to_report": "Öppna rapport",
            "service.agreements.actions.hint_create_report":
              "En ny rapport skapas. När uppdraget är klart sätts nästa servicedatum utifrån slutförandedatum.",
            "service.agreements.actions.hint_create_order":
              "En ny order skapas och nästa servicedatum sätts automatiskt.",
            "service.agreements.actions.prompt_report_title": "Skapa ny rapport",
            "service.agreements.actions.prompt_report_body":
              "Vill du skapa en ny rapport för detta serviceavtal?",
            "service.agreements.actions.prompt_order_title": "Skapa ny order",
            "service.agreements.actions.prompt_order_body":
              "Vill du skapa en ny order för detta serviceavtal?",
            "service.agreements.actions.err_no_agreement":
              "Kan inte skapa utan serviceavtal",
            "service.agreements.actions.err_active_report_report":
              "Kan inte skapa rapport medan en rapport redan är aktiv",
            "service.agreements.actions.err_active_report_order":
              "Kan inte skapa order medan en rapport redan är aktiv",
            "service.agreements.actions.err_no_customer_report":
              "Kan inte skapa rapport utan kund",
            "service.agreements.actions.err_no_customer_order":
              "Kan inte skapa order utan kund",
            "service.report.order_dialog.title_create": "Skapa order från rapport",
            "service.report.order_dialog.title_additional": "Skapa ytterligare order",
            "service.report.product_line_dialog.title": "Produktrad",
            "service.report.product_line_dialog.delete_line": "Ta bort rad",
            "service.report.product_line_dialog.delete_tooltip": "Ta bort rad",
            "service.report.product_line_dialog.delete_confirm_title":
              "Ta bort denna rad permanent?",
            "service.report.product_line_dialog.delete_confirm_hint":
              "Detta kan inte ångras.",
            "service.report.product_line_dialog.delete_cancel": "Avbryt",
            "service.report.product_line_dialog.delete_confirm": "Ta bort",
            "service.report.product_line_dialog.delete_working": "Tar bort…",
            "service.report.product_line_dialog.back_tooltip": "Tillbaka till produktrad",
            "service.report.order_dialog.dialog_eyebrow": "Order",
            "service.report.order_dialog.section_invoice": "Kund och faktura",
            "service.report.order_dialog.section_km": "Milersättning",
            "service.report.order_dialog.section_price_lines": "Avtalade prisrader",
            "service.report.order_dialog.section_order_group": "Ordergruppering",
            "service.report.order_dialog.price_lines_intro":
              "Följande prisrader läggs automatiskt till i ordern:",
            "service.report.order_dialog.price_lines_included_hours": "Inkluderade timmar:",
            "service.report.order_dialog.price_lines_footer_note":
              "Dessa prisrader omfattar {{hours}} h som faktureras via prisraderna, inte separat.",
            "service.report.order_dialog.generate_invoice": "Generera med ChatGPT",
            "service.report.order_dialog.generating_invoice": "Genererar…",
            "service.report.order_dialog.orders_heading": "Ordrar på denna rapport",
            "service.report.order_dialog.open_order": "Öppna order {{number}}",
            "service.report.order_dialog.create": "Skapa order",
            "service.report.order_dialog.create_another": "Skapa ny order",
            "service.report.order_dialog.follow_up_notice_title": "Tilläggsorder",
            "service.report.order_dialog.follow_up_notice_body":
              "Överenskomna prisrader lades på första ordern från rapporten och läggs inte in automatiskt på nya ordrar. Du kan fakturera nya timmar, körning och orderrader som inte redan är fakturerade.",
            "service.report.order_dialog.hours_rounding_label": "Avrundning av fakturerade timmar",
            "service.report.order_dialog.hours_rounding_actual":
              "Faktisk registrerad tid (ingen avrundning)",
            "service.report.order_dialog.hours_rounding_ceil_half":
              "Avrunda uppåt till närmaste halvtimme (0,5 h)",
            "service.report.order_dialog.hours_rounding_nearest_half": "Avrunda till närmaste halvtimme",
            "service.report.order_dialog.hours_rounding_ceil_hour": "Avrunda uppåt till hela timmar",
            "service.report.order_dialog.hours_rounding_nearest_hour": "Avrunda till närmaste hela timme",
            "service.report.order_dialog.hours_rounding_hint":
              "Standard är faktisk tid. Välj avrundning endast när faktureringsregler kräver det (uppåt halvtimme motsvarar gamla kryssrutan).",
            "service.report.order_dialog.hour_lines_label": "Orderrader för timmar",
            "service.report.order_dialog.hour_lines_each":
              "En rad per tidregistrering (rekommenderas för översikt)",
            "service.report.order_dialog.hour_lines_grouped":
              "Slå ihop per aktivitet (en rad per aktivitet)",
            "service.report.order_dialog.hour_lines_hint":
              "Fler registreringar på samma aktivitet blir en rad vid ihopslagning. Fast aktivitetsavgift (budget_fee) förblir en rad per aktivitet.",
            "service.report.order_dialog.section_order_lines": "Orderrader (varuförbrukning)",
            "service.report.order_dialog.section_order_lines_subtitle":
              "{{selected}} av {{total}} rader med förbrukning",
            "service.report.order_dialog.section_hours_subtitle":
              "{{selected}} av {{total}} h",
            "service.report.order_dialog.section_hours_subtitle_manual":
              "Manuella timmar eller välj registreringar nedan",
            "service.report.order_dialog.toggle_order_lines_aria": "Fakturera orderrader",
            "service.report.order_dialog.toggle_hours_aria": "Fakturera timmar",
            "service.report.order_dialog.invoice_order_lines_switch":
              "Fakturera orderrader ({{selected}} av {{total}} med förbrukning valda)",
            "service.report.order_dialog.pick_order_lines":
              "Välj orderrader att fakturera (endast produkter med förbrukning):",
            "service.report.order_dialog.no_consumption_lines":
              "Inga orderrader med förbrukning registrerade",
            "service.report.order_dialog.add_tilleggsarbeider_group_label":
              "Egen orderradgrupp «Tilleggsarbeider»",
            "service.report.order_dialog.add_tilleggsarbeider_group_hint":
              "Stäng av för att lägga timmar och tillhörande rader i huvudgruppen (samma som fakturatitel/text). Användbart när du bara vill ha produktrader utan extra grupp.",
            "service.report.order_dialog.section_hours": "Timmar (tilläggsarbete)",
            "service.report.order_dialog.invoice_hours_switch":
              "Fakturera timmar ({{selected}} av {{total}} h valda)",
            "service.report.order_dialog.invoice_hours_switch_manual":
              "Fakturera timmar (manuellt eller från lista)",
            "service.report.order_dialog.hours_manual_notice_title": "Inga fakturerbara tidregistreringar",
            "service.report.order_dialog.hours_manual_notice_body":
              "All tid kan ligga i avtalade prisrader, eller inga timmar är registrerade. Låt fakturering vara på och fyll i manuellt antal timmar nedan för att lägga standard timprodukt på ordern.",
            "service.report.order_dialog.pick_billable_hours":
              "Välj timmar att fakturera (endast tilläggsarbete):",
            "service.report.order_dialog.hours_settings_heading": "Tidsinställningar",
            "service.report.order_dialog.manual_hours_label":
              "Manuellt antal timmar (åsidosätter valda timmar om ifyllt)",
            "service.report.order_dialog.manual_hours_placeholder":
              "Krävs vid enbart manuell fakturering — annars valfritt",
            "service.report.order_dialog.hours_discount_label": "Rabatt (%)",
            "service.report.order_dialog.hours_preview_heading": "Förhandsvisning",
            "service.report.order_dialog.hours_preview_quantity": "Antal timmar: {{hours}}",
            "service.report.order_dialog.hours_preview_discount": "Rabatt: {{pct}}%",
            "Close": "Stäng",
            "Notes": "Noteringar",
            "Stripe Session": "Stripe Session",
            "Payment Status": "Betalningsstatus",
            "Payment Method": "Betalningsmetod",
            "Order Lines": "Orderlinjer",
            "Comment": "Kommentar",
            "Our Employee Contact": "Vår Anställd Kontakt",
            "Department": "Avdelning",
            "Active": "Aktiv",
            "Employee": "Anställd",
            "Customer Contact": "Kund Kontakt",
            "Contact": "Kontakt",
            "Not chosen": "Inte vald",
            "Address": "Address",
            "None": "Saknas",
            "New": "Ny",
            "Order Confirmation Sent": "Orderbekräftelse skickad",
            "Ready to be picked": "Klar att plockas",
            "Picked": "Plockad",
            "Packed": "Packad",
            "Ready to be shipped": "Klar att skickas",
            "Ready to be invoiced": "Klar att faktureras",
            "Invoiced": "Fakturerad",
            "Cancelled": "Avbruten",
            "Accomplished": "Slutförd",
            "Ongoing": "Pågående",
            "number.from": "Från",
            "number.to": "Till",
            "updated": "Uppdaterat",
            "item_number": "Artikkelnummer",
            "title": "Titel",
            "short_description": "Kort beskrivning",
            "purchase_price": "Inköpspris",
            "sales_price": "Försäljningspris",
        "product.add": "Lägg till produkt",
        "product.update": "Updatera produkt",
        "product.model_year": "Modellår",
        "product.replaced_by_product": "Ersatt av produkt",
        "product.replaced_by.banner_title": "Den här produkten har ersatts",
        "product.replaced_by.banner_description":
          "Använd ersättningsprodukten för aktuell information, pris och lager.",
        "product.replaced_by.open_replacement": "Öppna ersättningsprodukt",
        "product.selector.open_product": "Öppna produkt",
        "product.selector.replaced_label": "Ersatt",
        "product.selector.search_placeholder": "Sök produkter …",
        "product.selector.empty_flat_list":
          "Sök eller bläddra i listan. Använd tratten för att filtrera aktiva, utgångna eller lager.",
        "customer.system.product_search_placeholder":
          "Sök anläggningar (produkter med reservdelar) …",
        "product.selector.filter_system_products": "System (produkter med reservdelar)",
        "product.selector.toggle_filters": "Visa filter",
            "image.change": "Byt bild",
            "Welcome to Promang": "Welcome to React and react-i18next",
            "Sign in to your account": "Logga inn",
            "product.brands": "Märke",
            "product.brand": "Produkt Merke",
            "Spare parts": "Reservdelar",
            "Categories": "Kategorier",
            "Accessories": "Tilbehör",
            "Unit": "Enhet",
            "customer.type": "Kundtyp",
            "customer.name.required": "Kundnamn krävs",
            "Contact information": "Kontaktinformation",
            "company.outbound_mail.title": "Utgående e-post (Microsoft)",
            "company.outbound_mail.description": "Välj vilken delad företagsinkorg Promang ska skicka från (Microsoft 365). Tomt eller utan Microsoft: använd Promangs standardavsändare.",
            "company.outbound_mail.mailbox_label": "Skicka systemmejl från delad inkorg",
            "company.outbound_mail.promang_default": "Promang standard (inte Microsoft)",
            "company.outbound_mail.case_email_hint": "Ärende-e-post till medarbetare skickas från användarens eget Microsoft-konto när det är kopplat under användarinställningar — inte från denna delade inkorg.",
            "company.userRoles.helpLabel.scope": "Inkluderar:",
            "company.userRoles.helpLabel.admin": "Administratörer bör tänka på:",
            "company.userRoles.sections.actions": "Åtgärder",
            "company.userRoles.sections.submodules": "Undermoduler",
            "company.userRoles.accessIntro":
              "Hjälptexten under varje roll beskriver åtkomsten och vad du bör överväga innan du tilldelar rättigheter.",
            "company.users.page_title": "Användare",
            "company.users.subtitle_selected": "{{count}} valda",
            "company.users.hero.kicker": "Företag",
            "company.users.hero.title": "Användare och åtkomst",
            "company.users.hero.subtitle":
              "Hantera personer, roller, inbjudningar och filter på ett ställe — i linje med dashboardöversikten.",
            "company.users.stats.total": "Totalt",
            "company.users.stats.on_page": "På den här sidan",
            "company.users.stats.selected": "Valda",
            "company.users.section.kicker": "Katalog",
            "company.users.section.title": "Användarlista",
            "company.users.section.subtitle":
              "Sök, förfina med filter och öppna en profil för att redigera detaljer.",
            "company.users.section.meta_line": "{{total}} användare · sida {{page}}",
            "company.users.search_placeholder": "Sök användare…",
            "company.users.filters_heading": "Filter",
            "company.users.filters_description":
              "Sök och avgränsa listan med alternativen nedan.",
            "company.users.filter_title": "Filtrera användare",
            "company.users.filter.active": "Aktiva användare",
            "company.users.filter.employee": "Medarbetare",
            "company.users.filter.show_in_dropdown": "Visa i listruta",
            "company.users.new_user": "Ny användare",
            "company.users.calendar": "Kalender",
            "company.users.loading": "Laddar användare…",
            "company.users.table.status_inactive": "Inaktiv",
            "company.users.table.status_pending": "Väntar",
            "company.users.table.status_active": "Aktiv",
            "company.users.table.empty_title": "Inga användare hittades",
            "company.users.table.empty_hint":
              "Prova att justera sökning eller filter för att se fler träffar.",
            "company.users.table.row_kicker": "Användare",
            "company.users.table.unnamed": "Namnlös",
            "company.users.table.calendar": "Kalender",
            "company.users.profile.read_only_title": "Användarinformation är skrivskyddad",
            "company.users.profile.read_only_multi_company":
              "Den här användaren är kopplad till flera företag. Profilen (namn, foto, kontaktuppgifter m.m.) kan bara redigeras från dennes primära företag för att undvika motstridiga ändringar. Byt till det företaget i arbetsytan, eller ange rätt primärföretag för användaren.",
            "company.users.table.edit": "Redigera",
            "company.users.table.settings": "Profil",
            "company.users.table.view": "Öppna",
            "company.users.table.selected_of_total":
              "{{selected}} av {{total}} valda",
            "company.users.table.user_count": "{{count}} användare",
            "company.users.table.n_selected": "{{count}} valda",
            "company.users.invitation.expired":
              "Den här användaren har en utgången inbjudningslänk.",
            "company.users.invitation.resend_button": "Skicka inbjudan igen",
            "company.users.invitation.resending": "Skickar inbjudan...",
            "company.users.invitation.resend_success":
              "Inbjudan skickades igen.",
            "company.users.invitation.resend_error":
              "Kunde inte skicka inbjudan igen.",
            "driving": "Körning (hela flottan)",
            "driving_trips": "Resor och incheckat fordon",
            "driving_drivers": "Förare",
            "driving_vehicles": "Fordon (körmodul)",
            "vehicles": "Fordon",
            "Postal Address": "Postadress",
            "Physical Address": "Besöksadress",
            "Edit": "Redigera",
            "Back": "Tillbaka",
            "Customer Number": "Kundnummer",
            "Name": "Namn",
            "Email": "E-post",
            "pmField.email.invalid": "Ange en giltig e-postadress.",
            "pmField.email.sameAsName": "E-post och namn får inte vara lika. Använd namnfältet för namn och e-postfältet för e-post.",
            "pmField.email.nameLooksLikeEmail": "Det här ser ut som en e-postadress. Använd e-postfältet för e-post.",
            "Mobile": "Mobil",
            "Org. Nummer": "Org. Nummer",
            "Address 2": "Adress 2",
            "Postal": "Postnummer",
            "Place": "Plats",
            "Yes": "Ja",
            "No": "Nej",
            "Copied to clipboard": "Kopierat till urklipp",
            "Failed to copy": "Kunde inte kopiera",
            "Copy to clipboard": "Kopiera till urklipp",
            "Warehouse Status Type": "Lagerstatus Typ",
            "Account Code": "MVA Kod",
            "Product Type": "Produkt Typ",
            "Status": "Status",
            "Product Settings": "Produkt Innställningar",
            "Product Main Image": "Produktens Huvudbild",
            "Product Description": "Produkt Beskrivning",
            "Shipping": "Frakt",
            "active": "Aktiv",
            "Spare Part": "Reservdel",
            "Warehouse": "På lager",
            "Online Store": "Nätbutik",
            "Sales Price": "Försäljningspris",
            "Purchase Price": "Inköpspris",
            "Short Description": "Kort Beskrivning",
            "Title": "Titel",
            "Item Number": "Artikelnummer",
            "Product Information": "Produktinformation",
            "order_date": "Order Datum",
            "order_number": "Order Nummer",
            "Customer": "Kund",
            "Our Contact": "Vår kontakt",
            "Description": "Beskrivning",
            "Select a": "Välj en",
            "Reference": "Referens",
            "Delivery Information": "Leverans information",
            "Delivery Date": "Leverans Datum",
            "Delivery Address": "Leverans Adress",
            "missing_system": "System fattas",
            "missing_report": "Rapport fattas",
            "missing_customer": "Kund fattas",
            "missing_order": "Order fattas",
            "missing_order_lines": "Orderlinjer fattas",
            "missing_hours": "Timmar fattas",
            "RESPONSIBLE": "Ansvarig",
            "EXECUTOR": "Utförare",
            "OBSERVER": "Observatör",
            "note": "Anteckning",
            "work_order": "Arbetsorder",
            "Work Orders": "Arbetsorder",
            "Work Order List": "Arbetsorder - Lista",
            "New Work Order": "Ny Arbetsorder",
            "Search work orders...": "Sök i arbetsorder...",
            "Filter Work Orders by Status": "Filtrera arbetsorder efter status",
            "Finished": "Färdig",
            "Order Date": "Beställningsdatum",
            "Due Date": "Förfallodatum",
            "Event Period": "Händelseperiod",
            "Responsible": "Ansvarig",
            "Executor": "Utförare",
            "Work Order #": "Arbetsorder #",
            "work_orders.pagination_summary":
              "Sida {{page}} av {{totalPages}} ({{total}} totalt)",
            "work_orders.delete_confirm":
              "Detta raderar arbetsordern permanent. Timmar som är kopplade till den kopplas loss. Detta kan inte ångras.",
            "work_orders.delete_success": "Arbetsorder raderad",
            "work_orders.delete_failed": "Kunde inte radera arbetsordern",
            "work_orders.back_to_view": "Tillbaka till visning",
            "work_orders.calendar_filter": "Arbetsorder",
            "work_orders.project_activity.section_title": "Projektaktivitet",
            "work_orders.project_activity.help":
              "Koppla en projektaktivitet som inte redan är knuten någon annanstans, eller skapa en ny på detta projekt. När du sparar arbetsordern kopplas aktiviteten till denna order.",
            "work_orders.project_activity.new_title_label": "Titel för ny aktivitet",
            "work_orders.project_activity.copy_from_title": "Kopiera från titel",
            "work_orders.project_activity.new_title_placeholder":
              "t.ex. Installation fas 2",
            "work_orders.project_activity.create_button": "Skapa och välj",
            "work_orders.project_activity.creating": "Skapar…",
            "work_orders.project_activity.created_toast": "Projektaktivitet skapad",
            "work_orders.project_activity.create_error":
              "Kunde inte skapa projektaktivitet",
            "work_orders.project_activity.linked_label": "Projektaktivitet",
            "work_orders.billing_ready.action": "Klar för fakturering",
            "work_orders.billing_ready.eyebrow": "Fakturaunderlag",
            "work_orders.billing_ready.title": "Förbered fakturainformation",
            "work_orders.billing_ready.title_edit": "Uppdatera fakturaunderlag",
            "work_orders.billing_ready.intro":
              "Spara fakturatext och vad som ska faktureras (timmar och förbruk). Du kan bara markera arbetsordern klar för fakturering, eller skapa en debiteringsorder direkt för att gå vidare till fakturering.",
            "work_orders.billing_ready.section_invoice": "Fakturautkast",
            "work_orders.billing_ready.section_hours": "Timmar för fakturering",
            "work_orders.billing_ready.section_hours_subtitle":
              "Valt {{selected}} h av {{total}} h",
            "work_orders.billing_ready.section_items": "Orderrader (förbrukning)",
            "work_orders.billing_ready.section_items_subtitle":
              "{{selected}} av {{total}} rader valda",
            "work_orders.billing_ready.section_group": "Ordgruppering (senare)",
            "work_orders.billing_ready.add_tilleggsarbeider_hint":
              "När order senare skapas från arbetsordern kan timmar och material samlas i en egen grupp på debiteringsordern.",
            "work_orders.billing_ready.toggle_hours_aria": "Inkludera timmar i underlaget",
            "work_orders.billing_ready.toggle_items_aria": "Inkludera orderrader i underlaget",
            "work_orders.billing_ready.no_billable_hours": "Inga timmar är kopplade till arbetsordern.",
            "work_orders.billing_ready.no_usage_items": "Inga förbrukningsrader med använt antal.",
            "work_orders.billing_ready.submit": "Spara och markera klar för fakturering",
            "work_orders.billing_ready.success": "Markerad klar för fakturering och påminnelse skickad till utförare",
            "work_orders.billing_ready.failed": "Kunde inte spara fakturaunderlag",
            "work_orders.billing_ready.submit_create_order": "Skapa debiteringsorder",
            "work_orders.billing_ready.success_order": "Debiteringsorder skapad",
            "work_orders.billing_ready.failed_order": "Kunde inte skapa debiteringsorder",
            "work_orders.billing_ready.open_order": "Öppna debiteringsorder",
            "work_orders.billing_ready.sales_income_in_project_notice_title":
              "Inte fakturerbar som egen försäljningsorder",
            "work_orders.billing_ready.sales_income_in_project_notice":
              "Arbetsordern är markerad med att försäljningsintäkt ingår i projektet. Använd projektfakturering; markering som klar för fakturering och att skapa försäljningsorder från arbetsordern är inte tillgängligt.",
            "work_orders.bulk_create.toolbar": "{{count}} markerade",
            "work_orders.bulk_create.open": "Skapa debiteringsordrar…",
            "work_orders.bulk_create.clear": "Rensa markering",
            "work_orders.bulk_create.title": "Skapa debiteringsordrar från arbetsordrar",
            "work_orders.bulk_create.summary": "Du är på väg att skapa en eller flera debiteringsordrar från {{count}} arbetsorder(r).",
            "work_orders.bulk_create.hint":
              "Standardregler gäller: alla timmar och förbrukningsrader som kan faktureras tas med per arbetsorder. För full kontroll (avrundning, manuella timmar, radval), använd fakturadialogen på varje arbetsorder.",
            "work_orders.bulk_create.strategy_label": "Hur ska ordrarna grupperas?",
            "work_orders.bulk_create.strategy_per_wo": "En debiteringsorder per arbetsorder",
            "work_orders.bulk_create.strategy_customer": "Slå ihop per kund (en order per kund)",
            "work_orders.bulk_create.strategy_project": "Slå ihop per projekt (en order per projekt)",
            "work_orders.bulk_create.submit": "Skapa ordrar",
            "work_orders.bulk_create.success": "Skapade {{count}} debiteringsorder(r)",
            "work_orders.bulk_create.failed": "Kunde inte skapa debiteringsordrar",
            "work_orders.bulk_create.select_row": "Markera arbetsorder för massfakturering",
            "work_orders.bulk_create.select_page": "Markera alla arbetsordrar på sidan som kan faktureras",
            "work_orders.checklist.enable_switch": "Använd checklista för denna arbetsorder",
            "work_orders.checklist.section_title": "Checklista",
            "work_orders.checklist.save_to_enable_title": "Spara arbetsordern",
            "work_orders.checklist.save_to_enable_body":
              "Spara dina ändringar för att aktivera checklistan och skapa eller redigera rader.",
            "work_orders.checklist.missing_title": "Ingen checklista ännu",
            "work_orders.checklist.missing_body": "Skapa en checklista genom att välja mall eller börja tom.",
            "work_orders.checklist.choose": "Välj checklista",
            "work_orders.checklist.delete": "Ta bort checklista",
            "work_orders.checklist.delete_confirm_title": "Ta bort checklista?",
            "work_orders.checklist.delete_confirm_body": "Detta kan inte ångras. Checklistan och svaren tas bort.",
            "work_orders.checklist.loading": "Laddar checklista…",
            "work_orders.checklist.load_error": "Kunde inte ladda checklistan.",
            "work_orders.checklist.load_error_title": "Checklistan kunde inte laddas",
            "work_orders.checklist.load_error_hint":
              "Försök igen eller öppna arbetsordern från projektöversikten.",
            "work_orders.checklist.created": "Checklista skapad",
            "work_orders.checklist.create_error": "Kunde inte skapa checklista",
            "work_orders.checklist.deleted": "Checklista borttagen",
            "work_orders.checklist.delete_error": "Kunde inte ta bort checklista",
            "work_orders.checklist.save_error": "Kunde inte spara checklista",
            "work_orders.checklist.read_only_hint":
              "Du kan se arbetsorderns checklista i skrivskyddat läge på checklistsidan.",
            "work_orders.checklist.page_subtitle": "Checklista",
            "work_orders.checklist.page_heading": "Arbetsorder checklista",
            "work_orders.checklist.back_to_work_order": "Tillbaka till arbetsorder",
            "work_orders.checklist.disabled_title": "Checklista är inte aktiverad",
            "work_orders.checklist.disabled_body":
              "Aktivera «Använd checklista» på redigeringssidan för att använda avsnittet.",
            "work_orders.checklist.read_only_banner":
              "Skrivskyddat: du har inte behörighet att redigera checklistan.",
            "work_orders.checklist.create_from_edit": "Skapa en checklista från redigeringssidan för arbetsorder.",
            "work_orders.checklist.load_work_order_error": "Kunde inte ladda arbetsorder",
            "work_orders.checklist.card_title": "Checklista",
            "work_orders.checklist.card_desc_with_checklist":
              "Visa och fyll i checklistan på checklistsidan.",
            "work_orders.checklist.card_desc_no_checklist":
              "Skapa en checklista på redigeringssidan (välj mall eller börja tom).",
            "work_orders.checklist.unit": "punkter",
            "work_orders.checklist.mobile_nav": "Checklista",
            "work_orders.list_meta_total": "Totalt: {{count}}",
            "work_orders.table_no_title": "Ingen titel",
            "work_order.view.mobileNav.ariaLabel":
              "Snabbval för tidregistrering och varuförbrukning på arbetsorder",
            "work_order.admin.title": "Admin",
            "work_order.admin.edit": "Redigera arbetsorder",
            "work_order.admin.edit_desc": "Öppna fullständigt redigeringsformulär",
            "work_order.admin.approve": "Godkänn arbetsorder",
            "work_order.admin.approve_desc": "Godkänn eller avvisa (samordnare)",
            "work_order.admin.open_project": "Öppna projekt",
            "work_order.admin.open_customer": "Öppna kund",
            "work_order.admin.item_consumption": "Varuförbrukning",
            "work_order.admin.item_consumption_desc":
              "Registrera material och förbrukad kvantitet",
            "work_order.admin.billing_desc":
              "Förbered fakturaunderlag eller skapa kundorder",
            "work_order.admin.finish": "Slutför arbetsorder",
            "work_order.admin.finish_desc":
              "Gå igenom checklista och markera som slutförd",
            "work_order.admin.mentions": "@Omnämnanden",
            "work_order.admin.mentions_desc":
              "Anteckningar och resurser som refererar till denna arbetsorder",
            "work_order.admin.mentions_dialog_title":
              "Omnämnanden av arbetsordern",
            "work_order.admin.no_mentions": "Inga omnämnanden hittades.",
            "work_order.admin.set_status": "Ange status (admin)",
            "work_order.admin.set_status_desc":
              "Korrigera status för äldre fall, till exempel redan fakturerat utanför Promang.",
            "work_order.admin_set_status.title": "Ange status på arbetsorder",
            "work_order.admin_set_status.intro":
              "Använd när ordern fakturerats eller slutförts utanför det normala flödet. Skapar ingen kundorder.",
            "work_order.admin_set_status.status_label": "Status",
            "work_order.admin_set_status.mark_completed": "Markera som slutförd",
            "work_order.admin_set_status.submit": "Spara",
            "work_order.admin_set_status.success": "Status uppdaterad.",
            "work_order.admin_set_status.error": "Det gick inte att uppdatera status.",
            "work_order.completion.title": "Slutförande",
            "work_order.completion.status_not_applicable":
              "Slutförande är inte tillgängligt för denna status.",
            "work_order.completion.heading_done": "Arbetsorder slutförd",
            "work_order.completion.heading_pending": "Slutför arbetsorder",
            "work_order.completion.sub_done":
              "Arbetsordern har markerats som slutförd.",
            "work_order.completion.sub_blocked":
              "Vissa krav måste uppfyllas innan du kan slutföra.",
            "work_order.completion.sub_ready":
              "Alla obligatoriska krav är uppfyllda; du kan slutföra när du är redo.",
            "work_order.completion.label_status": "Status",
            "work_order.completion.label_progress": "Beredskap",
            "work_order.completion.value_done": "Slutförd",
            "work_order.completion.no_checks": "—",
            "work_order.completion.cta_view": "Visa slutförandedetaljer",
            "work_order.completion.cta_finish": "Slutför",
            "work_order.event.dialog_create": "Skapa händelse",
            "work_order.event.dialog_edit": "Redigera händelse",
            "work_order.event.toast_created": "Händelse skapad",
            "work_order.event.toast_updated": "Händelse uppdaterad",
            "work_order.event.toast_deleted": "Händelse raderad",
            "work_order.event.delete_failed": "Kunde inte radera händelsen",
            "work_order.event.delete_event": "Radera",
            "work_order.event.saving": "Sparar…",
            "work_order.event.submit_create": "Skapa",
            "work_order.event.submit_update": "Uppdatera",
            "work_order.event.field_title": "Titel",
            "work_order.event.field_title_placeholder": "Händelsetitel",
            "work_order.event.field_description": "Beskrivning",
            "work_order.event.field_description_placeholder": "Beskriv händelsen…",
            "work_order.event.field_start": "Starttid",
            "work_order.event.field_end": "Sluttid",
            "work_order.event.field_location": "Plats",
            "work_order.event.field_location_placeholder": "Var ska händelsen äga rum?",
            "work_order.event.location_prefilled":
              "Leveransadress från arbetsordern är förifylld (kan redigeras).",
            "work_order.event.all_day": "Hela dagen",
            "work_order.event.attendees_title": "Deltagare i händelsen",
            "work_order.event.attendees_hint":
              "Alla på arbetsordern föreslås. Avmarkera dem som inte ska delta. Du kan lägga till fler nedan.",
            "work_order.event.add_attendee": "Lägg till deltagare",
            "work_order.event.add_confirm": "Lägg till",
            "work_order.event.select_user": "Välj användare",
            "work_order.event.loading_users": "Laddar användare…",
            "work_order.event.no_attendees_from_wo":
              "Inga deltagare på arbetsordern. Använd «Lägg till deltagare» för att bjuda in.",
            "work_order.event.from_work_order": "Från arbetsorder",
            "work_order.event.remove_attendee": "Ta bort",
            "work_order.event.role_participant": "Deltagare",
            "work_order.event.error_need_event_owner":
              "Arbetsordern måste ha en användare som kan äga kalenderhändelsen (ansvarig utförare, ordreansvarig eller skapare) innan du kan skapa en händelse.",
            "work_order.event.notice_no_event_owner_title": "Saknar ägare för händelsen",
            "work_order.event.notice_no_event_owner_description":
              "Lägg till ansvarig utförare eller ordreansvarig på arbetsordern, eller se till att den har en skapare, så att händelsen kan kopplas till en användare. Du kan fortfarande redigera en befintlig händelse.",
            "work_order.participants.title": "Deltagare",
            "work_order.participants.description":
              "Vem som ingår i arbetsordern (roller och status).",
            "work_order.participants.draft_hint":
              "Spara arbetsordern först för att hantera deltagare som i ett projekt (egna dialogrutor).",
            "work_order.participants.add": "Lägg till deltagare",
            "work_order.participants.add_first": "Lägg till första deltagare",
            "work_order.participants.none": "Inga deltagare ännu.",
            "work_order.participants.user": "Användare",
            "work_order.participants.role": "Roll",
            "work_order.participants.status": "Status",
            "work_order.participants.edit": "Redigera",
            "work_order.participants.delete": "Ta bort",
            "work_order.participants.delete_confirm":
              "Ta bort denna deltagare från arbetsordern?",
            "work_order.participants.delete_error": "Kunde inte ta bort deltagare",
            "work_order.participants.error_loading":
              "Kunde inte ladda deltagare",
            "work_order.participants.save_error": "Kunde inte spara deltagare",
            "work_order.participants.created": "Deltagare tillagd",
            "work_order.participants.updated": "Deltagare uppdaterad",
            "work_order.participants.updating": "Uppdaterar…",
            "work_order.participants.adding": "Lägger till…",
            "report.participants.title": "Tillagda utförare",
            "report.participants.subtitle":
              "Extra fältpersonal och observatörer (alla syns i kalendern). Ansvarig utförare från avtalet anges under Utförare på avtalet.",
            "report.participants.add": "Lägg till",
            "report.participants.add_first": "Lägg till första",
            "report.participants.none": "Inga extra utförare utöver avtalet.",
            "report.participants.user": "Användare",
            "report.participants.role": "Roll",
            "report.participants.status": "Status",
            "report.participants.choose_role": "Välj roll",
            "report.participants.choose_status": "Välj status",
            "report.participants.edit": "Redigera",
            "report.participants.delete": "Ta bort",
            "report.participants.delete_confirm":
              "Ta bort den här personen från rapporten?",
            "report.participants.delete_error": "Kunde inte ta bort",
            "report.participants.save_error": "Kunde inte spara",
            "report.participants.created": "Tillagd",
            "report.participants.updated": "Uppdaterad",
            "report.participants.updating": "Uppdaterar…",
            "report.participants.adding": "Lägger till…",
            "report.participants.error_is_executing_employee":
              "Den här användaren är redan ansvarig utförare i avtalet. Välj någon annan eller ändra utförare i avtalet först.",
            "Use card view": "Använd kortvy",
            "Switch to card overview layout": "Byt till kortöversikt",
            "Switch to compact table layout": "Byt till tabellvy",
            "contact": "Kontakt",
            "service_agreement": "Serviceavtal",
            "order": "Order",
            "product": "Produkt",
            "folder": "Mapp",
      
            // Control Panel / Sentralbord translations
            "control.panel": "Kontrollpanel",
            "control.panel.overview":
              "Dashboard för systemintegrationer och övervakning",
            "overview": "Översikt",
            "queues": "Köer",
            "calls": "Samtalhistorik",
            "persons": "Personer",
            "settings": "Inställningar",
            "Bruker som håndterer egenmelding": "Användare som hanterar frånvaro",
            "Velg administrator": "Välj administratör",
            "Velg en administrator som skal håndtere egenmeldinger": "Välj en administratör som ska hantera frånvaro",
            "control.panel.overview.title": "Kontrollpanel Översikt",
            "control.panel.overview.description":
              "Dashboard för alla integrationer och system",
            "current.phone.status": "Aktuell Telefonstatus",
            "phone.status": "Telefonstatus",
            "phone.details.status": "Telefonstatus detaljer",
            "connected.to.phonero": "Ansluten till Phonero",
            "not.connected.to.phonero": "Inte ansluten till Phonero-system",
            "change.status": "Ändra Status",
            "not.connected.to.phone.system": "Inte ansluten till telefonsystem",
            "phonero.status": "Phonero Status",
            "not.configured": "Inte konfigurerad",
            "view.details": "Se detaljer",
            "system.status": "Systemstatus",
            "all.systems.operational": "Alla system operativa",
            "last.updated": "Senast uppdaterad",
            "quick.actions": "Snabbval",
            "configure": "Konfigurera",
            "phonero.queues": "Phonero Köer",
            "monitor.manage.queues": "Övervaka och hantera samtaleköer",
            "call.log": "Samtalhistorik",
            "view.call.history": "Se samtalhistorik och detaljer",
            "phonero.persons": "Phonero Personer",
            "manage.persons.phone": "Hantera personer och deras telefoninställningar",
            "control.panel.settings": "Kontrollpanel Inställningar",
            "configure.control.panel": "Konfigurera kontrollpanel och integrationer",
            "integrations": "Integrationer",
            "manage.all.integrations": "Hantera alla systemintegrationer",
            "phone.integration": "Telefonintegration",
      
            // Phonero presence statuses
            "presence.available": "Tillgänglig",
            "presence.busy": "Upptagen",
            "presence.away": "Borta",
            "presence.unknown": "Okänd",
            "presence.connected": "Ansluten till Phonero",
            "presence.not.available": "Tillgänglighetsstatus inte tillgänglig",
            "presence.failed.to.load": "Kunde inte ladda tillgänglighetsdata",
            "presence.updated.successfully": "Tillgänglighet uppdaterad",
            "presence.failed.to.update": "Kunde inte uppdatera tillgänglighet",
            "presence.cannot.update":
              "Kan inte uppdatera tillgänglighet - användare hittades inte i Phonero",
            "Nytt system": "Nytt system",
            // Events sidebar and scheduling
            "Events": "Händelser",
            "Your schedule for the selected day": "Ditt schema för vald dag",
            "Loading events...": "Laddar händelser...",
            "No events to show": "Inga händelser att visa",
            "Event": "Händelse",
            "Conflict": "Konflikt",
            "item_list_handling.pick_progress_short": "{{picked}}/{{total}} plockade",
            "item_list_handling.pick_progress_tooltip": "Hanteringslista: {{picked}} av {{total}} rader plockade. Liststatus: {{status}}.",
            "Planned time": "Planerad tid",
            "Start": "Start",
            "End": "Slut",
            "Location": "Plats",
            "Assumed 60 min duration for conflict check": "Antagen varaktighet 60 min för konfliktkontroll",
            "Executing Employee": "Utförare",
            "Agreement date": "Avtalsdatum",
            "Fixed time": "Fast tid",
            "Timeframe from": "Tidsram från",
            "Timeframe to": "Tidsram till",
            "Appointment confirmation required": "Bekräftelse av avtal krävs",
            "Send email to customer": "Skicka e-post till kund",
            "Phone number": "Telefonnummer",
            "Email address": "E-postadress",
            "Manually confirm agreement": "Bekräfta avtal manuellt",
            "Send confirmation reminder": "Skicka bekräftelsepåminnelse",
      
            // Customer Handler translations
            "customer.handler": "Kundebehandleren",
            "customer.handler.description": "Sök efter kunder, skapa samtal och administrera kundkommunikation",
            "customer.handler.selected.section": "Vald kund",
            "customer.handler.related.information": "Relaterad information",
            "customer.handler.open.customer.profile": "Öppna kundprofil",
            "customer.handler.open.customer.profile.hint": "Öppnar kundprofilen i en ny flik",
            "customer.handler.no.contact.info": "Ingen adress, e-post eller mobil registrerad",
            "customer.handler.edit.customer": "Redigera kund",
            "customer.handler.edit.communication": "Redigera",
            "customer.handler.communication.subject": "Ämne",
            "customer.handler.communication.body": "Innehåll",
            "customer.handler.communication.update.success": "Kommunikation uppdaterad",
            "search.customer": "Sök kund",
            "search.by.mobile.or.address": "Sök efter mobilnummer eller adress",
            "search.by.mobile.or.address.hint": "Ange mobilnummer eller adress för att söka",
            "searching": "Söker...",
            "search": "Sök",
            "search.results": "Sökresultat",
            "search.failed": "Sökningen misslyckades",
            "search.failed.server.error": "Serverfel uppstod",
            "search.failed.server.error.message": "Ett fel uppstod under sökningen. Försök igen. Skapa inte en ny kund om du tror att kunden redan finns.",
            "search.failed.unexpected.response": "Oväntat svar från servern",
            "search.error.title": "Sökfel",
            "search.error.hint": "Försök söka igen. Om problemet kvarstår, kontakta support. Skapa inte en duplicerad kund.",
            "create.conversation": "Skapa samtal",
            "name.or.mobile.required": "Namn eller mobilnummer krävs",
            "unknown.customer": "Okänd kund",
            "conversation.saved": "Samtal sparad",
            "conversation.saved.and.handled": "Samtal sparad och hanterad",
            "failed.to.create.customer": "Kunde inte skapa kund",
            "communication.added": "Kommunikation tillagd",
            "failed.to.add.communication": "Kunde inte lägga till kommunikation",
            "communication.marked.processed": "Kommunikation markerad som hanterad",
            "communication.marked.unprocessed": "Kommunikation markerad som ohanterad",
            "failed.to.update.communication": "Kunde inte uppdatera kommunikation",
            "no.communications.selected": "Inga kommunikationer valda",
            "communications.linked.to.case": "Kommunikationer kopplade till ärende",
            "failed.to.link.communications": "Kunde inte koppla kommunikationer",
            "selected.communications": "Valda kommunikationer",
            "link.to.case": "Koppla till ärende",
            "see.more": "Se mer",
            "mark.as.processed": "Markera som hanterad",
            "channel": "Kanal",
            "direction": "Riktning",
            "sent.at": "Skickad",
            "start.time": "Starttid",
            "end.time": "Sluttid",
            "related": "Relaterad",
            "processed": "Hanterad",
            "unprocessed": "Ohanterad",
            "created.by": "Skapad av",
            "street.address": "Gatuadress",
            "postal.code": "Postnummer",
            "city": "Stad",
            "conversation.date": "Samtalsdatum",
            "conversation.time": "Samtalstid",
            "conversation.note.placeholder": "Lägg till anteckning om samtalet...",
            "save": "Spara",
            "handle": "Hantera",
            "selected.customer": "Vald kund",
            "loading": "Laddar...",
            "loading.customer": "Laddar kund...",
            "communications": "Kommunikationer",
            "inbound": "Inkommande",
            "outbound": "Utgående",
            "no.communications": "Inga kommunikationer hittades",
            "no.cases": "Inga ärenden hittades",
            "upcoming.events": "Kommande händelser",
            "no.events": "Inga händelser hittades",
            "add.communication": "Lägg till kommunikation",
            "pending": "Väntar",
            "handled": "Hanterad",
            "Communication": "Kommunikation",
            "Message": "Meddelande",
            "Channel": "Kanal",
            "Direction": "Riktning",
            "link.to.case.choice.description": "Vill du länka till ett befintligt ärende eller skapa ett nytt?",
            "link.to.existing.case": "Länka till befintligt ärende",
            "link.to.existing.case.description": "Sök och välj ett befintligt ärende",
            "create.new.case": "Skapa nytt ärende",
            "create.new.case.description": "Skapa ett nytt ärende och länka kommunikationer",
            "search.case": "Sök ärende",
            "search.case.placeholder": "Sök efter ärendenummer, titel eller kund...",
            "no.cases.found": "Inga ärenden hittades",
            "cases": "Ärenden",
            "customer.cases": "Kundens ärenden",
            "linking.communications": "Länkar kommunikationer...",
            "treatment.section": "Behandlingssektion",
            "treatment.section.description": "Alla kommunikationer som kräver behandling",
            "search.communications": "Sök kommunikationer...",
            "all.statuses": "Alla statusar",
            "all.channels": "Alla kanaler",
            "phone": "Telefon",
            "email": "E-post",
            "sms": "SMS",
            "showing": "Visar",
            "of": "av",
            "customer.loaded": "Kund laddad",
            "customer.not.found": "Kund hittades inte",
            "failed.to.load.communications": "Kunde inte ladda kommunikationer",
            "failed.to.load.customer": "Kunde inte ladda kund",
      
            // Inventory Count translations (Swedish)
            "inventory.counts.title": "Lagerräkningar",
            "inventory.counts.description": "Hantera lagerräkningar och lagerkontroll",
            "inventory.count.title": "Lagerräkning",
            "inventory.count.create": "Ny räkning",
            "inventory.count.count_number": "Räkningsnummer",
            "inventory.count.date": "Datum",
            "inventory.count.status": "Status",
            "inventory.count.status.draft": "Utkast",
            "inventory.count.status.pending_approval": "Väntar på godkännande",
            "inventory.count.status.approved": "Godkänd",
            "inventory.count.status.completed": "Slutförd",
            "inventory.count.add_item": "Lägg till rad",
            "inventory.count.select_product": "Välj produkt",
            "inventory.count.scan_qr": "Skanna QR-kod",
            "inventory.count.import_csv": "Importera CSV/Excel",
            "inventory.count.selected_products": "Valda produkter",
            "inventory.count.item_number": "Artikelnr",
            "inventory.count.remove": "Ta bort",
            "inventory.count.note_optional": "Anteckning (valfritt)",
            "inventory.count.note_placeholder": "Lägg till anteckning...",
            "inventory.count.reset": "Återställ",
            "inventory.count.add_products": "Lägg till produkter",
            "inventory.count.add_product": "Lägg till produkt",
            "inventory.count.add_scanned_product": "Lägg till skannat produkt",
            "inventory.count.scan_another": "Skanna ett annat",
            "inventory.count.select_products": "Välj produkter",
            "inventory.count.products_selected": "{{count}} produkt(er) valda",
            "inventory.count.qr.required": "Ange eller skanna en QR-kod",
            "inventory.count.qr.placeholder": "Ange produktnummer eller skanna QR-kod",
            "inventory.count.product.already_selected": "Produkten är redan vald",
            "inventory.count.product.added": "Produkt tillagd",
            "inventory.count.product.not_found": "Produkt hittades inte. Försök manuell sökning.",
            "inventory.count.product.search_error": "Kunde inte söka efter produkt",
            "inventory.count.product.select_required": "Välj minst en produkt",
            "inventory.count.items": "Rader",
            "inventory.count.product": "Produkt",
            "inventory.count.quantity": "Mängd",
            "inventory.count.purchase_price": "Inköpspris",
            "inventory.count.total": "Totalt",
            "inventory.count.note": "Anteckning",
            "inventory.count.total_items": "Antal rader",
            "inventory.count.total_quantity": "Total mängd",
            "inventory.count.no_items": "Inga rader",
            "inventory.count.no_items_description": "Lägg till rader för att starta räkningen",
            "inventory.count.item.added": "Rad tillagd",
            "inventory.count.item.add_error": "Kunde inte lägga till rad",
            "inventory.count.item.updated": "Rad uppdaterad",
            "inventory.count.item.update_error": "Kunde inte uppdatera rad",
            "inventory.count.item.deleted": "Rad borttagen",
            "inventory.count.item.delete_error": "Kunde inte ta bort rad",
            "inventory.count.item.delete_confirm": "Är du säker på att du vill ta bort denna rad?",
            "inventory.count.quantity_required": "Mängd måste vara större än 0",
            "inventory.count.csv.import_title": "Importera rader från CSV/Excel",
            "inventory.count.csv.drop_here": "Släpp fil här",
            "inventory.count.csv.drop_or_select": "Dra och släpp en fil här, eller klicka för att välja",
            "inventory.count.csv.supported_formats": "CSV, XLS, XLSX",
            "inventory.count.csv.file_selected": "Fil vald",
            "inventory.count.csv.change_file": "Byt fil",
            "inventory.count.csv.column_mapping": "Kolummmappning",
            "inventory.count.csv.field.product_id": "Produkt ID",
            "inventory.count.csv.field.item_number": "Artikelnr",
            "inventory.count.csv.field.title": "Titel",
            "inventory.count.csv.field.quantity": "Mängd",
            "inventory.count.csv.field.purchase_price": "Inköpspris",
            "inventory.count.csv.field.note": "Anteckning",
            "inventory.count.csv.not_mapped": "Inte mappad",
            "inventory.count.csv.preview": "Förhandsvisning",
            "inventory.count.csv.first_rows": "första raderna",
            "inventory.count.csv.import": "Importera",
            "inventory.count.csv.importing": "Importerar...",
            "inventory.count.csv.import_success": "Importerade {{count}} rader",
            "inventory.count.csv.import_error": "Kunde inte importera rader",
            "inventory.count.csv.bulk_create_error": "Kunde inte skapa produkter i bulk",
            "inventory.count.csv.mapping_required": "Vänligen mappa minst Produkt ID eller Artikelnr",
            "inventory.count.csv.missing_products_title": "Produkter hittades inte",
            "inventory.count.csv.missing_products_message": "{{count}} produkt(er) hittades inte i systemet. Välj åtgärd för varje:",
            "inventory.count.csv.action": "Åtgärd",
            "inventory.count.csv.add_as_new": "Lägg till som ny produkt",
            "inventory.count.csv.skip": "Hoppa över",
            "inventory.count.csv.continue_import": "Fortsätt import",
            "inventory.count.csv.processing_items": "Bearbetar {{current}} av {{total}} produkter",
            "inventory.count.csv.processing": "Bearbetar...",
            "inventory.count.csv.partial_import_success": "Importerade {{imported}} rader, {{missing}} produkter hittades inte",
            "inventory.count.csv.no_items_to_import": "Inga rader att importera",
            "inventory.count.csv.no_headers": "Kunde inte upptäcka CSV-rubriker",
            "inventory.count.csv.read_error": "Fel vid läsning av fil",
            "inventory.count.csv.processing_error": "Fel vid bearbetning av fil",
            "inventory.count.csv.product_not_found": "Produkt hittades inte",
            "inventory.count.csv.product_search_error": "Fel vid sökning efter produkt",
            "inventory.count.csv.product_id_required": "Produkt ID eller Artikelnr krävs",
            "inventory.count.csv.no_valid_items": "Inga giltiga rader hittades i filen",
            "inventory.count.duplicate.title": "Produkt finns redan i listan",
            "inventory.count.duplicate.message": "Denna produkt finns redan i räkningslistan. Vill du lägga till ytterligare en rad?",
            "inventory.count.duplicate.added_at": "Tillagd",
            "inventory.count.duplicate.confirm": "Lägg till rad",
            "inventory.counts.search_placeholder": "Sök i lagerräkningar...",
            "inventory.counts.filter_title": "Filtrera på status",
            "inventory.count.new_title": "Ny lagerräkning",
            "inventory.count.title_required": "Titel krävs",
            "inventory.count.date_required": "Datum krävs",
            "inventory.count.storage_required": "Lager krävs",
            "inventory.count.storage": "Lager",
            "inventory.count.select_storage": "Välj lager",
            "inventory.count.create_success": "Lagerräkning skapad",
            "inventory.count.create_error": "Kunde inte skapa lagerräkning",
            "inventory.count.approve": "Godkänn",
            "inventory.count.unapprove": "Avgodkänn",
            "inventory.count.approve_all": "Godkänn alla",
            "inventory.count.unapprove_all": "Avgodkänn alla",
            "inventory.count.approve_all_success": "{{count}} rader godkända",
            "inventory.count.approve_all_error": "Kunde inte godkänna alla rader",
            "inventory.count.all_items_already_approved": "Alla rader är redan godkända",
            "inventory.count.approved": "Godkänd",
            "inventory.count.approved_at": "Godkänd",
            "inventory.count.approved_by": "Godkänd av",
            "inventory.count.approve_success": "Räkning godkänd",
            "inventory.count.approve_error": "Kunde inte godkänna räkning",
            "inventory.count.unapprove_success": "Räkning avgodkänd",
            "inventory.count.unapprove_error": "Kunde inte avgodkänna räkning",
            "inventory.count.copy": "Kopiera räkning",
            "inventory.count.no_title": "Ingen titel",
            "inventory.count.could_not_load": "Kunde inte ladda lagerräkningar",
            "inventory.count.no_counts_found": "Inga lagerräkningar hittades",
            "inventory.count.create_new": "Skapa en ny lagerräkning",
            "selected": "vald",
            "Select": "Välj",
            "Select all": "Välj alla",
            "Updated": "Uppdaterad",
            "Created": "Skapad",
            "inventory.count.copy_from_previous": "Kopiera från tidigare räkning",
            "inventory.count.copy_all_products": "Kopiera alla produkter från lager",
            "inventory.count.select_count_to_copy": "Välj räkning att kopiera",
            "inventory.count.copy_success": "Räkning kopierad",
            "inventory.count.copy_error": "Kunde inte kopiera räkning",
            "inventory.count.copy_products_success": "Produkter kopierade",
            "inventory.count.copy_products_error": "Kunde inte kopiera produkter",
            "inventory.count.approved_items": "Godkända rader",
            "inventory.count.approve_count": "Godkänn räkning",
            "inventory.count.date_updated": "Datum uppdaterat",
            "inventory.count.date_update_error": "Kunde inte uppdatera datum",
            "inventory.count.storage_updated": "Lager uppdaterat",
            "inventory.count.storage_update_error": "Kunde inte uppdatera lager",
            "inventory.count.no_storage": "Inget lager",
            "inventory.count.export_pdf": "Exportera PDF",
            "inventory.count.export_csv": "Exportera CSV/Excel",
            "inventory.count.export_pdf_success": "PDF exporterad",
            "inventory.count.export_pdf_error": "Kunde inte exportera PDF",
            "inventory.count.export_csv_success": "CSV exporterad",
            "inventory.count.export_csv_error": "Kunde inte exportera CSV",
            "product.stock_report.title": "Lagerrapport",
            "product.stock_report.description": "Komplett översikt över alla lagerrörelser (in/ut) och var produkten är registrerad (lagerräkning, korrektion, order, rapport, etc.)",
            "product.stock_report.date": "Datum",
            "product.stock_report.type": "Typ",
            "product.stock_report.transaction_title": "Titel",
            "product.stock_report.quantity": "Antal",
            "product.stock_report.storage": "Lager",
            "product.stock_report.status": "Status",
            "product.stock_report.approved": "Godkänd",
            "product.stock_report.pending": "Väntar",
            "product.stock_report.no_transactions": "Inga transaktioner",
            "product.stock_report.no_transactions_description": "Inga lagerrörelser hittades för denna produkt",
            "Processing...": "Bearbetar...",
            
            // Offer Calculation translations (Swedish)
            "offer.calculation.title": "Kalkyler / Offer Items",
            "offer.calculation.subtitle": "Hantera kalkyler och offer items",
            "offer.calculation.new": "Ny kalkyl",
            "offer.calculation.search_placeholder": "Sök i kalkyler...",
            "offer.calculation.name": "Namn",
            "offer.calculation.type": "Typ",
            "offer.calculation.status": "Status",
            "offer.calculation.total": "Totalt",
            "offer.calculation.actions": "Åtgärder",
            "offer.calculation.view": "Visa",
            "offer.calculation.edit": "Redigera",
            "offer.calculation.delete": "Ta bort",
            "offer.calculation.delete_confirm": "Är du säker på att du vill ta bort denna kalkylen?",
            "offer.calculation.no_results": "Inga kalkyler hittades",
            "offer.calculation.active": "Aktiv",
            "offer.calculation.inactive": "Inaktiv",
            "offer.calculation.type.standard": "Standard",
            "offer.calculation.type.product": "Produkt",
            "offer.calculation.type.hours": "Timmar",
            "offer.calculation.type.car_allowance": "Bilgodtgörelse",
            "offer.calculation.type.nested": "Nästad",
            "offer.calculation.line": "rad",
            "offer.calculation.lines": "rader",
            "offer.calculation.delete_success": "Kalkyl borttagen",
            "offer.calculation.delete_error": "Kunde inte ta bort kalkyl",
            "offer.calculation.untitled": "Utan titel",
            "offer.calculation.mode.title": "Välj kalkylupplägg",
            "offer.calculation.mode.subtitle": "Välj om denna kalkyl ska använda vanliga rader eller modulbyggaren. Detta låses efter att kalkylen har sparats.",
            "offer.calculation.mode.lines_title": "Radkalkyl",
            "offer.calculation.mode.lines_hint": "Använd befintlig radbaserad kalkyl med produkter, timmar och manuella rader.",
            "offer.calculation.mode.modules_title": "Modulbyggare",
            "offer.calculation.mode.modules_hint": "Bygg ett visuellt flöde med produkter, timmar, formler och pilar.",
            "offer.calculation.mode.locked_hint": "Kalkylupplägg är låst efter skapande för att undvika att rader och modulbyggare blandas.",
            "offer.calculation.builder.section_title": "Kalkylbyggare",
            "offer.calculation.builder.section_hint": "Behåll befintliga rader, eller bygg en visuell modulbaserad kalkyl som kan kopplas till backend senare.",
            "offer.calculation.builder.section_hint_lines": "Denna kalkyl är radbaserad. Använd rader, produkter, timmar och manuella rader.",
            "offer.calculation.builder.section_hint_modules": "Denna kalkyl använder modulbyggaren. Bygg flödet visuellt och testa det i användarvyn.",
            "offer.calculation.builder.tab_lines": "Rader",
            "offer.calculation.builder.tab_modules": "Modulbyggare",
            "offer.calculation.builder.tab_insert": "Användarvy",
            "offer.calculation.page.kicker": "Offerterkalkyl",
            "offer.calculation.page.subtitle": "Bygg, testa och använd kalkyler i en fullbreddsyta med rader, moduler och en separat inklistringsvy.",
            "offer.calculation.insert.title": "User insert view",
            "offer.calculation.insert.subtitle": "Så här känns kalkylen när den klistras in i offerter, moduler eller andra flöden.",
            "offer.calculation.insert.inputs_title": "Justerbara fält",
            "offer.calculation.insert.inputs_hint": "Endast olåsta fält kan ändras här, till exempel kilometer, procent och fördelning.",
            "offer.calculation.insert.flow_title": "Så hänger kalkylen ihop",
            "offer.calculation.insert.flow_hint": "Rutor och kopplingar visas som en readonly-karta medan siffrorna uppdateras live.",
            "offer.calculation.insert.fields_tab": "Justera fält",
            "offer.calculation.insert.map_tab": "Karta",
            "offer.calculation.insert.offer_dialog_title": "Anpassa kalkylen innan den läggs till offerten",
            "offer.calculation.insert.offer_cancel": "Avbryt",
            "offer.calculation.insert.offer_add": "Lägg till i offert",
            "offer.calculation.insert.adjust_fields": "Justera fält",
            "offer.calculation.insert.edit_lines": "Redigera kalkyl",
            "offer.calculation.insert.adjustable_fields": "Justerbara fält",
            "offer.calculation.insert.adjustable_fields_hint": "Denna kalkyl använder modulbyggaren. Öppna justering för att ändra antal, kilometer, procent och andra öppna fält.",
            "offer.calculation.module.palette_title": "Moduler",
            "offer.calculation.module.palette_hint": "Dra moduler till ytan, eller klicka för att lägga till dem.",
            "offer.calculation.module.canvas_title": "Modulkarta",
            "offer.calculation.module.canvas_hint": "Flytta rutor, koppla dem med pilar och välj om varje koppling ska lägga till eller dra av.",
            "offer.calculation.module.connecting_hint": "Välj nästa ruta för att skapa en koppling.",
            "offer.calculation.module.reset_example": "Återställ till exempel",
            "offer.calculation.module.zoom_out": "Zooma ut",
            "offer.calculation.module.zoom_in": "Zooma in",
            "offer.calculation.module.reset_view": "Återställ vy",
            "offer.calculation.module.result_title": "Resultat",
            "offer.calculation.module.result_hint": "Detta är en frontend-förhandsvisning. Backend blir källan till totalerna när den implementeras.",
            "offer.calculation.module.editor_title": "Redigera vald modul",
            "offer.calculation.module.edge_title": "Redigera pil",
            "offer.calculation.module.breakdown_title": "Fördelning",
            "offer.calculation.module.connect": "Koppla",
            "offer.calculation.module.connect_here": "Koppla hit",
            "offer.calculation.module.remove": "Ta bort",
            "offer.calculation.module.remove_edge": "Ta bort pil",
            "offer.calculation.module.locked": "Låst",
            "offer.calculation.module.unlocked": "Öppen",
            "offer.calculation.module.enabled": "Aktiv",
            "offer.calculation.module.disabled": "Inaktiv",
            "offer.calculation.module.operation.add": "Lägg till",
            "offer.calculation.module.operation.subtract": "Dra av",
            "offer.calculation.module.scope.all": "Hela jobbet",
            "offer.calculation.module.scope.work": "Endast jobb",
            "offer.calculation.module.scope.driving": "Endast körning",
            "offer.calculation.module.scope.selected": "Valda moduler",
            "offer.calculation.module.field.title": "Titel",
            "offer.calculation.module.field.amount": "Belopp",
            "offer.calculation.module.field.enabled": "Status",
            "offer.calculation.module.field.quantity": "Antal",
            "offer.calculation.module.field.unit_price": "Enhetspris",
            "offer.calculation.module.field.product_name": "Produktnamn",
            "offer.calculation.module.field.hours": "Timmar",
            "offer.calculation.module.field.hourly_rate": "Timpris",
            "offer.calculation.module.field.cost_hourly_rate": "Kostnad per timme",
            "offer.calculation.module.field.percent": "Procent",
            "offer.calculation.module.field.scope": "Gäller",
            "offer.calculation.module.field.divisor": "Fördela på",
            "offer.calculation.module.field.expression": "Formel",
            "offer.calculation.module.field.note": "Notering",
            "offer.calculation.module.field.operation": "Operation",
            "offer.calculation.module.formula.assistant_title": "Formelhjälp",
            "offer.calculation.module.formula.assistant_subtitle": "Välj en färdig mall, eller klicka på variabler och funktioner. Du behöver inte komma ihåg Excel-syntax.",
            "offer.calculation.module.formula.templates": "Färdiga mallar",
            "offer.calculation.module.formula.variables": "Infoga värde",
            "offer.calculation.module.formula.functions": "Smarta funktioner",
            "offer.calculation.module.formula.example_title": "Tips",
            "offer.calculation.module.formula.example_text": "`input` är summan från pilarna in till {{title}}. Börja med en mall och justera siffrorna.",
            "offer.calculation.module.formula.variable.input": "Summa från inkommande pilar",
            "offer.calculation.module.formula.variable.quantity": "Eget antal",
            "offer.calculation.module.formula.variable.price": "Eget pris",
            "offer.calculation.module.formula.variable.percent": "Egen procent",
            "offer.calculation.module.formula.function.sum": "Summera flera tal",
            "offer.calculation.module.formula.function.round": "Runda till heltal",
            "offer.calculation.module.formula.function.min": "Maxpristak",
            "offer.calculation.module.formula.function.max": "Minimipris",
            "offer.calculation.module.formula.template.same": "Använd summan som den är",
            "offer.calculation.module.formula.template.fixed_add": "Lägg till fast belopp",
            "offer.calculation.module.formula.template.fixed_subtract": "Dra av fast belopp",
            "offer.calculation.module.formula.template.ten_percent": "Lägg på 10 %",
            "offer.calculation.module.formula.template.custom_percent": "Lägg på egen %",
            "offer.calculation.module.formula.template.quantity_price": "Antal gånger pris",
            "offer.calculation.module.formula.template.split_two": "Dela på 2",
            "offer.calculation.module.formula.template.round": "Runda totalen",
            "offer.calculation.module.node.service": "Tjänst",
            "offer.calculation.module.node.service_hint": "Fast belopp som kan låsas, t.ex. lägenhet.",
            "offer.calculation.module.node.quantity": "Antal x pris",
            "offer.calculation.module.node.quantity_hint": "Antal multiplicerat med enhetspris, t.ex. kilometer.",
            "offer.calculation.module.node.product_price": "Produktpris",
            "offer.calculation.module.node.product_price_hint": "Produktnamn, antal och pris i en modul.",
            "offer.calculation.module.node.product_catalog": "Produktlista",
            "offer.calculation.module.node.product_catalog_hint": "Lägg till produkter från produktregistret eller manuella produktrader.",
            "offer.calculation.module.node.labor_hours": "Timfält",
            "offer.calculation.module.node.labor_hours_hint": "Timmar multiplicerat med timpris, t.ex. tilläggsarbete eller servicearbete.",
            "offer.calculation.module.node.percentage": "Procent",
            "offer.calculation.module.node.percentage_hint": "Påslag eller rabatt på inkommande moduler.",
            "offer.calculation.module.node.distribution": "Fördelning",
            "offer.calculation.module.node.distribution_hint": "Fördela inkommande belopp på X.",
            "offer.calculation.module.node.formula": "Excel-formel",
            "offer.calculation.module.node.formula_hint": "Använd input, quantity, price, percent, SUM och ROUND.",
            "offer.calculation.module.node.subtotal": "Subtotal",
            "offer.calculation.module.node.subtotal_hint": "Samlar flera inkommande moduler.",
            "offer.calculation.module.node.total": "Total",
            "offer.calculation.module.node.total_hint": "Slutpunkt för kalkylen.",
            "offer.calculation.module.node.note": "Notering",
            "offer.calculation.module.node.note_hint": "Förklarande ruta utan belopp.",
            "offer.calculation.module.product.title": "Produkter",
            "offer.calculation.module.product.hint": "Välj produkter från registret eller lägg till egna produktrader.",
            "offer.calculation.module.product.add_from_catalog": "Lägg till från produktregister",
            "offer.calculation.module.product.add_manual": "Manuell rad",
            "offer.calculation.module.product.empty": "Inga produkter har lagts till ännu.",
            "offer.calculation.module.product.manual_title": "Manuell produkt",
            "offer.calculation.module.product.include": "Ta med",
            "offer.calculation.module.product.exclude": "Uteslut",
            "offer.calculation.module.product.total": "Produkttotal",
            "offer.calculation.module.product.cancel": "Avbryt",
            "offer.calculation.module.product.add_selected": "Lägg till valda",
            
            // Accounting Summary translations (Swedish)
            "accounting.summary.title": "Räkenskapsöversikt",
            "accounting.summary.costs": "Kostnader",
            "accounting.summary.income": "Intäkter",
            "accounting.summary.profit": "Vinst",
            "accounting.summary.profit_margin": "marginal",
            "accounting.summary.projects": "Projekt",
            "accounting.summary.labor": "Lönekostnader",
            "accounting.summary.material": "Materialkostnader",
            "accounting.summary.supplier_invoices": "Leverantörsfakturor",
            "accounting.summary.item_lists": "Varlistor",
            "accounting.summary.customer_invoices": "Kundfakturor",
            "accounting.summary.reports": "Rapporter",
            "accounting.summary.total": "Totalt",
            "accounting.summary.calculated_at": "Beräknad",
            "accounting.summary.cached": "Cachad",
            "accounting.summary.load_error": "Kunde inte ladda räkenskapsöversikt",
            "accounting.summary.monthly_overview": "Månadsöversikt",
            "accounting.summary.chart_description": "Staplar: intäkter & kostnader · Linje: månadsresultat (intäkter − kostnader)",
            "accounting.summary.no_monthly_data": "Ingen månadsdata tillgänglig",
            "accounting.summary.months.january": "Jan",
            "accounting.summary.months.february": "Feb",
            "accounting.summary.months.march": "Mar",
            "accounting.summary.months.april": "Apr",
            "accounting.summary.months.may": "Maj",
            "accounting.summary.months.june": "Jun",
            "accounting.summary.months.july": "Jul",
            "accounting.summary.months.august": "Aug",
            "accounting.summary.months.september": "Sep",
            "accounting.summary.months.october": "Okt",
            "accounting.summary.months.november": "Nov",
            "accounting.summary.months.december": "Dec",
            "accounting.summary.expected_report_income": "Förväntad intäkt från uppdrag",
            "accounting.summary.expected_income": "Förväntad intäkt",
            "accounting.summary.expected_costs": "Förväntade kostnader",
            "accounting.summary.expected_profit": "Förväntad vinst",
      
            // Phonero presence descriptions
            "Free": "Ledig",
            "Meeting": "Möte",
            "Lunch": "Lunch",
            "Vacation": "Semester",
            "Busy": "Upptagen",
            "Way": "På väg",
            "Gone for the day": "Klar för dagen",
      
            // Live Calls translations
            "Live Calls (Not synched yet)": "Live Samtal (Inte synkroniserade ännu)",
            "Latest calls from Phonero API (not yet synced to database)":
              "Senaste samtal från Phonero API (inte synkroniserade till databas ännu)",
            "Refreshing...": "Uppdaterar...",
            "Refresh": "Uppdatera",
            "Loading live calls...": "Laddar live samtal...",
            "No unsynced live calls found":
              "Inga osynkroniserade live samtal hittades",
      
            // Manual Call translations
            "Add Manual Call": "Lägg till manuellt samtal",
            "From Number (Customer)": "Från nummer (Kund)",
            "Date & Time": "Datum & Tid",
            "Duration (seconds)": "Varaktighet (sekunder)",
            "Note": "Anteckning",
            "Cancel": "Avbryt",
            "Create Call": "Skapa samtal",
            "Creating...": "Skapar...",
            "Manual call created successfully": "Manuellt samtal skapat",
            "Manual call added successfully": "Manuellt samtal tillagt",
            "Manual": "Manuell",
            "Select Date": "Välj datum",
            "Choose date": "Välj datum",
            "report": "Rapport",
            "report.create": "Skapa rapport",
            "report.update": "Uppdatera rapport",
            "report.type": "Rapporttyp",
            "report.date": "Rapportdatum",
            "report.description": "Rapportbeskrivning",
            "report.agreement.update": "Uppdatera rapportavtal",
            "report.agreement.new": "Nytt rapportavtal",
            "report.agreement.modal_intro":
              "Fyll i när arbetet är planerat och om kunden ska få ett meddelande.",
            "report.agreement.title": "Tidsbokning / avtal",
            "report.agreement.subtitle": "Tid, utförare och kundavisering",
            "report.agreement.setup_title": "Ingen avtalad tid sparad ännu",
            "report.agreement.setup_body": "Ange datum, tid, vem som utför arbetet och skicka vid behov SMS eller e-post till kunden.",
            "report.agreement.setup_cta": "Lägg till avtal",
            "report.agreement.section.schedule": "Tid och utförare",
            "report.agreement.section.schedule_help":
              "Vem som utför arbetet, avtalsdatum och tidsperiod.",
            "report.agreement.section.notify": "Kundavisering",
            "report.agreement.section.notify_help":
              "Välj om kunden ska meddelas via SMS eller e-post och vem som tar emot det.",
            "report.agreement.send_to_customer": "Skicka avtal till kund",
            "report.agreement.send_to_customer_hint_on": "SMS och/eller e-post kan användas när det är aktiverat nedan.",
            "report.agreement.send_to_customer_hint_off": "Tiden sparas bara i Promang; kunden meddelas inte.",
            "report.agreement.executing_you": "Du (inloggad användare)",
            "report.agreement.select_executing": "Välj medarbetare",
            "report.agreement.change_executing": "Byt…",
            "report.agreement.confirm_hint_required":
              "Avtalet skickas till kunden som måste bekräfta via SMS eller e-post.",
            "report.agreement.confirm_hint_optional":
              "Tidsinformation skickas till kunden; bekräftelse krävs inte och avtalet bekräftas automatiskt.",
            "report.agreement.validation.date_required": "Datum krävs",
            "report.agreement.validation.executing_required": "Utförare krävs",
            "report.agreement.validation.phone_for_sms": "Telefonnummer krävs när SMS är på",
            "report.agreement.validation.email_for_email": "Giltig e-post krävs när e-post är på",
            "report.agreement.status.confirmed": "Avtalet är bekräftat",
            "report.agreement.status.not_confirmed": "Avtalet är inte bekräftat",
            "report.agreement.status.sms_sent": "SMS har skickats",
            "report.agreement.status.sms_not_sent": "SMS har inte skickats",
            "report.agreement.status.sms_confirmed": "Bekräftat via SMS",
            "report.agreement.status.email_sent": "E-post har skickats",
            "report.agreement.status.email_not_sent": "E-post har inte skickats",
            "report.agreement.status.none": "Inget avtal",
            "report.view.mobileNav.ariaLabel": "Snabbval för rapportavsnitt",
            "report.view.mobileNav.items": "Varuförbrukning",
            "report.view.mobileNav.variables": "Variabler",
            "report.view.mobileNav.checklist": "Checklista",
            "report.view.mobileNav.report": "Rapport",
            "report.view.mobileNav.timeRegistration": "Tidregistrering",
            "report.view.summary.customer": "Kund",
            "report.view.sectionReport.title": "Rapport",
            "report.view.sectionReport.description": "Skriv rapportinnehåll",
            "report.view.sectionReport.unit": "rapport",
            "report.view.sectionReport.statusFinished": "Klar",
            "report.view.sectionReport.statusNotRequired": "Krävs inte",
            "report.view.sectionReport.statusMissing": "Saknas",
            "report.view.sectionGuide.title": "Guider",
            "report.view.sectionGuide.description": "Strukturerade guider och historik för denna rapport",
            "report.view.sectionGuide.unitRuns": "körningar",
            "report.view.sectionGuide.statusNone": "Ej påbörjad",
            "report.view.sectionGuide.statusHasRuns": "{{count}} genomförda",
            "report.view.guideHistory.title": "Guidehistorik",
            "report.view.guideHistory.empty": "Inga guider har slutförts på denna rapport ännu.",
            "report.view.guideHistory.startGuide": "Starta guide",
            "report.view.guideHistory.close": "Stäng",
            "report.view.guideHistory.completedAt": "Slutförd",
            "report.view.guideHistory.by": "Av",
            "report.view.guideHistory.unknownUser": "Okänd användare",
            "report.view.guideHistory.answers": "Svar",
            "report.view.guideHistory.tagsApplied": "Etiketter tillagda ({{count}})",
            "report.view.mobileNav.guide": "Guide",
            "report.view.priceCalculated.title": "Ett pris har beräknats för detta uppdrag",
            "report.view.priceCalculated.subtitle": "Senast sparade kalkyl visar vad kunden ska betala för hela jobbet (fastpris + tillägg).",
            "report.view.priceCalculated.open": "Öppna kalkyl",
            "report.view.priceCalculated.exVat": "Exkl. moms",
            "report.view.priceCalculated.incVat": "Inkl. moms",
            "report.additional_work_calculator.sectionTitle": "Beräkna tilläggsarbete",
            "report.additional_work_calculator.sectionSubtitle": "Kalkyl för tillägg utöver fastpris",
            "report.additional_work_calculator.sectionBody": "Öppna kalkylen för att justera timmar, material och nytt uppmöte.",
            "report.additional_work_calculator.open": "Öppna kalkyl",
            "report.additional_work_calculator.dialogTitle": "Kalkyl — vad ska kunden betala?",
            "report.additional_work_calculator.loading": "Hämtar prisestimat…",
            "report.additional_work_calculator.heroLabel": "Vad kunden betalar (hela jobbet)",
            "report.additional_work_calculator.exVat": "Exkl. moms",
            "report.additional_work_calculator.incVat": "Inkl. moms",
            "report.additional_work_calculator.exVatShort": "exkl.",
            "report.additional_work_calculator.incVatShort": "inkl.",
            "report.additional_work_calculator.extraHours": "Extratimmar",
            "report.additional_work_calculator.hoursLabel": "Antal timmar",
            "report.additional_work_calculator.newVisit": "Nytt uppmöte / körning",
            "report.additional_work_calculator.newVisitHelp": "Avstånd och priser följer samma underlag som prisestimatet.",
            "report.additional_work_calculator.includeVisit": "Inkludera kostnad för nytt uppmöte",
            "report.additional_work_calculator.estimateKm": "Avstånd från prisestimat: {{km}} km (ca.)",
            "report.additional_work_calculator.estimateKmPrice": "Kilometerpris kund: {{price}} /km exkl. moms",
            "report.additional_work_calculator.estimateMin": "Minimibelopp körning: {{min}} — vid låg km används fast taxa {{fixed}}",
            "report.additional_work_calculator.underMinHint": "Vid systemavstånd under minimibelopp används fast taxa.",
            "report.additional_work_calculator.modeSystem": "Använd km från system",
            "report.additional_work_calculator.modeCustom": "Egna km",
            "report.additional_work_calculator.modeMinimum": "Endast minimum / fast taxa",
            "report.additional_work_calculator.customKm": "Antal kilometer",
            "report.additional_work_calculator.productsTitle": "Material (ej fastprisrader)",
            "report.additional_work_calculator.noProducts": "Inga rader utanför fastpris på rapporten.",
            "report.additional_work_calculator.lineHint": "Ändringar här påverkar bara kalkylen — inte rapportraderna.",
            "report.additional_work_calculator.qty": "Antal",
            "report.additional_work_calculator.unitPrice": "Pris/st exkl.",
            "report.additional_work_calculator.exclude": "Uteslut från beräkning",
            "report.additional_work_calculator.includeAgain": "Ta med igen",
            "report.additional_work_calculator.detailsToggle": "Mer för företaget (kostnad, marginal, fastpris)",
            "report.additional_work_calculator.hourlyCustomer": "Timpris kund (exkl.)",
            "report.additional_work_calculator.hourlyCustomerHelp": "Timpris som kunden debiteras.",
            "report.additional_work_calculator.hourlyCost": "Timpris kostnad (exkl.)",
            "report.additional_work_calculator.hourlyCostHelp": "Intern kostnad per timme.",
            "report.additional_work_calculator.fallbackHourly": "Standardpris används.",
            "report.additional_work_calculator.fallbackCost": "Standardpris används.",
            "report.additional_work_calculator.rowLaborCust": "Arbete (kund)",
            "report.additional_work_calculator.rowLaborCost": "Arbete (kostnad)",
            "report.additional_work_calculator.rowMaterialCust": "Material (kund)",
            "report.additional_work_calculator.rowMaterialCost": "Material (kostnad)",
            "report.additional_work_calculator.rowVisitCust": "Uppmöte (kund)",
            "report.additional_work_calculator.rowVisitCost": "Uppmöte (kostnad)",
            "report.additional_work_calculator.rowFixed": "Fastprisrader (kund, exkl.)",
            "report.additional_work_calculator.rowTotalCost": "Summa kostnad företag (exkl.)",
            "report.additional_work_calculator.rowMargin": "Marginal (exkl.)",
            "report.additional_work_calculator.historyToggle": "Sparade kalkyler ({{count}})",
            "report.additional_work_calculator.restore": "Återställ",
            "report.additional_work_calculator.close": "Stäng",
            "report.additional_work_calculator.save": "Spara kalkyl",
            "report.additional_work_calculator.saveAsNew": "Spara som ny kalkyl",
            "report.additional_work_calculator.saveOverwrite": "Skriv över senaste",
            "report.additional_work_calculator.saveOverwriteHint":
              "Ersätter den senast sparade kalkylen. Äldre historik behålls.",
            "report.additional_work_calculator.newCalculation": "Ny kalkyl",
            "report.additional_work_calculator.newCalculationHint":
              "Nollställer formuläret från rapport och prisestimat (senaste sparning påverkar inte).",
            "report.additional_work_calculator.saving": "Sparar…",
            "report.additional_work_calculator.toastSaved": "Kalkyl sparad",
            "report.additional_work_calculator.toastSavedNew": "Ny kalkyl sparad",
            "report.additional_work_calculator.toastSavedOverwrite": "Senaste kalkylen uppdaterad",
            "report.additional_work_calculator.toastSaveError": "Kunde inte spara kalkyl",
            "report.additional_work_calculator.toastRestored": "Värden från sparad kalkyl har laddats",
            "report.additional_work_calculator.addFromCatalog": "Lägg till produkt",
            "report.additional_work_calculator.addManualLine": "Tom rad",
            "report.additional_work_calculator.addProductsTitle": "Välj produkter till kalkylen",
            "report.additional_work_calculator.addSelectedProducts": "Lägg till i kalkyl",
            "report.additional_work_calculator.toastProductsAdded": "{{count}} produkt(er) tillagda i kalkylen",
            "report.additional_work_calculator.lineTitle": "Beskrivning / artikel",
            "report.additional_work_calculator.lineHintCustom": "Endast i kalkylen — skapar inte rapportrad.",
            "report.additional_work_calculator.unitCost": "Kost/st exkl.",
            "report.additional_work_calculator.removeLine": "Ta bort rad",
            "report.additional_work_calculator.loadFromReport": "Ladda kalkyl från rapport",
            "report.additional_work_calculator.loadFromReportHint":
              "Listan visar endast rapporter med sparad priskalkyl. Välj rapport — senast sparade kalkyl används. Rader från källrapporten kopplas inte till denna rapport.",
            "report.additional_work_calculator.reportSelectorLabel": "Rapport med priskalkyl",
            "report.additional_work_calculator.selectorCalcSummary": "Senast sparad: {{ex}} exkl. / {{inc}} inkl.",
            "report.additional_work_calculator.loadFromReportDialogTitle": "Ladda kalkyl från annan rapport",
            "report.additional_work_calculator.loadFromReportBody":
              "Ange rapport-ID (samma som i URL eller rapportkort). Varorader från den rapporten kopplas inte hit — de ingår bara i kalkylen här.",
            "report.additional_work_calculator.reportIdLabel": "Rapport-ID",
            "report.additional_work_calculator.loadFromReportApply": "Ladda",
            "report.additional_work_calculator.loadFromReportCancel": "Avbryt",
            "report.additional_work_calculator.loadFromReportLoading": "Hämtar…",
            "report.additional_work_calculator.loadFromReportIdRequired": "Ange rapport-ID",
            "report.additional_work_calculator.loadFromReportIdInvalid": "Ogiltigt rapport-ID",
            "report.additional_work_calculator.loadFromReportSame": "Välj en annan rapport än denna",
            "report.additional_work_calculator.toastLoadedFromReport": "Kalkyl laddad från rapport {{number}}",
            "report.additional_work_calculator.toastNoCalculatorOnReport": "Den rapporten har ingen sparad kalkyl",
            "report.additional_work_calculator.toastLoadReportError": "Kunde inte hämta rapport eller kalkyl",
            "report.additional_work_calculator.addToConsumption": "Lägg till i varuförbrukning",
            "report.additional_work_calculator.addToConsumptionWorking": "Lägger till…",
            "report.additional_work_calculator.addToConsumptionHint":
              "Skapar eller uppdaterar en rapportrad (samma som varuförbrukning). Priser från kalkylen skrivs till raden när de skiljer sig.",
            "report.additional_work_calculator.toastAddedToConsumption": "Tillagd i varuförbrukning",
            "report.additional_work_calculator.toastAddToConsumptionNeedQty": "Ange antal större än noll",
            "report.additional_work_calculator.toastAddToConsumptionNeedTitle": "Ange beskrivning för manuell rad",
            "report.additional_work_calculator.toastAddToConsumptionUnlinked":
              "Artikeln lades till, men kalkylen kunde inte kopplas till raden automatiskt — uppdatera eller justera i varuförbrukning.",
            "report.additional_work_calculator.toastAddToConsumptionPriceSyncError":
              "Rad skapad, men priserna från kalkylen kunde inte synkas",
            "report.additional_work_calculator.toastAddToConsumptionError": "Kunde inte lägga till i varuförbrukning",
            "report.additional_work_calculator.discountLabel": "Rabatt timmar / körning",
            "report.additional_work_calculator.discountHint":
              "Belopp exkl. moms som dras från extratimmar och nytt uppmöte/körning (inte material eller fastpris). Får inte överstiga summan av dessa.",
            "report.additional_work_calculator.discountFieldLabel": "Rabatt timmar/körning (kr exkl. moms)",
            "report.additional_work_calculator.lineDiscountLabel": "Rad rabatt (exkl.)",
            "report.additional_work_calculator.lineDiscountHint":
              "Rabatt exkl. moms på denna materialrad. Får inte överstiga radens belopp (antal × pris/st).",
            "report.additional_work_calculator.rowSubtotal": "Delsumma före rabatter (ex.)",
            "report.additional_work_calculator.rowDiscount": "Rabatt (ex.)",
            "report.additional_work_calculator.rowDiscountMaterials": "Materialrabatt (ex.)",
            "report.additional_work_calculator.rowDiscountHoursVisit": "Timmar/körning rabatt (ex.)",
            "report.additional_work_calculator.rowMaterialCustGross": "Material före rabatt (kund, exkl.)",
            "report.additional_work_calculator.detailsToggleCustomer": "Prisdetaljer (kund, ex.)",
            "report.additional_work_calculator.rowTotalCustomerExVat": "Summa kund (ex.)",
            "report.additional_work_calculator.excludeShort": "Uteslut",
            "report.additional_work_calculator.includeShort": "Ta med",
            "report.additional_work_calculator.addToConsumptionShort": "Varuförbrukning",
            "report.additional_work_calculator.addPriceLines": "Lägg till prislinje",
            "report.additional_work_calculator.addPriceLinesHint":
              "Skapar en avtalad prislinje med avtalat arbete inkl. uppmöte: summan av extratimmar och uppmöte/körning (exkl. moms, före rabatt timmar/körning). Kopplar första projektaktivitet som har aktivitetspost, annars första aktiviteten på projektet. Justera under Prislinjer.",
            "report.additional_work_calculator.priceLineWorkIncludingVisitTitle":
              "Avtalat arbete inkl. uppmöte (kalkyl)",
            "report.additional_work_calculator.toastPriceLinesNothing":
              "Ange extratimmar och/eller aktivera nytt uppmöte med belopp större än noll.",
            "report.additional_work_calculator.toastPriceLinesAdded": "{{count}} prislinje(r) tillagda",
            "report.additional_work_calculator.toastPriceLinesError": "Kunde inte skapa prislinje",
            "report.sectionCard.viewOnlyHint": "Endast visning (klicka för att se)",
            "report.sectionCard.progress": "Framsteg",
            "report.sectionDialog.reportTitle": "Rapportinnehåll",
            "report.sectionDialog.reportDescription": "Skriv rapportinnehåll",
            "report.sectionDialog.reportContentLabel": "Rapportinnehåll",
            "report.sectionDialog.internalReportLabel": "Intern rapport",
            "report.sectionDialog.placeholderReport": "Skriv rapportinnehåll här…",
            "report.sectionDialog.placeholderInternal": "Skriv intern rapport här…",
            "report.sectionDialog.formatting": "Formaterar…",
            "report.sectionDialog.formatWithAi": "Formatera med ChatGPT",
            "report.sectionDialog.autoSaveHint": "Ändringar sparas automatiskt.",
            "report.sectionDialog.saving": "Sparar…",
            "report.sectionDialog.saved": "Sparat",
            "report.sectionDialog.autoSaveError": "Kunde inte spara rapporttext",
            "report.sectionDialog.close": "Stäng",
            "report.agreement.section.followup": "Uppföljning till kund",
            "report.agreement.section.followup_help":
              "Skicka påminnelse, skicka avtalet igen (SMS) eller skicka uppdaterat avtal efter att det bekräftats.",
            "report.agreement.section.manual_confirm": "Bekräfta avtal manuellt",
            "report.agreement.section.manual_confirm_help":
              "Använd när kunden redan bekräftat utanför Promang. Du får bekräfta innan det sparas.",
            "report.agreement.section.cancel_agreement": "Avboka avtal",
            "report.agreement.section.cancel_agreement_help":
              "Välj typ av avbokning eller orsak. «Uppdrag avbokat» avslutar utan motivering och utan meddelande om ny tid. SMS till kunden kan stängas av/på nedan innan du bekräftar.",
            "report.agreement.cancel_sms_hint":
              "Om aktiverat kan SMS skickas när avbokningen skickas (beroende på inställningar).",
            "report.agreement.prompt.reminder_title": "Skicka bekräftelsepåminnelse?",
            "report.agreement.prompt.reminder_body":
              "Kontrollera att du inte redan skickat en påminnelse för detta avtal.",
            "report.agreement.prompt.resend_title": "Skicka avtalet igen?",
            "report.agreement.prompt.resend_body":
              "Kontrollera att du inte redan skickat ett nytt meddelande till kunden.",
            "report.agreement.prompt.updated_appointment_title":
              "Skicka uppdaterat avtal?",
            "report.agreement.prompt.updated_appointment_body":
              "Samma datum och tid skickas som tidigare; beskrivning m.m. kan ha uppdaterats.",
            "report.agreement.prompt.confirm_manual_title":
              "Registrera manuell bekräftelse?",
            "report.agreement.prompt.confirm_manual_body":
              "Avtalet markeras som bekräftat ({{method}}). Vill du fortsätta?",
            "report.agreement.prompt.cancel_agreement_title": "Avboka avtalet?",
            "report.agreement.prompt.cancel_agreement_body":
              "Orsak: {{reason}}. Detta avbokar tidsbokningen i Promang. Vill du fortsätta?",
            "cancel.reason": "Orsak till avbokning",
            "cancel.reason.required": "Orsak till avbokning krävs",
            "cancel.reason.employee_sickness": "Servicetekniker sjuk",
            "cancel.reason.customer_sickness": "Kund sjuk",
            "cancel.reason.not_confirmed": "Inte bekräftat av kund",
            "cancel.reason.not_suited": "Tid passade inte kunden",
            "cancel.reason.assignment_cancelled": "Uppdrag avbokat",
            "cancel.reason.not_chosen": "Inte vald",
            "report.agreement.edit": "Redigera avtal",
            "report.agreement.time_range": "Tidsperiod",
            "report.variables.update": "Uppdatera variabler",
            "report.price_lines.title": "Prislinjer",
            "report.price_lines.description": "Hantera prislinjer och avtalade priser",
            "report.price_lines.add": "Lägg till prislinje",
            "report.price_lines.empty": "Inga prislinjer tillagda",
            "report.price_lines.line": "Prislinje",
            "report.price_lines.title_field": "Titel",
            "report.price_lines.activity_item": "Aktivitet",
            "report.price_lines.no_activity": "Ingen aktivitet",
            "report.price_lines.description_field": "Beskrivning",
            "report.price_lines.is_agreed_price": "Avtalad prislinje",
            "report.price_lines.agreed_price": "Avtalat pris",
            "report.price_lines.agreed_price_excl_vat": "Avtalat pris (exkl. moms)",
            "report.price_lines.agreed_price_incl_vat": "Avtalat pris (inkl. moms)",
            "report.price_lines.vat_type": "Moms Typ",
            "report.price_lines.no_vat_type": "Ingen Moms Typ",
            "report.price_lines.select_vat_type": "Välj Moms Typ",
            "report.price_lines.select_vat_type_description": "Välj en moms typ för denna prisrad",
            "report.price_lines.search_vat_types": "Sök efter moms typer...",
            "report.price_lines.no_vat_types_found": "Inga moms typer hittades",
            "report.price_lines.no_vat_types_available": "Inga moms typer tillgängliga",
            "report.price_lines.select_activity": "Välj Aktivitet",
            "report.price_lines.project_activity": "Projektaktivitet",
            "report.price_lines.select_project_activity": "Välj projektaktivitet",
            "report.price_lines.select_project_first": "Välj ett projekt först",
            "report.price_lines.remove_activity": "Ta Bort Aktivitet",
            "report.price_lines.agreed_hours": "Avtalade timmar",
            "project_activity.label": "Projektaktivitet",
            "project_activity.select": "Välj projektaktivitet",
            "project_activity.dialog_title": "Välj projektaktivitet",
            "project_activity.search_placeholder": "Sök projektaktiviteter…",
            "project_activity.empty": "Inga projektaktiviteter hittades",
            "project_activity.select_project_first": "Välj projekt först",
            "project_activity.load_error": "Kunde inte ladda projektaktiviteter",
            "project_activity.clear_selection": "Rensa val",
            "project_activity.none": "Ingen projektaktivitet",
            "project_activity.missing": "Ingen projektrad",
            "hours.period_table.project_and_line": "Projekt / projektrad",
            "Loading": "Laddar",
            "hours.registration_warning.title": "Varning: Timmar överskrider beräknat",
            "hours.registration_warning.message": "Du håller på att registrera {newHours} timmar på aktiviteten \"{activityTitle}\". Detta kommer att bringa totalt registrerade timmar till {totalAfterRegistration} timmar, vilket överskrider de beräknade {estimatedHours} timmarna. Nu registrerat: {registeredHours} timmar.",
            "hours.registration_warning.question": "Är du säker på att du vill registrera dessa timmar på denna aktivitet?",
            "hours.registration_warning.confirm": "Ja, jag är säker",
            "hours.registration_warning.cancel": "Nej, korrigera",
            "hours.registration_warning.this_activity": "denna aktivitet",
            "hours.form_tab_details": "Detaljer",
            "hours.approved_edit_notice_title": "Godkänd timme",
            "hours.approved_edit_notice_body":
              "Timmen är godkänd. Som företagsadministratör kan du ändå redigera den; godkännandestatus behålls. Lön eller Tripletex bör kontrolleras manuellt efter ändringar.",
            "hours.bulk_reassign.project_field": "Projekt",
            "hours.bulk_reassign.title": "Flytta timmar till annat projekt / aktivitet",
            "hours.bulk_reassign.intro": "Du redigerar {{count}} timmar. Välj målprojekt och projektaktivitet (rad).",
            "hours.bulk_reassign.project_required": "Projekt krävs",
            "hours.bulk_reassign.activity_required": "Projektaktivitet krävs",
            "hours.bulk_reassign.submit": "Verkställ för valda timmar",
            "hours.bulk_reassign.saving": "Sparar…",
            "hours.bulk_reassign.success": "Uppdaterade {{count}} timmar.",
            "hours.bulk_reassign.partial": "Uppdaterade {{updated}}; {{failed}} misslyckades — se listan.",
            "hours.bulk_reassign.error": "Kunde inte flytta timmar",
            "hours.bulk_reassign.open": "Flytta valda…",
            "hours.approval.filter_project": "Projekt",
            "hours.approval.all_projects": "Alla projekt",
            "hours.approval.clear_project_filter": "Rensa projekt",
            "hours.approval.selection_summary.title": "Sammanfattning av val",
            "hours.approval.selection_summary.subtitle":
              "«Registrerat» och periodtal kommer från listan för valt datumintervall och filter (samma urval som tabellen).",
            "hours.approval.selection_summary.total_selected": "Valt: {{hours}} t · {{entries}} poster",
            "hours.approval.selection_summary.period_totals": "I perioden (inläst): {{hours}} t · {{entries}} poster",
            "hours.approval.selection_summary.by_date": "Per datum",
            "hours.approval.selection_summary.day_row": "{{date}}: {{selected}} t valt av {{registered}} t registrerat",
            "hours.approval.selection_summary.other_days": "Andra dagar med registreringar: {{days}} dagar · {{hours}} t",
            "hours.approval.selection_summary.clear": "Rensa val",
            "hours.approval.selection_summary.unknown_user": "Okänd användare",
            "hours.approval.bulk_unapprove.action": "Återkalla godkännande för valda",
            "hours.approval.bulk_unapprove.no_approved": "Ingen av de valda timmarna är godkända.",
            "hours.approval.bulk_unapprove.success": "Godkännande återkallat för {{count}} timmar.",
            "hours.approval.bulk_unapprove.error": "Kunde inte återkalla godkännande för alla valda timmar",
            "hours.approval.bulk_unapprove.process_note": "Massåterkallet godkännande",
            "project.time_registration.bulk_reassign": "Flytta valda timmar…",
            "project.time_registration.select_hour": "Välj timme för massflytt",
            "hours.resource_plan.title": "Resursplan och tillgänglighet",
            "hours.resource_plan.subtitle": "Se vem som är planerad, tillgänglig, frånvarande eller instämplad på de faktiska dagarna.",
            "hours.resource_plan.date_from": "Från datum",
            "hours.resource_plan.date_to": "Till datum",
            "hours.resource_plan.access_title": "Åtkomst för anställda",
            "hours.resource_plan.access_body": "Användare med åtkomst till Timmar kan se operativ kollegestatus utan administratörsrättigheter.",
            "hours.resource_plan.load_error": "Kunde inte ladda resursplan",
            "hours.resource_plan.stats.employees": "Anställda",
            "hours.resource_plan.stats.available_days": "Tillgängliga dagsrader",
            "hours.resource_plan.stats.clocked_in": "Instämplade",
            "hours.resource_plan.stats.scheduled_hours": "Planerade timmar",
            "hours.resource_plan.days_title": "Dagar i perioden",
            "hours.resource_plan.days_subtitle": "Välj en dag för detaljerad medarbetaröversikt.",
            "hours.resource_plan.day_stats": "{{available}} av {{employees}} tillgängliga",
            "hours.resource_plan.no_day": "Ingen dag vald",
            "hours.resource_plan.employee_overview": "Medarbetare, planerad tid och status för vald dag.",
            "hours.resource_plan.empty": "Inga anställda hittades för vald period.",
            "hours.resource_plan.unknown_employee": "Okänd medarbetare",
            "hours.resource_plan.table.employee": "Medarbetare",
            "hours.resource_plan.table.status": "Status",
            "hours.resource_plan.table.department": "Avdelning",
            "hours.resource_plan.table.scheduled": "Arbetsplan",
            "hours.resource_plan.table.shift": "Pass",
            "hours.resource_plan.table.note": "Notering",
            "hours.resource_plan.status.clocked_in": "På jobbet nu",
            "hours.resource_plan.status.available": "Tillgänglig",
            "hours.resource_plan.status.planned": "Planerad",
            "hours.resource_plan.status.absent": "Frånvaro",
            "hours.resource_plan.status.unavailable": "Inte tillgänglig",
            "hours.resource_plan.status.off": "Ledig",
            "crew.panel.title": "Bemanning och pass",
            "crew.panel.subtitle": "Dagens plan, frånvaro och stämpling (kräver modul «Mannskap och vaktplan» i företaget)",
            "crew.panel.loading": "Laddar bemanning…",
            "crew.panel.error": "Kunde inte ladda bemanning",
            "crew.panel.no_project": "Välj projekt för att se bemanning",
            "crew.panel.shifts": "Pass",
            "crew.panel.absences": "Frånvaro idag",
            "crew.panel.open_punches": "Pågående stämpling",
            "crew.panel.clock_in": "Stämpla in",
            "crew.panel.clock_out": "Stämpla ut",
            "crew.panel.checklists": "Checklistor",
            "crew.panel.seed_checklists": "Skapa standard checklisttyper",
            "crew.panel.hours": "Tidlista",
            "crew.panel.open_full": "Öppna modul",
            "crew.page.kicker": "Planering",
            "crew.page.title": "Bemanning och pass",
            "crew.page.subtitle": "Planera pass, hantera tillgänglighet, stämpling, kiosk och ledaröversikt",
            "crew.tabs.shifts": "Passplan",
            "crew.tabs.mine": "Mina pass",
            "crew.tabs.availability": "Tillgänglighet",
            "crew.tabs.punch": "Stämpling",
            "crew.tabs.kiosk": "Kiosk",
            "crew.tabs.leader": "Ledare",
            "crew.tabs.leader_alerts": "Efterlevnad och varningar",
            "crew.tabs.payroll": "Löneunderlag",
            "crew.stats.shifts": "Pass",
            "crew.stats.assignments": "Uppdrag",
            "crew.stats.open_punches": "Öppna stämplingar",
            "crew.stats.alerts": "Varningar",
            "crew.filters.title": "Planeringsfilter",
            "crew.filters.subtitle": "Välj projekt, period och aktiv dag för veckovyn.",
            "crew.filters.project": "Projekt",
            "crew.filters.date": "Datum",
            "crew.filters.period": "Period",
            "crew.filters.period_from": "Period från",
            "crew.filters.period_to": "Period till",
            "crew.filters.active_day": "Aktiv dag",
            "crew.filters.density": "Visning",
            "crew.filters.days": "dagar",
            "crew.filters.this_week": "Denna vecka",
            "crew.filters.next_week": "Nästa vecka",
            "crew.filters.this_month": "Denna månad",
            "crew.density.cozy": "Luftig",
            "crew.density.compact": "Kompakt",
            "crew.shift.new": "Nytt pass",
            "crew.shift.edit": "Redigera pass",
            "crew.shift.copy": "Kopiera pass",
            "crew.shift.copy_short": "Kopiera",
            "crew.shift.new_short": "Nytt pass",
            "crew.shift.step_info": "Info",
            "crew.shift.step_days_time": "Dagar och tid",
            "crew.shift.next_days_time": "Nästa: dagar och tid",
            "crew.shift.back_info": "Tillbaka till info",
            "crew.shift.title": "Titel",
            "crew.shift.title_hint": "Kort namn som gör passet lätt att känna igen, t.ex. ”Lördag kväll foodtruck”.",
            "crew.shift.title_placeholder": "T.ex. Lördag kväll foodtruck",
            "crew.shift.role": "Roll",
            "crew.shift.role_hint": "Vad personen ska göra på passet, t.ex. passledare, kök, kassa, servering eller städning. Använd ”passledare” när personen även ska följa upp checklistor vid start/slut.",
            "crew.shift.role_placeholder": "T.ex. Passledare",
            "crew.shift.role_suggestions": "Välj rollförslag eller skriv manuellt",
            "crew.shift.roles.shift_lead": "Passledare",
            "crew.shift.roles.cashier": "Kassa",
            "crew.shift.roles.kitchen": "Kök",
            "crew.shift.roles.service": "Servering",
            "crew.shift.roles.runner": "Runner",
            "crew.shift.roles.cleanup": "Städning",
            "crew.shift.roles.closing": "Stängning",
            "crew.shift.starts_at": "Start",
            "crew.shift.ends_at": "Slut",
            "crew.shift.project": "Projekt",
            "crew.shift.project_hint": "Kopplar passet till rätt projekt. Detta används senare vid stämpling och tidregistrering så att timmar hamnar på rätt projekt.",
            "crew.shift.location": "Plats",
            "crew.shift.location_hint": "Var passet utförs, t.ex. foodtruck-namn, adress, evenemang eller avdelning.",
            "crew.shift.location_placeholder": "T.ex. Foodtruck Centrum",
            "crew.shift.break_minutes": "Paus (min)",
            "crew.shift.break_minutes_hint": "Planerad paus som dras från planerade timmar.",
            "crew.shift.slots": "Platser",
            "crew.shift.slots_hint": "Hur många personer som behövs på passet.",
            "crew.shift.assignment_mode": "Tilldelning",
            "crew.shift.assignment_mode_hint": "Direkt tilldelning ger passet till vald anställd. Öppet passerbjudande låter anställda svara på erbjudandet.",
            "crew.shift.assignment_direct": "Direkt tilldelning",
            "crew.shift.assignment_open": "Öppet passerbjudande",
            "crew.shift.response_deadline": "Svarfrist",
            "crew.shift.response_deadline_hint": "Valfritt. Obesvarade erbjudanden döljs för anställda efter fristen.",
            "crew.shift.leader_checklist_required": "Kräv ledarchecklistor",
            "crew.shift.leader_checklist_required_hint": "Skapar obligatoriska uppstarts- och avslutschecklistor för passet. Användbart för passledare i foodtruck, serveringsenhet och serviceteam.",
            "crew.shift.handover_note": "Överlämningsnotering",
            "crew.shift.handover_note_hint": "Viktig information nästa ledare eller pass bör se.",
            "crew.shift.assigned_employee": "Anställd på passet",
            "crew.shift.assigned_employee_hint": "Valfritt. Välj en anställd här för att lägga personen direkt på alla valda dagar.",
            "crew.shift.month": "Månad",
            "crew.shift.month_hint": "Välj månaden du vill planera. Kryssa i dagarna i kalendern nedan.",
            "crew.shift.from_time": "Från kl.",
            "crew.shift.from_time_hint": "Starttid som används för alla valda dagar.",
            "crew.shift.to_time": "Till kl.",
            "crew.shift.to_time_hint": "Sluttid som används för alla valda dagar. Om slut är före start räknas det som nattpass till nästa dag.",
            "crew.shift.single_day": "En dag",
            "crew.shift.period_days": "Flera dagar",
            "crew.shift.period_from": "Period från",
            "crew.shift.period_to": "Period till",
            "crew.shift.weekdays": "Välj veckodagar",
            "crew.shift.create_plan": "Skapa passplan",
            "crew.shift.copy_plan": "Kopiera passplan",
            "crew.shift.copy_assignments_hint": "{{count}} personal kopieras från originalpasset om du inte väljer en annan anställd.",
            "crew.shift.overview_month": "Månad",
            "crew.shift.overview_period": "Period",
            "crew.shift.days_with_shifts": "Dagar med pass",
            "crew.shift.missing_days": "Dagar utan plan",
            "crew.shift.planned_hours": "Planerade timmar",
            "crew.shift.month_overview": "Månadsöversikt",
            "crew.shift.month_overview_hint": "Gröna dagar har passplan. Ljusa dagar saknar plan.",
            "crew.shift.day_has_shifts": "{{count}} pass",
            "crew.shift.day_missing": "Saknar plan",
            "crew.shift.day_by_day": "Dag för dag",
            "crew.shift.day_shift_count": "{{count}} pass",
            "crew.shift.selected_day_timeline": "Tidslinje för vald dag",
            "crew.shift.no_shifts_selected_day": "Inga pass på vald dag.",
            "crew.shift.add_shift_hint": "Välj en dag i veckan eller skapa ett nytt pass för att fylla planen.",
            "crew.shift.no_role": "Ingen roll",
            "crew.shift.no_days_selected": "Inga dagar valda i perioden",
            "crew.shift.ends_after_start": "Slut måste vara efter start",
            "crew.shift.no_crew_added": "Ingen personal tillagd / passerbjudande skickat",
            "crew.shift.publish": "Publicera",
            "crew.shift.cancel": "Avbryt",
            "crew.shift.cancel_reason": "Orsak till avbokning",
            "crew.assignment.add": "Lägg till personal",
            "crew.assignment.add_short": "Lägg till personal",
            "crew.assignment.accept": "Acceptera",
            "crew.assignment.decline": "Avböj",
            "crew.availability.starts_at": "Från",
            "crew.availability.ends_at": "Till",
            "crew.availability.add_day": "Välj dag",
            "crew.availability.add_day_button": "Lägg till dag",
            "crew.availability.add_weekdays": "Lägg till vardagar",
            "crew.availability.month": "Månad",
            "crew.availability.remove_day": "Ta bort dag",
            "crew.availability.no_days_selected": "Inga dagar valda",
            "crew.availability.selected_days": "Valda dagar",
            "crew.availability.selected_short": "Vald",
            "crew.availability.saved_short": "Sparad",
            "crew.availability.from_time": "Från kl.",
            "crew.availability.to_time": "Till kl.",
            "crew.availability.status": "Status",
            "crew.availability.available": "Tillgänglig",
            "crew.availability.unavailable": "Inte tillgänglig",
            "crew.availability.monthly_overview": "Tillgänglighet per månad",
            "crew.availability.month_stats": "{{days}} dagar · {{hours}} timmar tillgängliga",
            "crew.availability.loading": "Laddar…",
            "crew.availability.no_entries": "Ingen tillgänglighet sparad för vald period.",
            "crew.punch.clocked_in": "Du är instämplad",
            "crew.punch.choose_shift": "Välj pass för instämpling, eller stämpla in utan pass.",
            "crew.punch.clock_in_without_shift": "Stämpla in utan pass",
            "crew.punch.history": "Stämplingshistorik",
            "crew.punch.history_date": "Datum",
            "crew.punch.history_in": "In",
            "crew.punch.history_out": "Ut",
            "crew.punch.history_hours": "Timmar",
            "crew.punch.history_status": "Status",
            "crew.punch.deviation_note": "Avvikelse / notering",
            "crew.punch.deviation_note_placeholder": "Avvikelse, saknad checklistepunkt eller notering till nästa ledare...",
            "crew.punch.open": "Öppen",
            "crew.punch.closed": "Stängd",
            "crew.punch.no_history": "Inga stämplingar i perioden.",
            "crew.kiosk.title": "Kiosk / PIN",
            "crew.kiosk.help": "Använd en gemensamt inloggad enhet och personlig PIN för anställda.",
            "crew.kiosk.open": "Öppna PIN-verifiering",
            "crew.kiosk.employee_number": "Anställningsnummer",
            "crew.kiosk.pin": "PIN",
            "crew.kiosk.verify": "Verifiera",
            "crew.kiosk.verify_title": "Verifiera PIN",
            "crew.kiosk.pin_admin_title": "Hantera anställds PIN",
            "crew.kiosk.save_pin": "Spara PIN",
            "crew.kiosk.clear_pin": "Radera PIN",
            "crew.payroll.planned": "Planerat",
            "crew.payroll.actual": "Faktiskt",
            "crew.empty.shifts": "Inga pass i vald period.",
            "crew.empty.assignments": "Inga passerbjudanden eller tilldelningar.",
            "crew.empty.alerts": "Inga varningar.",
            "crew.empty.payroll": "Inget löneunderlag i perioden.",
            "crew.checklists.handover_title": "Checklisteöverlämning",
            "crew.checklists.mark_completed": "Markera klar",
            "crew.checklists.no_runs": "Inga obligatoriska passchecklistor i perioden.",
            "crew.checklists.kind.start": "Uppstart",
            "crew.checklists.kind.end": "Avslut",
            "crew.checklists.status.pending": "Väntar",
            "crew.checklists.status.in_progress": "Pågår",
            "crew.checklists.status.completed": "Klar",
            "crew.alerts.time_punch_deviation_note": "Avvikelse/notering från stämpling",
            "crew.alerts.required_shift_checklist_pending": "Obligatorisk checklista är inte klar",
            "crew.alerts.long_open_punch": "Lång öppen stämpling",
            "crew.alerts.planned_shift_missing_break": "Planerat pass saknar paus",
            "crew.alerts.high_hours_last_12_months": "Höga faktiska timmar senaste 12 månaderna",
            "crew.toast.saved": "Sparat",
            "crew.toast.assignment_saved": "Personal tillagd",
            "crew.toast.pin_verified": "PIN verifierad",
            "crew.toast.pin_saved": "PIN sparad",
            "crew.toast.pin_cleared": "PIN raderad",
            "crew.toast.published": "Pass publicerat",
            "crew.toast.cancelled": "Pass avbrutet",
            "crew.toast.accepted": "Pass accepterat",
            "crew.toast.declined": "Pass avböjt",
            "crew.toast.availability_saved": "Tillgänglighet sparad",
            "crew.toast.clocked_in": "Instämplad",
            "crew.toast.clocked_out": "Utstämplad",
            "crew.toast.checklists_seeded": "Checklisttyper skapade",
            "crew.toast.checklist_completed": "Checklista markerad som klar",
            "crew.weekdays.monday": "Mån",
            "crew.weekdays.tuesday": "Tis",
            "crew.weekdays.wednesday": "Ons",
            "crew.weekdays.thursday": "Tor",
            "crew.weekdays.friday": "Fre",
            "crew.weekdays.saturday": "Lör",
            "crew.weekdays.sunday": "Sön",
            "hours.sheet.add_hour": "Lägg till timme",
            "hours.sheet.edit_hour": "Redigera timme",
            "hours.sheet.new_hour": "Ny timme",
            "hours.sheet.stats_title": "Statistik",
            "hours.sheet.stats_selected_period": "Vald period (listan)",
            "hours.sheet.stats_calendar_month": "Kalendermånad",
            "hours.sheet.stats_weeks_heading": "Veckor",
            "hours.sheet.stats_this_week": "Denna vecka",
            "hours.sheet.stats_prev_week": "Föregående vecka",
            "hours.sheet.stats_normal_suffix": "normal (schema)",
            "hours.sheet.stats_no_schedule": "Ingen arbetstidsplan är kopplad till anställningen — normaltimmar och procent visas inte.",
            "hours.sheet.stats_loading_extra": "Hämtar månads- och veckototaler…",
            "report.price_lines.updated": "Prislinje uppdaterad",
            "report.price_lines.created": "Prislinje skapad",
            "report.price_lines.deleted": "Prislinje raderad",
            "report.price_lines.save_error": "Kunde inte spara prislinje",
            "report.price_lines.delete_error": "Kunde inte radera prislinje",
            "report.price_lines.edit": "Redigera prislinje",
            "report.copy.price_lines_option": "Prislinjer",
            "report.copy.variables_option": "Variabler",
            "report.sequel.copy_variables_switch": "Kopiera från huvudrapport",
            "report.sequel.copy_variables_hint_on":
              "Variabler kopieras från huvudrapporten, inkl. grupper, typgrupper, värden och mätningar.",
            "report.sequel.copy_variables_hint_off": "Inga variabler kopieras.",
            "report.sequel.copy_variables_none_available":
              "Inga variabelrader eller grupper på huvudrapporten — inget att kopiera.",
            "report.sequel.copy_price_lines_switch": "Kopiera från huvudrapport",
            "report.sequel.copy_price_lines_hint_on":
              "Prislinjer kopieras från huvudrapporten ({{count}} rader).",
            "report.sequel.copy_price_lines_hint_off": "Inga prislinjer kopieras.",
            "report.sequel.copy_price_lines_none_available": "Inga prislinjer på huvudrapporten.",
            "report.price_lines.updating": "Uppdaterar...",
            "report.price_lines.adding": "Lägger till...",
            "report.price_lines.delete_confirm": "Är du säker på att du vill ta bort denna prislinjen?",
            "report.price_lines.delete": "Ta bort prislinje",
            "report.price_lines.error_loading": "Fel vid laddning av prislinjer",
            "report.price_lines.add_first": "Lägg till första prislinjen",
            "report.price_lines.title_required": "Titel krävs",
            "report.price_lines.validation.agreed_price_or_hours":
                "Ange avtalat pris (exkl. eller inkl. moms) eller avtalade timmar, eller stäng av «Avtalad prisrad».",
            "report.price_lines.server_errors_title": "Kunde inte spara — se meddelandena nedan",
            "report.price_lines.field_errors_hint": "Fält med fel är markerade.",
            "report.details.description": "Grundläggande rapportinformation",
            "report.items.description": "Hantera varor och konsumtion",
            "report.activities.description": "Hantera aktiviteter och timmar",
            "report.checklist.description": "Slutför checklistpunkter",
            "report.checklist.loading": "Laddar checklista…",
            "report.checklist.load_error": "Kunde inte ladda checklista",
            "report.checklist.load_error_title": "Checklistan kunde inte laddas",
            "report.checklist.load_error_hint":
              "Gå till ett annat steg och tillbaka, eller stäng och öppna dialogrutan igen. Om problemet kvarstår, försök igen senare.",
            "quality.checklist.view.completionTitle": "Slutför checklista",
            "quality.checklist.view.completionDescription":
              "När alla rader är godkända eller markerade som avvikelse kan du slutföra checklistan. Osparade ändringar sparas när du fortsätter.",
            "quality.checklist.view.completionButton": "Slutför checklista",
            "quality.checklist.view.completionSaving": "Sparar…",
            "quality.checklist.view.completionDoneTitle": "Checklistan är slutförd",
            "quality.checklist.view.completionDoneDescription":
              "Checklistan är markerad som färdig.",
            "quality.checklist.type.titleLabel": "Titel",
            "quality.checklist.type.activeLabel": "Aktiv",
            "quality.checklist.type.introLabel": "Introduktion till denna checklisttyp",
            "quality.checklist.type.defaultActions": "Tillgängliga svar",
            "quality.checklist.type.defaultActionsHint":
              "Vilka utfall som ska visas som knappar på checklistrader. Punkter kan begränsa listan vidare.",
            "quality.checklist.type.pointsHeading": "Checklistpunkter",
            "quality.checklist.type.pointsSubheading":
              "Lägg till rubrik, vägledning för kund/användare och vilka svar som gäller för varje punkt.",
            "quality.checklist.type.documentsRequired": "Dokumentation krävs",
            "quality.checklist.type.pointLabel": "Punkt {{n}}",
            "quality.checklist.type.pointTitle": "Punktets namn",
            "quality.checklist.type.guidanceLabel": "Vägledning",
            "quality.checklist.type.guidanceHint":
              "Visas för den som fyller i checklistan. Fritextsvar anges i fältet nedan vid ifyllnad.",
            "quality.checklist.type.pointActions": "Svar för denna punkt",
            "quality.checklist.type.pointActionsHint":
              "Stäng av svar som inte ska visas bara för denna punkt. Standard följer checklisttypen.",
            "quality.checklist.type.addRow": "Ny punkt",
            "quality.checklist.type.deleteRowConfirm": "Ta bort denna punkt?",
            "quality.checklist.type.customFieldsTitle": "Anpassade fält",
            "quality.checklist.type.customFieldsHint":
                "Lägg till inmatningsfält som måste fyllas i vid genomförande av denna punkt (t.ex. uppmätt ström, återvinningsgrad).",
            "quality.checklist.type.customFieldLabel": "Etikett",
            "quality.checklist.type.customFieldType": "Typ",
            "quality.checklist.type.customFieldUnit": "Enhet",
            "quality.checklist.type.customFieldPlaceholder": "Platshållartext",
            "quality.checklist.type.customFieldRequired": "Obligatorisk",
            "quality.checklist.type.customFieldAdd": "Lägg till fält",
            "quality.checklist.type.customFieldTypes.text": "Text",
            "quality.checklist.type.customFieldTypes.number": "Tal",
            "quality.checklist.type.customFieldTypes.textarea": "Lång text",
            "quality.checklist.actions.performed": "Utförd",
            "quality.checklist.actions.approved": "Godkänd",
            "quality.checklist.actions.na": "Ej aktuellt",
            "quality.checklist.actions.deviation": "Avvikelse",
            "quality.checklist.item.title": "Titel",
            "quality.checklist.item.guidanceTitle": "Vägledning",
            "quality.checklist.item.completionNote": "Anteckningar / observerat",
            "quality.checklist.item.deviationNoteRequired": "Lägg till en kort förklaring av avvikelsen.",
            "quality.checklist.item.responseLabel": "Utfall",
            "quality.checklist.item.customFieldsTitle": "Mätningar / data",
            "quality.checklist.item.customFieldRequired": "Detta fält är obligatoriskt",
            "quality.checklist.item.customFieldsRequiredBeforeOutcome":
                "Fyll i obligatoriska fält innan du väljer utfall.",
            "report.type.required": "Rapporttyp krävs",
            "work Order": "Arbeidsordre",
            "service Agreement": "Serviceavtal",
            "project": "Prosjekt",
            "project_plan": "Projektplan",
            "projects_plan": "Projektplan",
            "projects_accounting": "Projektredovisning",
            "project.details": "Projektdetaljer",
            "project.edit": "Redigera projekt",
            "project.item_list.summary_title": "Varlistor — sammanfattning",
            "project.item_list.summary_total_quantity": "Total kvantitet (netto)",
            "project.item_list.summary_total_purchase": "Totalt inköp",
            "project.item_list.summary_total_sales": "Totalt försäljning",
            "project.item_list.view_items_summary": "Vis varusammanfattning",
            "project.item_list.items_summary_page_title": "Varlistor — sammanfattning",
            "project.item_list.items_summary_subtitle":
              "Kvantiteter och priser över alla listor i detta projekt",
            "project.item_list.items_summary_intro":
              "Rader slås ihop per artikelnummer (produkter utan nummer grupperas per produkt). Returlister minskar nettokvantitet och belopp.",
            "project.item_list.items_summary_table_item_number": "Art.nr",
            "project.summary.invoiced_ex_vat_basis": "fakturerat (exkl. moms)",
            "project.summary.margin_on_invoiced_hint": "Baserat på fakturerat exkl. moms",
            "project.summary.of": "av",
            "project.summary.invoicing_rate_no_contract": "Ej definierat utan kontraktssumma",
            "project.summary.cost_rate_on_invoiced_hint": "mot fakturerat exkl. moms",
            "project.invoices.totals.invoiced_ex_vat": "Totalt fakturerat (exkl. moms)",
            "project.invoices.pagination.showing": "Visar {{from}}–{{to}} av {{total}}",
            "project.invoices.pagination.load_more": "Ladda fler fakturor",
            "project.invoices.pagination.loading_more": "Laddar…",
            "project.invoices.pagination.loaded_of_total": "{{loaded}} av {{total}} fakturor visade",
            "project.invoices.pagination.all_loaded": "Alla {{total}} fakturor är inlästa",
            "project.invoices.create_disabled_hint": "Det går inte att skapa faktura här ännu",
            "project.invoices.pagination.prev": "Föregående",
            "project.invoices.pagination.next": "Nästa",
            "project.activities.tab_title": "Aktiviteter",
            "project.activities.tab_hint":
              "Lämna titelfältet (Tab eller klick utanför) för att spara en ny rad. Nästa nummer sätts automatiskt; Tripletex-rader hanteras i bakgrunden.",
            "project.activities.search_label": "Sök",
            "project.activities.search_placeholder":
              "Sök titel, nummer, beskrivning…",
            "project.activities.filter_label": "Filter",
            "project.activities.filter_all": "Alla",
            "project.activities.filter_standard": "Endast standard",
            "project.activities.filter_additional": "Endast tilläggsarbete",
            "project.activities.add_quick": "Ny rad",
            "project.activities.draft_title_placeholder":
              "Titel — Tab för att spara och lägga till nästa",
            "project.activities.deleted": "Aktivitet borttagen",
            "project.activities.title": "Aktiviteter",
            "project.activities.description":
              "Rader som används för timmar och prisuppskattningar. Hantera dem under fliken Aktiviteter på projektet.",
            "project.activities.description_field": "Beskrivning",
            "project.activities.activity_line": "Tripletex-aktivitetsrad",
            "project.activities.activity_line_hint":
              "Valfritt. Kopplar raden till en projektaktivitetsrad i Tripletex.",
            "project.activities.is_additional": "Tillägg",
            "project.activities.title_required": "Titel krävs",
            "project.activities.delete_error": "Kunde inte ta bort aktivitet",
            "project.activities.add": "Lägg till aktivitet",
            "project.activities.add_first": "Lägg till första aktivitet",
            "project.activities.edit": "Redigera aktivitet",
            "project.activities.delete": "Ta bort aktivitet",
            "project.activities.delete_confirm":
              "Är du säker på att du vill ta bort denna aktivitet?",
            "project.activities.none": "Inga aktiviteter tillagda ännu.",
            "project.activities.activity": "Aktivitet",
            "project.activities.number": "Nummer",
            "project.activities.budget_hours": "Budgettimmar",
            "project.activities.budget_fee": "Budgetarvode",
            "project.activities.invoiceable": "Fakturerbar",
            "project.activities.error_loading": "Fel vid inläsning av aktiviteter",
            "project.activities.updated": "Aktivitet uppdaterad",
            "project.activities.created": "Aktivitet tillagd",
            "project.activities.save_error": "Kunde inte spara aktivitet",
            "project.activities.activity_required": "Aktivitet krävs",
            "project.activities.title_field": "Titel",
            "project.activities.start_date": "Startdatum",
            "project.activities.end_date": "Slutdatum",
            "project.activities.budget_fee_rate": "Budgetarvodesgrad",
            "project.activities.inactive": "Inaktiv",
            "project.activities.updating": "Uppdaterar…",
            "project.activities.adding": "Lägger till…",
            "project.activities.summary_title": "Översikt",
            "project.activities.summary_hours": "Timmar (rapporterat / budget)",
            "project.activities.summary_activities_done": "Slutförda aktiviteter",
            "project.activities.summary_budget_fee": "Summa budgetarvode",
            "project.activities.summary_budget_fee_hint": "Summa av budgetarvode på alla aktiviteter (referens).",
            "project.activities.hours_unit": "h",
            "project.activities.hours_unit_short": "h",
            "project.activities.of_total_budget_hours": "av budgeterade timmar (projekt)",
            "project.activities.completed_label": "slutförda",
            "project.activities.currency_nok": "NOK",
            "project.activities.mode_view": "Visningsläge",
            "project.activities.mode_edit": "Redigeringsläge",
            "project.activities.status_label": "Status",
            "project.activities.status.open": "Öppen",
            "project.activities.status.in_progress": "Pågår",
            "project.activities.status.completed": "Slutförd",
            "project.activities.status.on_hold": "Pausad",
            "project.activities.edit_dialog_title": "Aktivitet",
            "project.activities.progress_section": "Framsteg",
            "project.activities.logged_vs_budget": "{{logged}} h rapporterat · {{budget}} h budget",
            "project.activities.of_budget_hours": "av aktivitetens budgettimmar",
            "project.activities.linked_work_orders": "{{count}} kopplad(e) arbetsorder(r)",
            "project.activities.linked_work_orders_label": "Arbetsordrar på aktiviteten",
            "project.activities.no_description": "Ingen beskrivning.",
            "project.activities.period": "Period",
            "project.activities.new_work_order": "Ny arbetsorder",
            "project.activities.open_work_orders_tab": "Öppna fliken Arbetsordrar",
            "project.activities.open_time_tab": "Öppna tidsregistrering",
            "project.activities.logged_short": "Rapporterat",
            "project.activities.status_progress_title": "Status och framsteg",
            "project.plan.title": "Projektplan",
            "project.plan.subtitle": "Planera och hantera projekthändelser",
            "project.plan.select_project": "Välj projekt",
            "project.plan.project": "Projekt",
            "project.plan.no_events": "Inga händelser i denna period",
            "project.plan.total": "Totalt",
            "project.plan.loading": "Laddar händelser...",
            "project.plan.week": "Vecka",
            "project.plan.resource_capacity": "Resurskapacitet",
            "project.plan.resource_capacity_subtitle":
              "Jämför resursplanen från Timmar med planerade projekthändelser och arbetsordrar i vald period.",
            "project.plan.loading_resource_plan": "Laddar resursplan...",
            "project.plan.capacity.events": "Händelser",
            "project.plan.capacity.available": "Tillgängliga",
            "project.plan.capacity.assigned": "Allokerade",
            "project.plan.capacity.scheduled_hours": "Arbetsplantimmar",
            "project.plan.capacity.free_hours": "Lediga timmar",
            "project.plan.capacity.assigned_of_available": "{{assigned}} av {{available}} resurser använda",
            "project.plan.capacity.free_hours_value": "{{hours}} t ledigt",
            "project.plan.capacity.events_value": "{{count}} händelse(r)",
            "project.time_registration.loading": "Laddar tidsregistreringar…",
            "project.time_registration.list_title": "Tidsregistrering — {{title}}",
            "project.time_registration.filter": "Filter",
            "project.time_registration.date_from": "Från datum",
            "project.time_registration.date_to": "Till datum",
            "project.time_registration.empty":
              "Inga tidsregistreringar hittades för detta projekt",
            "project.time_registration.registrations": "registreringar",
            "project.time_registration.no_activity": "Ingen aktivitet",
            "project.time_registration.approved_section": "Godkända timmar",
            "project.time_registration.approved_section_hint":
              "Dessa timmar är godkända och ingår i summor och timkostnader ovan.",
            "project.time_registration.excluded_section":
              "Ej godkända eller väntar på godkännande",
            "project.time_registration.excluded_section_hint":
              "Timmar som inte är godkända räknas inte med i summor eller timkostnader.",
            "project.time_registration.no_approved_in_range":
              "Inga godkända timmar i vald period.",
            "project.time_registration.total_approved_hours": "Godkända (i summa)",
            "project.time_registration.total_excluded_hours": "Utanför summa",
            "project.time_registration.summary_approved_label":
              "Totalt godkända timmar (summering)",
            "project.time_registration.summary_excluded_note":
              "{{hours}} timmar är inte godkända och räknas inte med.",
            "project.time_registration.badge_approved": "Godkänd",
            "project.time_registration.badge_rejected": "Ej godkänd",
            "project.time_registration.badge_pending": "Väntar på godkännande",
            "project.time_registration.approve": "Godkänn",
            "project.time_registration.reject": "Avvisa",
            "project.time_registration.open_hour": "Redigera timme",
            "project.time_registration.process_dialog": "Hantera timme",
            "absence": "Fravær",
            "Week": "Uke",
            "Day": "Dag",
            "Filters": "Filter",
            "Project Filter": "Projektfilter",
            "Activity Filter": "Aktivitetsfilter",
            "All Projects": "Alla projekt",
            "All Activities": "Alla aktiviteter",
            "Clear Filters": "Rensa filter",
            "No hours recorded for this day":
              "Inga timmar registrerade för denna dag",
            "entries": "poster",
            "Loading hours...": "Laddar timmar...",
            "already_registered_hours_for_event": "Redan registrerade timmar på denna händelse",
            "dashboard_report.status.planned": "Planerad",

            "company_guide.badge": "Företagsguide",
            "company_guide.hours.title": "Tidsregistrering, frånvaro och arbetsschema",
            "company_guide.hours.subtitle":
              "Checklista för administratörer med Timmar-modulen (visas i användarguiden för timmar).",
            "company_guide.hours.progress_label": "Status",
            "company_guide.hours.progress_loading": "Laddar…",
            "company_guide.hours.progress_error": "Kunde inte hämta status. Uppdatera sidan.",
            "company_guide.hours.progress_summary_ok": "{{done}} av {{total}} rekommenderade steg är på plats.",
            "company_guide.hours.progress_summary_warnings":
              "{{done}} av {{total}} rekommenderade steg är på plats. {{warnings}} punkt(er) behöver fortfarande uppmärksamhet.",
            "company_guide.hours.footer_hint":
              "Legacy Activity/ActivityItem används främst mot Tripletex-synk, inte som primär tidsregistrering i Promang.",
            "company_guide.hours.footer_link_settings": "Öppna Timmar → Inställningar",
            "company_guide.hours.link.scroll_to_explanation": "Läs förklaringen nedan",
            "company_guide.hours.link.settings_section": "Öppna i inställningar",
            "company_guide.hours.link.work_schedule": "Öppna schema",
            "company_guide.hours.task.registration_model.title": "Tidsregistrering och projektrader",
            "company_guide.hours.task.registration_model.info":
              "Projekttimmar kräver project_activity på projektet. Activity/ActivityItem är legacy i gränssnittet och används för Tripletex-synk.",
            "company_guide.hours.task.absence_types.title": "Frånvarotyper",
            "company_guide.hours.task.absence_types.ok": "{{count}} frånvarotyp(er) definierade.",
            "company_guide.hours.task.absence_types.warn":
              "Skapa frånvarotyper som matchar ert arbetssätt (semester, sjuk, kompledighet …).",
            "company_guide.hours.task.absence_types.unknown": "Kunde inte verifiera frånvarotyper automatiskt.",
            "company_guide.hours.task.handlers.title": "Ansvar för timmar och frånvaro",
            "company_guide.hours.task.handlers.ok": "Handläggare för timmar och frånvaro är satta.",
            "company_guide.hours.task.handlers.warn":
              "Ange vem som hanterar tidrapporter och egna frånvaromeldingar.",
            "company_guide.hours.task.work_schedule.title": "Arbetsschema och sysselsättningsgrad",
            "company_guide.hours.task.work_schedule.info":
              "Se till att varje anställd har arbetsschema som stämmer med tjänsten; det påverkar planerade timmar och frånvaro.",
            "company_guide.hours.task.work_schedule.ok": "Arbetsscheman finns och anställda är kopplade.",
            "company_guide.hours.task.work_schedule.warn_none": "Skapa minst ett företagsarbetsschema.",
            "company_guide.hours.task.work_schedule.warn_unassigned":
              "{{count}} aktiv(a) anställd(a) saknar arbetsschema.",
            "company_guide.hours.link.work_schedule_admin": "Hantera arbetsscheman",

            "company_guide.company.badge": "Företagsguide",
            "company_guide.company.heading": "Grundläggande företagsinställningar",
            "company_guide.company.subtitle":
              "Logotyp, kontakt, adresser och villkorslänkar ger trygghet i kunddialog, offerter och webbhandel.",
            "company_guide.company.progress_label": "Status",
            "company_guide.company.progress_loading": "Laddar…",
            "company_guide.company.progress_error": "Kunde inte hämta företagsdata. Uppdatera sidan.",
            "company_guide.company.progress_ok": "{{done}} av {{total}} rekommenderade punkter är på plats.",
            "company_guide.company.progress_warnings":
              "{{done}} av {{total}} rekommenderade punkter är på plats. {{warnings}} behöver åtgärd.",
            "company_guide.company.footer_hint":
              "Ändringar görs under Företag → Inställningar. Checklistan uppdateras när du sparar.",
            "company_guide.company.link.settings": "Öppna företagsinställningar",
            "company_guide.company.task.name.title": "Företagsnamn",
            "company_guide.company.task.name.warn": "Företagsnamn bör fyllas i.",
            "company_guide.company.task.name.ok": "Företagsnamn verkar vara ifyllt.",
            "company_guide.company.task.logo.title": "Logotyp",
            "company_guide.company.task.logo.warn": "Lägg till logotyp för dokument, offerter och kundvy.",
            "company_guide.company.task.logo.ok": "Logotyp är registrerad.",
            "company_guide.company.task.contact.title": "Kontaktinformation",
            "company_guide.company.task.contact.warn": "Ange minst en av e-post, telefon eller mobil.",
            "company_guide.company.task.contact.ok": "Minst en kontaktkanal är satt.",
            "company_guide.company.task.address.title": "Adress",
            "company_guide.company.task.address.warn": "Lägg in företags- eller postadress.",
            "company_guide.company.task.address.ok": "Adress är registrerad.",
            "company_guide.company.task.sales_conditions_url.title": "Försäljningsvillkor (URL)",
            "company_guide.company.task.sales_conditions_url.warn":
              "Länk till försäljningsvillkor saknas — viktigt för offerter och webbhandel.",
            "company_guide.company.task.sales_conditions_url.ok": "Länk till försäljningsvillkor är satt.",
            "company_guide.company.task.vat.title": "Moms / org.nr",
            "company_guide.company.task.vat.warn": "Organisationsnummer / moms bör fyllas i.",
            "company_guide.company.task.vat.ok": "Org.nr / moms är registrerat.",

            "dashboard.company_guide.alert_company_title": "Företagsprofil behöver uppmärksamhet",
            "dashboard.company_guide.alert_company_subtitle":
              "{{count}} punkt(er) i företagsguiden bör åtgärdas.",
            "dashboard.company_guide.alert_hours_title": "Timinställningar behöver uppmärksamhet",
            "dashboard.company_guide.alert_hours_subtitle":
              "{{count}} punkt(er) i timguiden bör åtgärdas.",
            "dashboard.company_guide.alert_cta": "Öppna guide och checklista",

            "user_guide.hub.card.company.title": "Företag och inställningar",
            "user_guide.hub.card.company.description":
              "Logotyp, kontakt, adresser, försäljningsvillkor och annat som bör finnas på plats.",

            "user_guide.company.back_to_hub": "Tillbaka till användarguiden",
            "user_guide.company.badge": "Företag",
            "user_guide.company.title": "Företagsinställningar och profil",
            "user_guide.company.intro":
              "Rätt företagsinformation spelar roll för kunder, offerter och integrationer. Som administratör bör du gå igenom checklistan nedan och fylla luckor.",
            "user_guide.company.section.why.title": "Varför detta är viktigt",
            "user_guide.company.section.why.p1":
              "Logotyp och kontaktuppgifter förväntas där ni möter kunder och leverantörer.",
            "user_guide.company.section.why.p2":
              "Adress och försäljningsvillkor krävs ofta i avtal, webbhandel och dokumentexport.",
            "user_guide.company.section.where.title": "Var du gör ändringar",
            "user_guide.company.section.where.p1":
              "Gå till Företag → Inställningar. Använd länkarna i checklistan för att hoppa till rätt avsnitt.",

            "user_employment.work_schedule_label": "Arbetsschema (timmar)",
            "user_employment.work_schedule_hint":
              "Används för tidregistrering, planerad tid och frånvaro. Skapa scheman under Timmar → Arbetsscheman.",
            "user_employment.work_schedule_none": "Inget valt",

            "work_schedules_admin.title": "Arbetsscheman",
            "work_schedules_admin.intro":
              "Skapa och underhåll scheman (timmar per veckodag). Nya anställda får senast skapade schema som standard om inget annat tilldelas.",
            "work_schedules_admin.summary_title": "Översikt",
            "work_schedules_admin.summary_plans": "{{count}} arbetsschema i företaget.",
            "work_schedules_admin.summary_unassigned_ok": "Alla aktiva anställda har arbetsschema.",
            "work_schedules_admin.summary_unassigned_warn":
              "{{count}} aktiv(a) anställd(a) saknar arbetsschema — tilldela under användarprofilen.",
            "work_schedules_admin.assign_hint": "Tilldela på anställd:",
            "work_schedules_admin.assign_link": "Användare / anställda",
            "work_schedules_admin.new": "Nytt arbetsschema",
            "work_schedules_admin.edit": "Redigera",
            "work_schedules_admin.delete": "Ta bort",
            "work_schedules_admin.save": "Spara",
            "work_schedules_admin.saving": "Sparar…",
            "work_schedules_admin.cancel": "Avbryt",
            "work_schedules_admin.field_name": "Namn (valfritt)",
            "work_schedules_admin.field_name_placeholder": "T.ex. Kontor 7,5h",
            "work_schedules_admin.empty": "Inga arbetsscheman ännu — skapa ett för att komma igång.",
            "work_schedules_admin.unnamed": "Utan namn",
            "work_schedules_admin.confirm_delete": "Ta bort «{{name}}»? Kan inte tas bort om det används.",
            "work_schedules_admin.created": "Arbetsschema skapat",
            "work_schedules_admin.saved": "Arbetsschema sparat",
            "work_schedules_admin.deleted": "Arbetsschema borttaget",
            "work_schedules_admin.load_error": "Kunde inte hämta arbetsscheman",
            "work_schedules_admin.save_error": "Kunde inte spara",
            "work_schedules_admin.delete_error": "Kunde inte ta bort",
            "work_schedules_admin.back_guide": "Tillbaka till användarguide (timmar)",
            "work_schedules_admin.day.monday": "Måndag",
            "work_schedules_admin.day.tuesday": "Tisdag",
            "work_schedules_admin.day.wednesday": "Onsdag",
            "work_schedules_admin.day.thursday": "Torsdag",
            "work_schedules_admin.day.friday": "Fredag",
            "work_schedules_admin.day.saturday": "Lördag",
            "work_schedules_admin.day.sunday": "Söndag",

            "work_schedule_view.page_title": "Schema",
            "work_schedule_view.fallback_title": "Arbetsschema",
            "work_schedule_view.subtitle": "Timmar per veckodag justerade för sysselsättningsgrad",
            "work_schedule_view.empty": "Inget arbetsschema är kopplat till din anställning ännu.",
            "work_schedule_view.empty_hint":
              "Be en administratör skapa ett schema och tilldela det på din användar-/anställningsprofil.",
            "work_schedule_view.link_users": "Gå till användare",
            "work_schedule_view.day_off": "Ledig",
            "work_schedule_view.hours_value": "{{hours}} timmar",
            "work_schedule_view.day.monday": "Måndag",
            "work_schedule_view.day.tuesday": "Tisdag",
            "work_schedule_view.day.wednesday": "Onsdag",
            "work_schedule_view.day.thursday": "Torsdag",
            "work_schedule_view.day.friday": "Fredag",
            "work_schedule_view.day.saturday": "Lördag",
            "work_schedule_view.day.sunday": "Söndag",

            "hour_settings.page.subtitle":
              "Frånvaro, godkännandeflöde, lönelås och övriga inställningar för tid (projekttimmar bygger på project_activity på projektet).",
            "hour_settings.guide.title": "Kom igång med timmar",
            "hour_settings.guide.intro":
              "Samma steg som på instrumentpanelen. Tidsregistrering bygger på projekt och project_activity; listorna över generella aktiviteter här är valfri administration och inget uppstartssteg.",
            "hour_settings.guide.step.project_activity":
              "Projekttimmar: säkerställ project_activity (och projekt) där personal ska föra tid — det är vad nuvarande Promang kräver för projektregistrering.",
            "hour_settings.guide.step.absence_types": "Frånvarotyper: skapa och underhåll de typer ni använder.",
            "hour_settings.guide.step.handlers":
              "Sätt administratör för timmar och för egna frånvaromeldingar.",
            "hour_settings.guide.step.payroll_lock":
              "Överväg låsning av lönperiod och utbetalningsdag när rutiner finns.",
            "hour_settings.guide.step.time_documents":
              "Valfritt — dokumentation på fristående tidrader utan kopplad servicerapport eller arbetsorder.",
            "hour_settings.guide.step.work_schedule":
              "Skapa arbetsscheman under Timmar → Arbetsscheman och koppla dem till anställda (användarprofiler).",
            "hour_settings.guide.back_dashboard": "Tillbaka till startsidan",
            "hour_settings.guide.open_user_guide": "Användarguide: timmar och frånvaro",

            "hour_settings.time_documents.section_title": "Bilagor på tidrader",
            "hour_settings.time_documents.section_description":
              "Tillåt att bifoga bilder/filer till frittstående tidrader när raden inte är kopplad till servicerapport eller arbetsorder.",
            "hour_settings.time_documents.enabled": "Tillåt dokumentation (bilder/filer) via tidregistrering",

            "hour.time_documents.title": "Dokumentation",
            "hour.time_documents.subtitle": "Bilder och filer kopplade till denna timrad.",
            "hour.time_documents.help_save_first": "Spara tidraden innan du kan bifoga filer.",
            "hour.time_documents.pending_hint":
              "Lägg till filer här. De laddas upp automatiskt när tidraden sparas.",
            "hour.time_documents.pending_add": "Lägg till filer",
            "hour.time_documents.pending_count": "{{count}} fil(er) väntar på uppladdning",
            "hour.time_documents.pending_remove": "Ta bort",
            "hour.time_documents.pending_file_type_denied": "Filtypen är inte tillåten.",
            "hour.time_documents.pending_upload_done": "Bilagor har laddats upp",
            "hour.time_documents.pending_upload_failed":
              "Timraden sparades, men uppladdning av bilagor misslyckades. Stäng och öppna timraden igen för att försöka på nytt.",
            "hour.time_documents.blocked_linked":
              "Dokumentation är inte möjlig när timraden kopplats till rapport eller arbetsorder.",
            "hour.time_documents.blocked_lock": "Perioden är låst; bilagor kan inte ändras.",

            "user_guide.hub.badge": "Användarguide",
            "user_guide.hub.title": "Så använder du Promang",
            "user_guide.hub.subtitle":
              "Steg-för-steg-guider för administratörer och personal. Innehållet uppdateras i appen — teknisk utvecklardokumentation finns separat.",
            "user_guide.hub.card.hours.title": "Timmar, frånvaro och arbetsschema",
            "user_guide.hub.card.hours.description":
              "Uppstart: frånvarotyper, ansvariga, lönelås, påminnelser och arbetsschema.",
            "user_guide.hub.footer_note": "Behöver du mer svar? Prova resurscentrets FAQ.",

            "dashboard.company_guide.hours_teaser_title": "Timmar och frånvaro",
            "dashboard.company_guide.hours_teaser_subtitle":
              "Uppstartsstatus och full guide finns i användarguiden — inte på startsidan.",
            "dashboard.company_guide.hours_teaser_cta": "Öppna status och guide",

            "user_guide.hours.back_to_hub": "Tillbaka till användarguiden",
            "user_guide.hours.checklist.badge": "Uppstart",
            "user_guide.hours.checklist.heading": "Status för uppsättning (Timmar-modulen)",
            "user_guide.hours.checklist.subtitle":
              "Endast synligt för administratörer. Varje rad länkar till inställningar eller mer information längre ned på sidan.",
            "user_guide.hours.badge": "Timmar och frånvaro",
            "user_guide.hours.title": "Timmar, frånvaro och arbetsschema",
            "user_guide.hours.purpose":
              "Guiden hjälper nya företag och administratörer att sätta upp frånvaro, ansvariga och arbetsschema. Checklistan på instrumentpanelen (endast admin) länkar hit för detaljer.",

            "user_guide.hours.section.registration.title": "Tidsregistrering i Promang",
            "user_guide.hours.section.registration.p1":
              "Projekttimmar ska kopplas till ett projekt och en projektrad (project activity). Det styr tidsregistrering i arbetsytan.",
            "user_guide.hours.section.registration.p2":
              "Äldre begrepp Activity och ActivityItem används i bakgrunden mot ekonomisystem (t.ex. Tripletex-synk). De är inte det du normalt väljer när du registrerar tid i gränssnittet.",
            "user_guide.hours.section.registration.p3":
              "Listor med «generella aktiviteter» under Timmar → Inställningar kan användas för administration men är inget separat krav i uppstartschecklistan på instrumentpanelen.",

            "user_guide.hours.section.visibility.title": "Vem ser vad?",
            "user_guide.hours.section.visibility.li1":
              "På startsidan visas bara en kort länk för administratörer när Timmar är aktiv. Full status och checklista finns här i användarguiden.",
            "user_guide.hours.section.visibility.li2":
              "Alla som har tillgång till Timmar → Inställningar ser den korta hjälpen högst upp på inställningssidan.",

            "user_guide.hours.section.steps.title": "Rekommenderad ordning",
            "user_guide.hours.section.steps.s1.title": "1. Frånvarotyper",
            "user_guide.hours.section.steps.s1.where": "Gå till Timmar → Inställningar → Frånvarotyper.",
            "user_guide.hours.section.steps.s1.b1":
              "Skapa typer som passar: semester, sjuk, egenanmälan, kompledighet, ledighet med mera.",
            "user_guide.hours.section.steps.s1.b2":
              "Frånvaro registreras mot dessa typer. Vem som godkänner egenanmälan beror på roller och vem ni sätter som frånvaroansvarig.",

            "user_guide.hours.section.steps.s2.title": "2. Ansvar för timmar och frånvaro",
            "user_guide.hours.section.steps.s2.where": "Gå till Timmar → Inställningar → Hantering av timmar och frånvaro.",
            "user_guide.hours.section.steps.s2.b1":
              "Timmar: välj gärna den som ska godkänna tidrapporter och följa upp avvikelser.",
            "user_guide.hours.section.steps.s2.b2":
              "Egenanmälan / frånvaro: välj den som ska hantera egenanmälningar (ofta HR eller närmaste chef).",
            "user_guide.hours.section.steps.s2.b3": "Sätt båda tidigt så medarbetare vet vem som följer upp.",

            "user_guide.hours.section.steps.s3.title": "3. Låsning av lönperiod (valfritt)",
            "user_guide.hours.section.steps.s3.where": "Gå till Timmar → Inställningar → Låsning av lönperiod.",
            "user_guide.hours.section.steps.s3.b1":
              "När rutinerna finns kan ni låsa månad vid periodslut och sätta utbetalningsdag enligt lön.",
            "user_guide.hours.section.steps.s3.b2":
              "Låsta perioder begränsar ändringar bakåt i tid; undantag hanteras av dem som har upplåsningsrättigheter där det är aktiverat.",

            "user_guide.hours.section.steps.s4.title": "4. Påminnelser om timmar (valfritt)",
            "user_guide.hours.section.steps.s4.where": "Gå till Timmar → Inställningar → Påminnelse om timmar.",
            "user_guide.hours.section.steps.s4.b1": "Slå på daglig påminnelse och sätt tider om ni vill påminna om tidsregistrering.",
            "user_guide.hours.section.steps.s4.b2":
              "Utgående e-post måste vara konfigurerad i drift (schemalagda jobbar) — fråga administratör eller leverantör om detta är aktivt.",

            "user_guide.hours.section.steps.s5.title": "5. Arbetsschema och sysselsättningsgrad",
            "user_guide.hours.section.steps.s5.where": "Använd Schema och användarprofiler under Användare.",
            "user_guide.hours.section.steps.s5.b1":
              "Varje anställd bör ha arbetsschema som stämmer med tjänsten — det påverkar förväntad tid och planering.",
            "user_guide.hours.section.steps.s5.b2": "Kalender och uppföljning av frånvaro förutsätter att detta finns på plats.",

            "user_guide.hours.section.related.title": "Snabbvägar",
            "user_guide.hours.section.related.link_hours": "Timlista",
            "user_guide.hours.section.related.link_approval": "Godkännande av timmar",
            "user_guide.hours.section.related.link_absence": "Frånvaroöversikt",
            "user_guide.hours.section.related.link_monthly": "Månadsöversikt timmar",
            "user_guide.hours.section.related.link_settings": "Inställningar för timmar",

            "user_guide.hours.section.more_help.title": "Mer hjälp",
            "user_guide.hours.section.more_help.p1":
              "Om något inte finns här kan resurscentrets FAQ eller support hjälpa vidare.",
            "user_guide.hours.section.more_help.faq_link": "Öppna FAQ i resurscentret",

            "Time Registration": "Tidsregistrering",
            "Registered hours": "Registrerade timmar",
            "Hours Overview": "Timmar Översikt",
            "Track and manage work hours": "Spåra och hantera arbetstimmar",
            "Select Employee": "Välj Anställd",
            "Set Date": "Sätt datum",
            "Today": "Idag",
            "Calendar": "Kalender",
      
            // Work Statistics translations
            "Work Statistics": "Arbetsstatistik",
            "Overview of your work hours and performance":
              "Översikt över dina arbetstimmar och prestation",
            "Something went wrong while loading work stats":
              "Något gick fel vid laddning av arbetsstatistik",
            "Could not load work statistics": "Kunde inte ladda arbetsstatistik",
            "No data available": "Ingen data tillgänglig",
            "No work statistics found for this user.":
              "Ingen arbetsstatistik hittades för denna användare.",
            "Expected This Week": "Förväntat denna vecka",
            "Worked This Week": "Arbetat denna vecka",
            "Worked This Month": "Arbetat denna månad",
            "Earned Time Off": "Intjänad ledighet",
            "Weekly Progress": "Veckans framsteg",
            "Hours worked this week": "Timmar arbetade denna vecka",
            "Remaining": "Återstående",
            "Overtime": "Övertid",
            "Weekly Goal": "Veckomål",
            "Completed": "Slutförd",
            "In Progress": "Pågående",
            "Under Target": "Under mål",
            "On Track": "På rätt spår",
            "Efficiency": "Effektivitet",
      
            // Vehicle translations
            "Vehicle handbook": "Fordonhandbok",
            "Check in to a vehicle to open its handbook from this menu.":
              "Checka in på ett fordon för att öppna handboken från den här menyn.",
            "Vehicle handbook could not be opened. Try again or contact an administrator.":
              "Fordonhandboken kunde inte öppnas. Försök igen eller kontakta en administratör.",
            "Go to trips": "Gå till resor",
            "Vehicle handbook entry subtitle":
              "Checka in och öppna sedan handboken för det fordon du är incheckad på.",
            "Vehicle handbook check in": "Checka in på fordon",
            "Vehicle handbook check in hint":
              "Välj ett fordon att checka in på; du skickas sedan till handboken.",
            "Vehicle handbook not a driver":
              "Du är inte registrerad som förare i företaget. Kontakta en administratör om du behöver körtillgång.",
            "Vehicle handbook no vehicles permission":
              "Du behöver behörighet till fordonslistan för att checka in här. Du kan fortfarande checka in från Resor eller instrumentpanelen om det finns.",
            "Vehicle Information": "Fordoninformation",
            "Number Plate": "Registreringsnummer",
            "VIN (Chassis Number)": "VIN (Chassisnummer)",
            "Make": "Märke",
            "Model": "Modell",
            "Model Year": "Årsmodell",
            "Body Style": "Karossstil",
            "Nickname": "Smeknamn",
            "Current Odometer (km)": "Nuvarande mätarställning (km)",
            "Statens Vegvesen Information": "Statens Vegvesen Information",
            "Norwegian Vehicle Authority Information": "Norska Vägverket Information",
            "Registration Date": "Registreringsdatum",
            "First Registration": "Första registrering",
            "Vehicle Type": "Fordonstyp",
            "Fuel Type": "Bränsletyp",
            "Engine Size (cc)": "Motoreffekt (cc)",
            "Power (kW)": "Effekt (kW)",
            "Inspection Information": "Besiktningsinformation",
            "EU-kontroll / Periodic Vehicle Inspection":
              "EU-kontroll / Periodisk fordonbesiktning",
            "Last Inspection Date": "Senaste besiktningsdatum",
            "Next Inspection Date": "Nästa besiktningsdatum",
            "Inspection Result": "Besiktningsresultat",
            "Inspection Station": "Besiktningsstation",
            "Insurance Information": "Försäkringsinformation",
            "Vehicle Insurance Details": "Fordonförsäkring Detaljer",
            "Insurance Company": "Försäkringsbolag",
            "Policy Number": "Policenummer",
            "Insurance Start Date": "Försäkring startdatum",
            "Insurance End Date": "Försäkring slutdatum",
            "Insurance Type": "Försäkringstyp",
            "Annual Premium (NOK)": "Årlig premie (NOK)",
            "Service Information": "Serviceinformation",
            "Maintenance and Service Details": "Underhåll och Service Detaljer",
            "Last Service Date": "Senaste servicedatum",
            "Next Service Date": "Nästa servicedatum",
            "Service Interval (km)": "Serviceintervall (km)",
            "Service Provider": "Serviceleverantör",
            "Warranty End Date": "Garanti slutdatum",
            "Warranty Type": "Garantityp",
            "Damage Reports": "Skaderapporter",
            "Vehicle Damage History": "Fordon Skadehistorik",
            "Damage reports will be implemented in the future":
              "Skaderapporter kommer att implementeras i framtiden",
            "Internal Controls": "Interna kontroller",
            "Company Internal Vehicle Controls":
              "Företagets Interna Fordonskontroller",
            "Last Internal Check": "Senaste interna kontroll",
            "Next Internal Check": "Nästa interna kontroll",
            "Safety Equipment Status": "Säkerhetsutrustning Status",
            "Vehicle Status": "Fordonstatus",
            "Trips": "Turer",
            "Service": "Service",
            "Documents": "Dokument",
            "Vehicle": "Fordon",
            "Vehicle Documents": "Fordon Dokument",
            "Manage vehicle documents and files": "Hantera fordon dokument och filer",
            "Vehicle Trips": "Fordon Turer",
            "trips found": "turer hittade",
            "No trips found for this vehicle": "Inga turer hittade för detta fordon",
            "Vehicle safety and maintenance checklists":
              "Fordon säkerhet och underhåll checklistor",
            "Create Checklist": "Skapa checklista",
            "Last Internal Control": "Senaste interna kontroll",
            "Checklist Number": "Checklista nummer",
            "Items Approved": "Godkända punkter",
            "Checklist Items": "Checklista punkter",
            "Approved": "Godkänd",
            "Not Approved": "Inte godkänd",
            "No checklists found": "Inga checklistor hittade",
            "Get started by creating a new checklist":
              "Börja med att skapa en ny checklista",
            "Select Checklist Type": "Välj checklista typ",
            "Choose the type of checklist you want to create for this vehicle":
              "Välj typ av checklista du vill skapa för detta fordon",
            "Create a new checklist for this project":
              "Skapa en ny checklista för detta projekt",
            "Choose the type of checklist you want to create for this project":
              "Välj typ av checklista du vill skapa för detta projekt",
            "Project checklist title": "Projektchecklista #{{number}}{{suffix}}",
            "Customer checklist title": "Kundchecklista #{{number}}{{suffix}}",
            "Folder checklist title": "Mappchecklista #{{number}}{{suffix}}",
            "Generic new checklist title": "Checklista #{{number}} ({{date}})",
            "Report checklist default title": "Rapport {{number}} - {{address}}",
            "Choose the type of checklist you want to create for this report":
              "Välj typ av checklista du vill skapa för denna rapport",
            "Choose the type of checklist you want to create for this folder":
              "Välj typ av checklista du vill skapa för denna mapp",
            "Choose the type of checklist you want to create for this customer":
              "Välj typ av checklista du vill skapa för denna kund",
            "Choose the type of checklist you want to create":
              "Välj typ av checklista du vill skapa",
            "Checklist title placeholder": "Ange en titel för checklistan",
            "Checklist title edit hint":
              "Föreslås automatiskt — ändra titeln vid behov innan du väljer typ.",
            "Enter checklist title": "Ange checklista titel",
            "No checklist types available": "Inga checklista typer tillgängliga",
            "items": "punkter",
            "Basic Information": "Grundläggande information",
            "Enter checklist basic details":
              "Ange grundläggande detaljer för checklistan",
            "Define checklist items and requirements":
              "Definiera checklista punkter och krav",
            "Show all": "Visa alla",
            "Show in new tab": "Visa i ny fane",
      
            // Personalhåndbok translations
            "Personalhåndbok": "Personalhåndbok",
            "personalhåndbok.description":
              "Tilgang till företagets riktlinjer, säkerhetsprocedurer och anställdinformation",
            "Open": "Öppna",
            "HMS Guidelines": "Rutiner",
            "Safety procedures and guidelines": "Säkerhetsprocedurer och riktlinjer",
            "Instructions": "Riktlinjer",
            "Company policies and procedures": "Företagets riktlinjer och procedurer",
            "Instruction Chapters": "Riktlinjer - Kapitel",
            "Chapter": "Kapitel",
            "Create Chapter": "Skapa kapitel",
            "Update Chapter": "Uppdatera kapitel",
            "Chapter Number": "Kapitel nummer",
            "Parent Chapter": "Överordnat kapitel",
            "Sub Chapters": "Underkapitel",
            "No chapter number": "Inget kapitel nummer",
            "Colleagues": "Kolleger",
            "Team overview and contacts": "Team översikt och kontakter",
            "Overview": "Översikt",
            "Recent HMS Guidelines": "Senaste Rutiner",
            "Recent Instructions": "Senaste Riktlinjer",
            "Recent KS/HMS Documents": "Senaste KS/HMS Dokument",
            "KS/HMS Documents": "KS/HMS Dokument",
            "employee_handbook.pending_read_ack_title":
              "KS/HMS: dokument som saknar bekräftelse",
            "employee_handbook.pending_read_ack_body":
              "Du har {count} dokument som inte bekräftats som lästa och förstådda. Öppna varje dokument och bekräfta, eller använd fullständig HMS/KS-vy.",
            "employee_handbook.all_documents_acknowledged":
              "Du har bekräftat alla KS/HMS-dokument du har tillgång till (läst och förstått).",
            "employee_handbook.read_status_acknowledged": "Läst och bekräftad",
            "employee_handbook.read_status_pending": "Saknar bekräftelse",
            "employee_handbook.read_status_creator_exempt": "Författare (undantagen)",
            "employee_handbook.go_to_documents_tab": "Gå till KS/HMS-dokument",
            "employee_handbook.open_full_document": "Öppna full sida (HMS/KS)",
            "dashboard_report.handbook_read_incomplete":
              "{pending} av {total} KS/HMS-dokument saknar bekräftelse som läst/förstått.",
            "employee_handbook.stat_line_pending":
              "{count} dokument saknar fortfarande bekräftelse som läst och förstått.",
            "Kapitler": "Kapitel",
            "Dokumenter uten kapittel": "Dokument utan kapitel",
            "Dokumenter som ikke er tilknyttet noe kapittel": "Dokument som inte är kopplade till något kapitel",
            "Søk etter dokumenter...": "Sök efter dokument...",
            "Fant {count} dokumenter": "Hittade {count} dokument",
            "Ingen dokumenter funnet": "Inga dokument hittades",
            "Prøv å endre søkeordene dine": "Försök ändra dina sökord",
            "Laster dokument...": "Laddar dokument...",
            "Ingen innhold tilgjengelig": "Inget innehåll tillgängligt",
            "Dokumenter uten bransje": "Dokument utan bransch",
            "Dokumenter uten kategori": "Dokument utan kategori",
            "Dokumenter uten bransje og kategori": "Dokument utan bransch och kategori",
            "No chapter": "Inget kapitel",
            "Employee Handbook": "Anställd Handbok",
      
            // Deviation Template translations
            "deviation.template": "Avvik mal",
            "deviation.template.select": "Velg mal",
            "deviation.template.select.description":
              "Velg en mal for å gjøre det enklere å registrere avviket",
            "deviation.template.standard": "Standard avvik",
            "deviation.template.standard.description": "Vanlig avviksregistrering",
            "deviation.form.type_category_hint":
              "Välj den kategori som bäst beskriver denna avvikelse.",
            "deviation.form.search_types": "Sök bland avvikelsetyper…",
            "deviation.form.no_matching_types": "Inga träffar bland typerna",
            "deviation.template.incident_injury": "Uønsket hendelse - Skade",
            "deviation.template.incident_injury.description":
              "Strukturert skjema for registrering av uønsket hendelse med skade",
            "deviation.template.back": "← Tilbake til maler",
      
            // Event description translations
            "deviation.event.description": "Hendelsesbeskrivelse",
            "deviation.event.description.title": "Hendelsesbeskrivelse",
            "deviation.event.description.subtitle": "Beskriv hendelsen som skjedde",
            "deviation.event.date": "Dato for hendelse",
            "deviation.event.time": "Tidspunkt",
            "deviation.event.description.field": "Beskrivelse av hendelsen",
            "deviation.event.description.placeholder":
              "Beskriv detaljert hva som skjedde...",
            "deviation.event.involved_persons": "Involverte personer",
            "deviation.event.witnesses": "Vitner",
      
            // Location translations
            "deviation.location": "Hvor skjedde hendelsen",
            "deviation.location.title": "Hvor skjedde hendelsen",
            "deviation.location.subtitle": "Angi sted og avdeling",
            "deviation.location.place": "Sted",
            "deviation.location.department": "Avdeling",
            "deviation.location.building": "Bygg/Område",
            "deviation.location.room_area": "Rom/Område",
            "deviation.location.details": "Mer detaljert beskrivelse av stedet",
            "deviation.location.details.placeholder":
              "Beskriv stedet mer detaljert...",
      
            // Categorization translations
            "deviation.categorization": "Kategorisering",
            "deviation.categorization.title": "Kategorisering av hendelsen",
            "deviation.categorization.subtitle":
              "Kategoriser hendelsen for å gjøre det enklere å analysere og følge opp",
            "deviation.categorization.category": "Kategori",
            "deviation.categorization.severity": "Alvorlighetsgrad",
            "deviation.categorization.immediate_cause": "Umiddelbar årsak",
            "deviation.categorization.underlying_cause": "Underliggende årsak",
            "deviation.categorization.details": "Mer detaljert kategorisering",
            "deviation.categorization.details.placeholder":
              "Beskriv kategoriseringen mer detaljert...",
      
            // Event categories
            "deviation.category.law_violation": "Avvik lov",
            "deviation.category.regulation_violation": "Avvik forskrift",
            "deviation.category.procedure_violation": "Brudd på rutine",
            "deviation.category.process_violation": "Brudd på prosedyre",
            "deviation.category.training_violation": "Brudd på opplæring",
            "deviation.category.information": "Informasjon",
            "deviation.category.other": "Annet",
      
            // Treatment translations
            "deviation.treatment": "Behandling",
            "deviation.treatment.title": "Behandling av hendelsen",
            "deviation.treatment.subtitle":
              "Vurder om årsakanalyse og strakstiltak er nødvendig",
            "deviation.treatment.root_cause_analysis": "Årsakanalyse",
            "deviation.treatment.immediate_actions": "Strakstiltak",
            "deviation.treatment.root_cause_analysis.details": "Årsakanalyse",
            "deviation.treatment.root_cause_analysis.placeholder":
              "Beskriv årsakanalysen...",
            "deviation.treatment.immediate_actions.details": "Strakstiltak",
            "deviation.treatment.immediate_actions.placeholder":
              "Beskriv strakstiltakene...",
            "deviation.treatment.suggested_actions": "Forslag til tiltak",
            "deviation.treatment.suggested_actions.placeholder":
              "Beskriv forslag til tiltak...",
      
            // Action translations
            "deviation.action": "Tiltak",
            "deviation.action.title": "Opprett tiltak",
            "deviation.action.subtitle":
              "Opprett og planlegg konkrete tiltak basert på analysen",
            "deviation.action.title.field": "Tiltak tittel",
            "deviation.action.deadline": "Frist",
            "deviation.action.responsible": "Ansvarlig person",
            "deviation.action.department": "Avdeling",
            "deviation.action.location": "Sted",
            "deviation.action.category": "Kategori",
            "deviation.action.description": "Beskrivelse av tiltak",
            "deviation.action.description.placeholder":
              "Beskriv tiltaket detaljert...",
            "deviation.action.health_service_cooperation":
              "Samarbeid med bedrifthelsetjenesten",
            "deviation.action.cost": "Kostnad (NOK)",
            "deviation.action.documents": "Dokumenter",
            "deviation.action.related_elements": "Tilknyttede elementer",
      
            // Action categories
            "deviation.action.category.safety": "Sikkerhet",
            "deviation.action.category.quality": "Kvalitet",
            "deviation.action.category.environment": "Miljø",
            "deviation.action.category.procedure": "Prosedyre",
            "deviation.action.category.training": "Opplæring",
            "deviation.action.category.maintenance": "Vedlikehold",
            "deviation.action.category.equipment": "Utstyr",
            "deviation.action.category.communication": "Kommunikasjon",
            "deviation.action.category.other": "Annet",
      
            // Action statuses
            "deviation.action.status.planned": "Planlagt",
            "deviation.action.status.started": "Påbegynt",
            "deviation.action.status.in_progress": "Under arbeid",
            "deviation.action.status.completed": "Fullført",
            "deviation.action.status.cancelled": "Kansellert",
            "deviation.action.status.on_hold": "På vent",
      
            // Action priorities
            "deviation.action.priority.low": "Lav",
            "deviation.action.priority.medium": "Medium",
            "deviation.action.priority.high": "Høy",
            "deviation.action.priority.critical": "Kritisk",
      
            // Form validation messages
            "deviation.event.description.required": "Hendelsesbeskrivelse er påkrevd",
            "deviation.location.required": "Sted er påkrevd",
            "deviation.category.required": "Kategori er påkrevd",
            "deviation.action.title.required": "Tiltak tittel er påkrevd",
            "deviation.action.description.required": "Beskrivelse er påkrevd",
            "deviation.action.category.required": "Kategori er påkrevd",
            "deviation.action.deadline.required": "Frist er påkrevd",
            "deviation.action.responsible.required": "Ansvarlig person er påkrevd",
      
            // Success/Error messages
            "deviation.template.saved": "Data ble lagret!",
            "deviation.action.created": "Tiltak ble opprettet!",
            "deviation.template.save_error": "Noe gikk galt. Kunne ikke lagre data!",
            "deviation.action.create_error":
              "Noe gikk galt. Kunne ikke opprette tiltak!",
      
            // Navigation
            "deviation.previous": "Forrige",
            "deviation.next": "Neste",
            "deviation.complete": "Fullfør",
            "deviation.reset": "Nullstill",
            "deviation.create_action": "Opprett tiltak",
            "deviation.saving": "Lagrer...",
      
            // Action creation dialog
            "deviation.action.create.question": "Ønsker du å opprette tiltak?",
            "deviation.action.create.description":
              "Du kan opprette konkrete tiltak med frist, ansvarlig person og beskrivelse.",
            "deviation.action.create.yes": "Ja, opprett tiltak",
            "deviation.action.create.no": "Nei, ikke nå",
            "deviation.action.notes": "Notater om tiltak (valgfritt)",
            "deviation.action.notes.placeholder":
              "Legg til notater om tiltak hvis nødvendig...",
      
            // HSE Event Form - Additional translations
            "Hendelsesdato": "Händelsedatum",
            "Hendelsestid": "Händelsetid",
            "Involverte personer beskrivelse":
              "Lista alla personer involverade i händelsen",
            "Vitner beskrivelse": "Lista eventuella vittnen till händelsen",
            "Umiddelbar årsak beskrivelse":
              "Beskriv den omedelbara orsaken till händelsen",
            "Underliggende årsak beskrivelse":
              "Beskriv den underliggande orsaken till händelsen",
            "Kategorisering beskrivelse": "Beskriv kategoriseringen mer detaljerat",
            "Årsakanalyse beskrivelse": "Beskriv orsaksanalysen",
            "Strakstiltak beskrivelse": "Beskriv omedelbara åtgärder som vidtogs",
            "Forslag til tiltak beskrivelse":
              "Beskriv förslag till åtgärder för att förhindra återkommande",
            "Tilknyttede elementer beskrivelse":
              "Länka till relaterade kunder, projekt, anställda och mappar",
            "Dokumenter beskrivelse": "Ladda upp relevanta dokument och filer",
            "Velg avdeling": "Välj avdelning",
            "Velg involverte personer": "Välj involverade personer",
            "Andre involverte personer": "Andra involverade personer",
            "Andre involverte personer beskrivelse":
              "Beskriv andra personer involverade i händelsen",
            "Beskriv andre involverte personer...":
              "Beskriv andra involverade personer...",
            "Søk etter personer...": "Sök efter personer...",
            "personer valgt": "personer valda",
            "Ingen personer funnet": "Inga personer hittades",
            "Valgte personer": "Valda personer",
            "Ingen personer tilgjengelig": "Inga personer tillgängliga",
            "Fjern alle": "Ta bort alla",
            "Legg til person": "Lägg till person",
            "Personer": "Personer",
            "Søk i personer...": "Sök bland personer...",
            "Velg personer": "Välj personer",
            "Ingen personer valgt": "Inga personer valda",
            "Personer valgt": "Personer valda",
            "Bekreft": "Bekräfta",
      
            // HSE Action Form translations
            "Korrigerende tiltak": "Corrective Action",
            "Forebyggende tiltak": "Preventive Action",
            "Type tiltak": "Action Type",
            "Prioritet": "Priority",
            "Lav": "Low",
            "Medium": "Medium",
            "Høy": "High",
            "Kritisk": "Critical",
            "Venter": "Pending",
            "Under arbeid": "In Progress",
            "Fullført": "Completed",
            "Kansellert": "Cancelled",
            "Frist": "Due Date",
            "Kostnadsestimat": "Cost Estimate",
            "Implementeringsnotater": "Implementation Notes",
            "Tiltak ble opprettet": "Action was created",
            "Kunne ikke opprette tiltak": "Could not create action",
      
            // Departments translations - Norwegian
            "Avdelinger": "Avdelinger",
            "Ny avdeling": "Ny avdeling",
            "Rediger avdeling": "Rediger avdeling",
            "Søk i avdelinger...": "Søk i avdelinger...",
            "Filtrer avdelinger": "Filtrer avdelinger",
            "Alle avdelinger": "Alle avdelinger",
            "Ingen avdelinger": "Ingen avdelinger",
            "Kom i gang ved å opprette en ny avdeling.": "Kom i gang ved å opprette en ny avdeling.",
            "Navn": "Navn",
            "Nummer": "Nummer",
            "Synkronisert": "Synkronisert",
            "Ikke synkronisert": "Ikke synkronisert",
            "Aktiv": "Aktiv",
            "Inaktiv": "Inaktiv",
            "Handlinger": "Handlinger",
            "Rediger": "Rediger",
            "Avbryt": "Avbryt",
      
            // Report admin menu (Norwegian)
            "report.admin.title": "Admin",
            "report.admin.status": "Rapportstatus",
            "report.admin.status_desc": "Under prosess, prosessert, fakturert",
            "report.admin.reset": "Reset",
            "report.admin.reset_desc": "Nullstill rapport-moduler",
            "report.admin.view_main_report": "Vis hovedrapport",
            "report.admin.view_sequel": "Gå til oppfølger",
            "report.admin.view_case": "Vis sak",
            "report.admin.create_case": "Opprett sak",
            "report.admin.create_case_desc": "Opprett eller knytt sak for oppfølging av rapport",
            "report.admin.case_dialog_title": "Oppfølging av rapport",
            "report.admin.create_sequel": "Opprett oppfølger",
            "report.admin.create_sequel_desc": "Opprett ny rapport som oppfølger",
            "report.admin.create_order": "Skapa order",
            "report.admin.create_order_desc": "Skapa en order från denna rapport (timmar, mil, rader)",
            "report.admin.open_mentions": "Åpne sak hvor rapport er nevnt",
            "report.admin.open_mentions_desc": "Se saker og notater som nevner rapporten",
            "report.admin.mentions_dialog_title": "Rapport nevnt i",
            "report.admin.mentioned_at": "Nevnt",
            "report.admin.no_mentions": "Rapporten er ikke nevnt andre steder",

            "report.dev.title": "Dev",
            "report.dev.variables_v2": "Variabler V2",
            "report.dev.variables_v2_desc": "Redigera rapportvariabler (grupperad editor)",

            "report.variables.legacy.headingOnly": "Variabler",
            "report.variables.legacy.headingTagged": "Variabler (äldre)",
            "report.variables.legacy.saving": "Sparar...",
            "report.variables.legacy.save": "Spara variabler",
            "report.variables.orphaned.title": "Ofullständiga huvudvariabler",
            "report.variables.orphaned.body":
              "Dessa är markerade som huvudvariabler men saknar typgrupp. Koppla till en typgrupp eller ta bort dem.",
            "report.variables.ungrouped.heading": "Variabler utan grupp",
            "report.variables.groups.heading": "Grupper",
            "report.variables.newSystem.title": "Variabler",
            "report.variables.createTypeGroup": "Skapa typgrupp",
            "report.variables.createGroup": "Skapa grupp",
            "report.variables.sketch.tablist": "Variabler (skiss)",
            "report.variables.sketch.groupTablist": "Grupper och översikt",
            "report.variables.sketch.navGroupLabel": "Grupp",
            "report.variables.sketch.navVariableTypeLabel": "Variabeltyp",
            "report.variables.sketch.typeTablist": "Variabeltyper",
            "report.variables.sketch.noTypesInGroup": "Inga variabeltyper här ännu.",
            "report.variables.sketch.ungroupedTab": "Utan grupp",
            "report.variables.sketch.ungroupedTabSub": "{{count}} variabeltyper",
            "report.variables.sketch.pickVariableType": "Välj en variabeltyp i flikraden ovan.",
            "report.variables.sketch.addGroup": "Lägg till grupp",
            "report.variables.sketch.groupNoTypes": "Inga typgrupper",
            "report.variables.sketch.unitsNotSet": "Mätenhet ej satt",
            "report.variables.sketch.untitledGroup": "Utan namn",
            "report.variables.sketch.measureLabel": "Mät",
            "report.variables.sketch.projectedShort": "Proj.",
            "report.variables.sketch.variableTypeFallback": "Variabeltyp",
            "report.variables.sketch.tabOrphaned": "Ofullständiga",
            "report.variables.sketch.tabOrphanedSub": "{{count}} huvudvariabler",
            "report.variables.sketch.tabLegacySub": "Äldre format",
            "report.variables.sketchTab.legacy": "Äldre",
            "report.variables.sketch.emptyAll":
              "Inga grupper eller fria variabeltyper ännu. Använd knapparna ovan.",
            "report.variables.sketch.groupTabEmpty":
              "Inga typgrupper i denna flik ännu. Lägg till huvudvariabel.",
            "report.variables.sketch.editGroup": "Redigera grupp",
            "report.variables.sketch.addMainVariable": "Huvudvariabel",
            "report.variables.sketch.addAnotherMainVariable": "Lägg till ny huvudvariabel i gruppen",
            "report.variables.sketch.typeGroupUngrouped": "Typgrupp (utan grupp)",
            "report.variables.sketch.deleteGroupAria": "Ta bort grupp",
            "report.variables.sketch.structureMenuTrigger": "Grupp och struktur",
            "report.variables.sketch.structureMenuAria": "Grupp och struktur — fler åtgärder",
            "report.variables.sketch.deleteGroupMenu": "Ta bort grupp",
            "report.variables.sketch.addVariable": "Lägg till variabel",
            "report.variables.sketch.addBulkVariables": "Lägg till variabler i bulk",
            "report.variables.sketch.editTypeGroupAria": "Redigera variabeltyp",
            "report.variables.sketch.deleteTypeGroupAria": "Ta bort variabeltyp",
            "report.variables.sketch.typeGroupMoreAria": "Fler åtgärder för variabeltypen",
            "report.variables.sketch.editTypeGroupMenu": "Redigera variabeltyp",
            "report.variables.sketch.deleteTypeGroupMenu": "Ta bort variabeltyp",
            "report.variables.sketch.measurements": "Mätningar",
            "report.variables.sketch.editVariable": "Redigera",
            "report.variables.sketch.editVariableAria": "Redigera variabel",
            "report.variables.sketch.deleteVariable": "Ta bort",
            "report.variables.sketch.deleteVariableAria": "Ta bort variabel",
            "report.variables.sketch.variableRowMenuAria": "Åtgärder för variabel",
            "report.variables.sketch.noSubvariablesYet": "Inga variabler ännu",
            "report.variables.sketch.actionSheetClose": "Stäng",
            "report.variables.sketch.openVariableActionsAria": "Visa åtgärder för variabel",
            "report.variables.sketch.variableActionsTitle": "Variabel",
            "report.variables.sketch.variableActionsHint": "Välj en åtgärd nedan.",
            "report.variables.sketch.rowProjected": "Projicerat:",
            "report.variables.sketch.rowPreMeasurement": "Före mätning:",
            "report.variables.sketch.rowMeasured": "Mätt:",
            "report.variables.sketch.globalTotalsHeading": "Summa per variabeltyp (alla grupper)",
            "report.variables.sketch.globalStatTotalLabel": "Summa",
            "report.variables.sketch.globalSumProjected": "Proj. (totalt)",
            "report.variables.sketch.globalSumPre": "För-mätning (totalt)",
            "report.variables.sketch.globalSumMeasured": "Mätt (totalt)",
            "report.variables.sketch.tabSumProjected": "Σ Proj.",
            "report.variables.sketch.tabSumPre": "Σ För",
            "report.variables.sketch.tabSumMeasured": "Σ Mätt",
            "report.variables.sketch.cardTotalPrefix": "TOTAL",
            "report.variables.sketch.totalsProjRow": "Proj. totalt",
            "report.variables.sketch.totalsPreRow": "För totalt",
            "report.variables.sketch.totalsMeasRow": "Mätt totalt",
            "report.variables.sketch.newGroup": "Ny grupp",
            "report.variables.sketch.typeGroupShort": "Typgrupp",
            "report.variables.sketch.tableColVariable": "Variabel",
            "report.variables.sketch.tableColProj": "Proj.",
            "report.variables.sketch.tableColPre": "För",
            "report.variables.sketch.tableColMeas": "Mätt",
            "report.variables.sketch.tableColLsSuffix": "(l/s)",
            "report.variables.sketch.bulkAddShort": "Bulk-add",
            "report.variables.sketch.fabNoType": "Skapa en typgrupp innan du lägger till variabler.",
            "report.variables.sketch.statusMeasuredOnly": "Mätt",
            "report.variables.sketch.statusGood": "Bra",
            "report.variables.sketch.statusCheck": "Kontrollera",
            "report.variables.sketchEditor.statusMeasured": "Mätt",
            "report.variables.sketchEditor.statusGood": "Bra matchning",
            "report.variables.sketchEditor.statusGoodSub": "Mätt värde ligger inom acceptabelt intervall",
            "report.variables.sketchEditor.statusCheck": "Kontrollera avvikelse",
            "report.variables.sketchEditor.statusCheckSub": "Mätt avviker mer än 15 % från projicerat",
            "report.variables.sketchEditor.refRequired": "Referens krävs",
            "report.variables.sketchEditor.saveError": "Kunde inte spara",
            "report.variables.sketchEditor.measureError": "Kunde inte spara mätning",
            "report.variables.sketchEditor.saved": "Sparat",
            "report.variables.sketchEditor.noGroup": "Utan grupp",
            "report.variables.sketchEditor.measuredActual": "Mätt (faktiskt)",
            "report.variables.sketchEditor.cancel": "Avbryt",
            "report.variables.sketchEditor.saving": "Sparar…",
            "report.variables.sketchEditor.saveChanges": "Spara ändringar",
            "report.variables.sketchEditor.deleteSubvariable": "Ta bort undervariabel",
            "report.variables.sketchEditor.deleteSubvariableHint":
              "Endast denna undervariabel tas bort. Huvudvariabeln och typgruppen finns kvar.",
            "report.variables.sketchEditor.deleteSubvariableConfirm":
              "Ta bort undervariabeln «{{reference}}»? Mätningar och värden raderas permanent.",
            "report.variables.sketchEditor.subvariableDeleted": "Undervariabel borttagen",
            "report.variables.sketchEditor.subvariableDeleteError": "Kunde inte ta bort variabeln",
            "report.variables.sketchEditor.deleteSubvariableCancel": "Avbryt",
            "report.variables.sketchEditor.deleteSubvariableWorking": "Tar bort…",
            "report.variables.sketchEditor.deleteSubvariableConfirmAction": "Ta bort permanent",
            "report.variables.sketchEditor.measuredHint":
              "Uppdaterar senaste mätning vid sparning. Använd ”Lägg till mätning” nedan för fler mätpunkter.",
            "report.variables.sketchEditor.addMeasurementHeading": "Lägg till ny mätning",
            "report.variables.sketchEditor.addMeasurementValue": "Mätvärde",
            "report.variables.sketchEditor.addMeasurementButton": "Lägg till",
            "report.variables.sketchEditor.addingMeasurement": "Lägger till…",
            "report.variables.sketchEditor.measurementAdded": "Mätning tillagd",
            "report.variables.sketchEditor.measurementInvalid": "Ange ett giltigt mätvärde",
            "report.variables.sketchEditor.historyHeading": "Mätningshistorik ({{count}})",
            "report.variables.sketchEditor.historyLoading": "Laddar mätningar…",
            "report.variables.sketchEditor.historyEmpty": "Inga mätningar registrerade",
            "report.variables.sketchEditor.historyLoadError": "Kunde inte ladda mätningar",
            "report.variables.sketchEditor.historyColValue": "Värde",
            "report.variables.sketchEditor.historyColDate": "Datum/tid",
            "report.variables.sketchEditor.tabMeasurements": "Mätningar",
            "report.variables.sketchEditor.tabDetails": "Värden",
            "report.variables.sketchEditor.tabsAria": "Variabelredigerare – flikar",
            "report.variables.sketchEditor.measurementsIntro": "Lägg till ett mätvärde eller bläddra i historiken.",
            "report.variables.sketchEditor.detailsIntro": "Referens och fält som sparas tillsammans.",
            "report.variables.sketchEditor.goToDetails": "Redigera referens och övriga värden →",
            "report.variables.sketchEditor.close": "Stäng",
            "report.variables.sketchEditor.addMeasurementPlaceholder": "Värde",
            "report.variables.sketchEditor.measuredHintDetails":
              "Uppdaterar senaste mätning om du sparar ett nytt värde här. Nya mätpunkter läggs till under Mätningar.",
            "report.variables.measurementDialog.title": "Mätningar",
            "report.variables.measurementDialog.variableFallback": "Variabel",
            "report.variables.measurementDialog.contextHeading": "Underlag",
            "report.variables.measurementDialog.reference": "Referens",
            "report.variables.measurementDialog.measurementUnit": "Mätenhet",
            "report.variables.measurementDialog.projectedUnit": "Projicerad enhet",
            "report.variables.measurementDialog.projectedLabel": "Projicerat",
            "report.variables.measurementDialog.preMeasurementLabel": "Före mätning",
            "report.variables.measurementDialog.latestHeading": "Senaste mätning",

            // Cases list - new view (Norwegian)
            "Use list view": "Bruk listevisning",
            "Use new view": "Bruk ny visning",
            "Switch to classic list view": "Bytt til klassisk listevisning",
            "Switch to compact editable table view": "Bytt til kompakt redigerbar tabellvisning",
            "Status updated": "Status oppdatert",
            "Could not update status": "Kunne ikke oppdatere status",
            "Due date updated": "Frist oppdatert",
            "Could not update due date": "Kunne ikke oppdatere frist",
            "Priority updated": "Prioritet oppdatert",
            "Could not update priority": "Kunne ikke oppdatere prioritet",
            "Last update": "Siste oppdatering",
            "No updates yet": "Ingen oppdateringer ennå",
            "Add update": "Legg til oppdatering",
            "Write an update...": "Skriv en oppdatering...",
            "Gå til bruker": "Gå til bruker",
            "Bruker": "Bruker",
            "Ansatt": "Ansatt",
            "Update added": "Oppdatering lagt til",
            "Could not add update": "Kunne ikke legge til oppdatering",
            "Open case": "Åpne sak",
            "View full": "Vis full",
            "No title": "Mangler tittel",
            "Prioritering": "Prioritering",
            "Priority": "Prioritet",
            "Case type": "Sakstype",
            "Labels": "Etiketter",
            "No labels defined": "Ingen etiketter definert",
            "Remove": "Fjern",
            "Statistics": "Statistikk",
            "Cases by label": "Saker per etikett",
            "No labels with cases yet": "Ingen etiketter med saker ennå",
            "Label administration": "Etikettadministrasjon",
            "All modules": "Alle moduler",
            "Cases": "Ärenden",
            "Projects": "Projekt",
            "Customers": "Kunder",
            "Tasks": "Uppgifter",
            "Add label": "Legg til etikett",
            "Scope module": "Modul",
            "Sort order": "Sortering",
            "Name is required": "Navn er påkrevd",
            "Are you sure you want to delete this label?": "Er du sikker på at du vil slette denne etiketten?",
            "Lagrer...": "Lagrer...",
            "Oppretter...": "Oppretter...",
            "Lagre endringer": "Lagre endringer",
            "Opprett avdeling": "Opprett avdeling",
            "Navn er påkrevd": "Navn er påkrevd",
            "Kunne ikke laste avdelinger": "Kunne ikke laste avdelinger",
            "Avdeling opprettet": "Avdeling opprettet",
            "Kunne ikke opprette avdeling": "Kunne ikke opprette avdeling",
            "Avdeling oppdatert": "Avdeling oppdatert",
            "Kunne ikke oppdatere avdeling": "Kunne ikke oppdatere avdeling",
            "avdelinger valgt": "avdelinger valgt",
            "avdeling valgt": "avdeling valgt",

            // Microsoft / Outlook
            "microsoft.explain.title": "Vad innebär anslutningen?",
            "microsoft.explain.company.1":
              "Kopplar företagets huvudmejl (t.ex. post@foretag.se) till Microsoft så att Promang kan läsa och hantera inkommande mejl för ärenden.",
            "microsoft.explain.company.2":
              "Ger underlag för att skapa och uppdatera ärenden från mejltrådar.",
            "microsoft.explain.company.3":
              "Kräver administratörsbehörighet och samtycke i Microsoft för den valda inkorgen.",
            "microsoft.explain.company.4":
              "Hemligheter och tokenutbyte sker endast i Promang API — inte i webbläsaren.",
            "microsoft.explain.company.5":
              "Att skicka mejl och AI-funktioner mot företagsmejl kommer när lagring av tokens är klar på servern.",
            "microsoft.explain.user.1":
              "Kopplar ditt eget Microsoft- / Outlook-konto till Promang-användaren du är inloggad som.",
            "microsoft.explain.user.2":
              "Gör det möjligt att skicka mejl från din adress där det är aktiverat i Promang, och att använda AI/kontext från din mejl.",
            "microsoft.explain.user.3":
              "Du måste vara inloggad i Promang innan du klickar «Anslut Microsoft».",
            "microsoft.explain.user.4":
              "Mejladressen i Microsoft bör matcha din användare där det är praktiskt möjligt.",
            "microsoft.explain.user.5":
              "Du kan när som helst koppla från under Inställningar eller på sidan Microsoft / Outlook.",
            "microsoft.company.page_title": "Microsoft — företagsmejl",
            "microsoft.company.page_subtitle": "Koppla företagets huvudmejl (admin).",
            "microsoft.company.card_title": "Företagsmejl (Microsoft 365)",
            "microsoft.company.subtitle": "För gemensam inkorg och ärenden för företagets räkning.",
            "microsoft.user.page_title": "Microsoft / Outlook",
            "microsoft.user.page_subtitle": "Koppla ditt Microsoft-konto till denna Promang-användare.",
            "microsoft.user.card_title": "Ditt Outlook-konto",
            "microsoft.user.subtitle":
              "Mejl skickas från ditt konto när det stöds; ger också kontext till AI och ärenden.",
            "microsoft.user.settings_section_title": "Microsoft / Outlook",
            "microsoft.user.settings_section_intro":
              "Koppla Microsoft till kontot du är inloggad med. Detta är inte samma som «Logga in med Microsoft» på inloggningssidan — du stannar i Promang och ger åtkomst till mejl för funktioner i instrumentpanelen.",
            "microsoft.user.open_full_page": "Öppna egen sida för anslutning",
            "microsoft.user.calendar_heading": "Kalender för händelser",
            "microsoft.user.calendar_intro":
              "Alla kalendrar du kan öppna i Outlook för detta konto visas (egna och delade). Välj var Promang ska skapa händelser. Använd sök om du har många kalendrar.",
            "microsoft.user.calendar_refresh": "Hämta kalendrar",
            "microsoft.user.calendar_need_refresh":
              "Anslut Microsoft med refresh-token (fullständig koppling) för att hämta kalendrar.",
            "microsoft.user.calendar_select_label": "Kalender",
            "microsoft.user.calendar_none": "Ingen vald",
            "microsoft.user.calendar_choose": "Sök …",
            "microsoft.user.calendar_modal_title": "Välj kalender",
            "microsoft.user.calendar_modal_close": "Stäng",
            "microsoft.user.calendar_modal_hint":
              "Sök på namn eller ägarens e-post. Delade kalendrar märks; skrivskyddade kan inte sparas för händelsesynk.",
            "microsoft.user.calendar_search_placeholder": "Sök kalendrar …",
            "microsoft.user.calendar_search_empty": "Inga kalendrar matchar sökningen.",
            "microsoft.user.calendar_modal_empty": "Microsoft returnerade inga kalendrar.",
            "microsoft.user.calendar_badge_own": "Din",
            "microsoft.user.calendar_badge_shared": "Delad",
            "microsoft.user.calendar_badge_readonly": "Skrivskyddad",
            "microsoft.user.calendar_readonly_hint":
              "Den här kalendern är skrivskyddad i Microsoft. Välj en du kan redigera för att synka händelser.",
            "microsoft.user.calendar_readonly_save":
              "Kan inte spara en skrivskyddad kalender för händelser. Välj en kalender du kan redigera.",
            "microsoft.user.calendar_current": "Tidigare vald: {{name}}{{email}}",
            "microsoft.user.calendar_save": "Spara kalender",
            "microsoft.user.calendar_saved": "Kalender sparad.",
            "microsoft.user.calendar_save_failed": "Kunde inte spara kalender.",
            "microsoft.user.calendar_load_failed": "Kunde inte hämta kalendrar.",
            "microsoft.user.personal_mail_ai.title": "Din brevlåda — AI-regler och bearbetning",
            "microsoft.user.personal_mail_ai.intro":
              "Konfigurera sortering, manuella regler, AI-routning och kör bearbetning för din länkade Microsoft-brevlåda — samma alternativ som delade företagsinkorgar. Ärenden och kunder skapas i aktuellt företag.",
            "microsoft.user.personal_mail_ai.no_permission":
              "Din roll inkluderar inte personlig inkorg-AI. Be en administratör tilldela rollen «microsoft_personal_mail_ai» för detta företag eller ge dig adminåtkomst.",
            "microsoft.user.personal_mail_ai.forbidden_toast": "Du har inte behörighet till dessa inställningar.",
            "microsoft.user.personal_mail_ai.load_failed": "Kunde inte hämta inställningar för e-post-AI.",
            "microsoft.user.personal_mail_ai.no_refresh":
              "Anslut Microsoft med refresh-token (full e-postlänk) för att läsa meddelanden och köra bearbetning.",
            "microsoft.user.personal_mail_ai.connect_first":
              "Anslut Microsoft ovan för att konfigurera regler, AI-routning och bearbetning för din egen brevlåda.",
            "microsoft.status.loading": "Läser in status…",
            "microsoft.status.api_pending":
              "API för att spara tokens rullas fortfarande ut. Du kan fortfarande slutföra inloggning hos Microsoft; kontakta administratör om något misslyckas.",
            "microsoft.status.connected": "Ansluten",
            "microsoft.action.disconnect": "Koppla från",
            "microsoft.action.connect_microsoft": "Anslut Microsoft",
            "microsoft.action.redirect_hint":
              "Du skickas till Microsoft för att godkänna åtkomst, sedan tillbaka till Promang.",
            "microsoft.toast.login_required": "Du måste vara inloggad i Promang för att koppla.",
            "microsoft.toast.missing_env": "Microsoft är inte konfigurerat på servern.",
            "microsoft.toast.start_failed": "Kunde inte starta Microsoft-anslutning.",
            "microsoft.toast.disconnected": "Frånkopplad.",
            "microsoft.toast.disconnect_failed": "Kunde inte koppla från.",
            "microsoft.callback.working": "Slutför anslutning…",
            "microsoft.callback.error_microsoft": "Microsoft avbröt eller misslyckades.",
            "microsoft.callback.missing_params": "Saknar code eller state från Microsoft.",
            "microsoft.callback.success_login": "Inloggad med Microsoft.",
            "microsoft.callback.success_link": "Microsoft-kontot är anslutet.",
            "microsoft.callback.api_not_ready": "API är inte redo för detta steg ännu.",
            "microsoft.callback.exchange_failed": "Kunde inte slutföra anslutningen.",
            "microsoft.callback.unknown_intent": "Okänd anslutningstyp.",
            "microsoft.callback.title": "Microsoft och Promang",
            "microsoft.callback.subtitle_loading":
              "Slutför säker anslutning. Det tar vanligtvis några sekunder.",
            "microsoft.callback.success_title": "Anslutning klar",
            "microsoft.callback.error_title": "Något gick fel",
            "microsoft.callback.redirecting_note": "Skickar dig tillbaka till Promang …",
            "microsoft.callback.continue_now": "Gå till Promang nu",
            "microsoft.callback.back_to_promang": "Tillbaka till Promang",
            "microsoft.callback.back_to_login": "Tillbaka till inloggning",
            "microsoft.callback.debug_heading": "Teknisk detalj (felsökning)",
            "microsoft.callback.wait_hint": "Stäng inte den här fliken medan vi slutför.",
            "microsoft.login.or": "eller",
            "microsoft.login.redirecting": "Omdirigerar…",
            "microsoft.login.with_microsoft": "Logga in med Microsoft",
            "microsoft.test_mail.button": "Skicka testmejl till mig själv",
            "microsoft.test_mail.hint":
              "Skickar ett meddelande från den kopplade inkorgen till samma adress, för att verifiera Mail.Send och token.",
            "microsoft.test_mail.success": "Testmejl skickat. Kontrollera inkorgen.",
            "microsoft.test_mail.failed": "Kunde inte skicka testmejl.",
            "microsoft.ai_mailboxes.title": "Delade inkorgar för AI",
            "microsoft.ai_mailboxes.admin_page_title": "Delade inkorgar (Microsoft 365)",
            "microsoft.ai_mailboxes.admin_page_subtitle":
              "Registrera delade adresser, koppla Microsoft, visa inkorg och ställ in hur e-post ska hanteras (sortering, ärenden, arkiv, autosvar, signatur, regler). Behandling och valfri flytt till Archive/Arkiv körs när jobbet är på eller du använder «Kör behandling» (inte simulering).",
            "microsoft.ai_mailboxes.intro":
              "Registrera delade adresser (t.ex. post@, service@). Varje inkorg måste kopplas till Microsoft så att Promang kan läsa inkorgen och skicka test via Graph.",
            "microsoft.ai_mailboxes.how_link_works":
              "Logga in som dig själv (t.ex. du@foretag.se) — inte som den delade adressen. Delade postlådor (t.ex. post@…) har oftast inget eget lösenord. Använd ett konto som redan kan öppna den delade inkorgen i Outlook (full åtkomst / delegat). Promang sparar refresh-token för inloggningen; Graph läser/skickar för adressen på raden.",
            "microsoft.ai_mailboxes.mail_safety_dev_notice":
              "Med **Arkivera efter hantering** på flyttar Promang hanterade meddelanden till mappen **Archive** eller **Arkiv** (Graph), även i utveckling — bara när behandling körs med riktiga åtgärder (inte simulering). Annars läser vi inkorgen för visning. «Kör behandling», schemalagt jobb och test kan skicka e-post (t.ex. vidarebefordran) via Graph — använd «Simulera jobb» för att testa utan utskick och utan flytt.",
            "microsoft.ai_mailboxes.linked_as": "Microsoft kopplat som {{email}}",
            "microsoft.ai_mailboxes.not_linked": "Inte kopplat till Microsoft — koppla för att läsa inkorg och skicka test.",
            "microsoft.ai_mailboxes.connect_microsoft": "Anslut Microsoft",
            "microsoft.ai_mailboxes.disconnect_microsoft": "Koppla från Microsoft",
            "microsoft.ai_mailboxes.send_test": "Skicka testmejl",
            "microsoft.ai_mailboxes.go_to_mailbox": "Gå till postlåda",
            "microsoft.ai_mailboxes.go_to_mailbox_hint":
              "Öppnar Outlook på webben för denna adress i en ny flik (mappar: inkorg, arkiv m.m.). Du måste vara inloggad i Microsoft i webbläsaren med ett konto som har åtkomst till postlådan.",
            "microsoft.ai_mailboxes.go_to_mailbox_missing_email": "Ingen postadress att öppna.",
            "microsoft.ai_mailboxes.multi_inbox_hint":
              "Du kan ha flera inkorgar öppna samtidigt. Öppna ett meddelande i Promang för att läsa innehåll och se behandlingslogg i flikar.",
            "microsoft.ai_mailboxes.reader.title": "Meddelande (Promang)",
            "microsoft.ai_mailboxes.reader.close": "Stäng",
            "microsoft.ai_mailboxes.reader.tab_message": "Innehåll",
            "microsoft.ai_mailboxes.reader.tab_reply_draft": "AI svarutkast",
            "microsoft.ai_mailboxes.reader.tab_logs": "Behandlingslogg",
            "microsoft.ai_mailboxes.reader.reply_draft_hint":
              "Redigerar utkastets brödtext i Outlook (HTML). Vid skickning behålls tråden under din text.",
            "microsoft.ai_mailboxes.reader.reply_draft_load_failed": "Kunde inte läsa svarutkast.",
            "microsoft.ai_mailboxes.reader.reply_draft_saved": "Utkast sparat.",
            "microsoft.ai_mailboxes.reader.reply_draft_save": "Spara utkast",
            "microsoft.ai_mailboxes.reader.reply_draft_saving": "Sparar…",
            "microsoft.ai_mailboxes.reader.reply_draft_none": "Inget AI svarutkast för detta meddelande.",
            "microsoft.ai_mailboxes.reader.field_from": "Från",
            "microsoft.ai_mailboxes.reader.field_to": "Till",
            "microsoft.ai_mailboxes.reader.field_cc": "Kopia",
            "microsoft.ai_mailboxes.reader.field_date": "Mottaget",
            "microsoft.ai_mailboxes.reader.attachments_notice":
              "Meddelandet har bilagor. Filer visas inte här — använd Outlook på webben om du behöver ladda ner.",
            "microsoft.ai_mailboxes.reader.body_iframe_title": "E-postinnehåll",
            "microsoft.ai_mailboxes.reader.no_body": "Inget innehåll.",
            "microsoft.ai_mailboxes.reader.load_failed": "Kunde inte läsa meddelandet.",
            "microsoft.ai_mailboxes.reader.inbox_only_hint":
              "Listan visar bara inkorg. För arkiv, skräppost och andra mappar, använd Outlook på webben (länk nedan) vid behov.",
            "microsoft.ai_mailboxes.reader.folder_hint":
              "Du kan välja Arkiv, Skickat och andra mappar i postlådelistan ovan. Använd Outlook på webben (länk nedan) för full mapphantering vid behov.",
            "microsoft.ai_mailboxes.reader.open_in_owa": "Öppna postlåda i Outlook på webben…",
            "microsoft.ai_mailboxes.reader.open_short": "Öppna",
            "microsoft.ai_mailboxes.reader.open_tooltip":
              "Öppna i Promang: läs e-post och se behandlingslogg (flikar).",
            "microsoft.ai_mailboxes.show_inbox": "E-postmappar",
            "microsoft.ai_mailboxes.inbox_requires_link": "Anslut Microsoft för denna adress först.",
            "microsoft.ai_mailboxes.no_messages": "Inga meddelanden i denna mapp (eller mappen är tom).",
            "microsoft.ai_mailboxes.messages_failed": "Kunde inte läsa meddelanden för denna mapp.",
            "microsoft.ai_mailboxes.process_folder_hint":
              "Markera meddelanden nedan och simulera eller kör behandling. Det schemalagda jobbet behandlar fortfarande bara inkorgen om du inte ändrar det separat.",
            "microsoft.ai_mailboxes.folder.select_label": "Mapp",
            "microsoft.ai_mailboxes.folder.group_shortcuts": "Genvägar",
            "microsoft.ai_mailboxes.folder.group_tree": "Alla mappar",
            "microsoft.ai_mailboxes.folder.loading_tree": "Läser in mappar…",
            "microsoft.ai_mailboxes.folder.folders_failed": "Kunde inte läsa mappar.",
            "microsoft.ai_mailboxes.folder.seg_inbox": "Inkorg",
            "microsoft.ai_mailboxes.folder.seg_archive": "Arkiv",
            "microsoft.ai_mailboxes.folder.seg_sentitems": "Skickat",
            "microsoft.ai_mailboxes.folder.seg_deleteditems": "Borttaget",
            "microsoft.ai_mailboxes.folder.seg_junkemail": "Skräppost",
            "microsoft.ai_mailboxes.folder.seg_drafts": "Utkast",
            "microsoft.ai_mailboxes.folder.seg_outbox": "Utkorg",
            "microsoft.ai_mailboxes.col.received": "Mottagen",
            "microsoft.ai_mailboxes.col.from": "Från",
            "microsoft.ai_mailboxes.col.subject": "Ämne",
            "microsoft.ai_mailboxes.microsoft_disconnected": "Microsoft frånkopplat för denna inkorg.",
            "microsoft.ai_mailboxes.microsoft_disconnect_failed": "Kunde inte koppla från Microsoft.",
            "microsoft.ai_mailboxes.shared_test_ok": "Testmejl skickat.",
            "microsoft.ai_mailboxes.shared_test_failed": "Kunde inte skicka testmejl.",
            "microsoft.ai_mailboxes.email_label": "E-postadress",
            "microsoft.ai_mailboxes.email_placeholder": "post@foretag.se",
            "microsoft.ai_mailboxes.add": "Lägg till",
            "microsoft.ai_mailboxes.empty": "Inga adresser tillagda ännu.",
            "microsoft.ai_mailboxes.remove": "Ta bort",
            "microsoft.ai_mailboxes.added": "Adressen har lagts till.",
            "microsoft.ai_mailboxes.add_failed": "Kunde inte lägga till adressen.",
            "microsoft.ai_mailboxes.removed": "Adressen har tagits bort.",
            "microsoft.ai_mailboxes.remove_failed": "Kunde inte ta bort adressen.",
            "microsoft.ai_mailboxes.load_failed": "Kunde inte läsa in adresser.",
            "microsoft.ai_mailboxes.email_required": "Ange en e-postadress.",
            "microsoft.ai_mailboxes.settings.toggle": "Inställningar",
            "microsoft.ai_mailboxes.settings.heading": "E-posthantering",
            "microsoft.ai_mailboxes.settings.intro":
              "Dessa val gäller endast denna postlåda. Inkorgslistan använder sortering från Graph direkt efter sparning.",
            "microsoft.ai_mailboxes.settings.processing_job_title": "Jobb: behandla inkorg",
            "microsoft.ai_mailboxes.settings.processing_job_hint":
              "När «På» sparas kan schemalagd körning (t.ex. Heroku Scheduler + `rake microsoft:enqueue_ai_mailbox_processing`) behandla upp till 50 senaste meddelanden och köra regler (inkl. vidarebefordran som textavisering). Testa säkert med «Simulera jobb» i inkorgslistan.",
            "microsoft.ai_mailboxes.settings.processing_job_off": "Av",
            "microsoft.ai_mailboxes.settings.processing_job_on": "På",
            "microsoft.ai_mailboxes.settings.mail_sort": "Sortering i inkorg",
            "microsoft.ai_mailboxes.settings.sort_received_desc": "Nyast först",
            "microsoft.ai_mailboxes.settings.sort_received_asc": "Äldst först",
            "microsoft.ai_mailboxes.settings.sort_subject_asc": "Ämne A–Ö",
            "microsoft.ai_mailboxes.settings.auto_create_case": "Skapa ärende för ny e-post (när aktiverat i Promang)",
            "microsoft.ai_mailboxes.settings.auto_create_case_hint":
              "När funktionen släpps används undantagen nedan för att undvika ärenden från reklam, nyhetsbrev m.m.",
            "microsoft.ai_mailboxes.settings.skip_promotional_hint": "Markera sannolik reklam/nyhetsbrev som inte ska bli ärende (rekommenderas)",
            "microsoft.ai_mailboxes.settings.ignore_subject_keywords": "Skapa inte ärende om ämnet innehåller (komma eller radbrytning)",
            "microsoft.ai_mailboxes.settings.ignore_subject_placeholder": "t.ex. reklam, unsubscribe, newsletter",
            "microsoft.ai_mailboxes.settings.ignore_from_domains": "Skapa inte ärende om avsändardomän är (komma eller radbrytning)",
            "microsoft.ai_mailboxes.settings.ignore_domains_placeholder": "t.ex. mailchimp.com, sendgrid.net",
            "microsoft.ai_mailboxes.settings.archive_after_processing": "Arkivera efter hantering",
            "microsoft.ai_mailboxes.settings.archive_hint":
              "Flyttar hanterad e-post från inkorg till **Archive** eller **Arkiv** via Microsoft Graph efter lyckad hantering (manuell regel eller AI). Gäller även utveckling — kräver att behandling körs med riktiga åtgärder, inte «Simulera jobb».",
            "microsoft.ai_mailboxes.settings.auto_reply_enabled": "Automatiskt svar efter nytt ärende (kundförfrågan)",
            "microsoft.ai_mailboxes.settings.auto_reply_body_ph":
              "HTML-innehåll (valfritt). Platshållare: %{case_number}, %{sak}. Tomt fält ger standardtext med ärendenummer.",
            "microsoft.ai_mailboxes.settings.auto_reply_note":
              "När autosvar är på svarar Promang i samma e-posttråd (Graph reply), inte som nytt meddelande. Svarsraden får [SAK-<nummer>]. Signatur HTML läggs till om den är satt.",
            "microsoft.ai_mailboxes.settings.signature_html": "Signatur (HTML)",
            "microsoft.ai_mailboxes.settings.signature_ph": "<p>Med vänliga hälsningar<br/>…</p>",
            "microsoft.ai_mailboxes.settings.rules_heading": "Regler",
            "microsoft.ai_mailboxes.settings.rules_intro":
              "Extra regler (t.ex. hoppa över ärende eller skicka kopia till adress) när inkorgsjobbet körs. Matchning är enkel textsökning.",
            "microsoft.ai_mailboxes.settings.rules_forward_hint":
              "Vidarebefordran sparas som inställning; under utveckling skickar bakgrundsjobbet ingen e-post automatiskt ännu.",
            "microsoft.ai_mailboxes.settings.add_rule": "Lägg till regel",
            "microsoft.ai_mailboxes.settings.no_rules": "Inga anpassade regler ännu.",
            "microsoft.ai_mailboxes.settings.rule_name": "Namn",
            "microsoft.ai_mailboxes.settings.rule_match": "Match",
            "microsoft.ai_mailboxes.settings.rule_value": "Värde",
            "microsoft.ai_mailboxes.settings.rule_action": "Åtgärd",
            "microsoft.ai_mailboxes.settings.rule_on": "På",
            "microsoft.ai_mailboxes.settings.remove_rule": "Ta bort regel",
            "microsoft.ai_mailboxes.settings.match_subject_contains": "Ämne innehåller",
            "microsoft.ai_mailboxes.settings.match_subject_equals": "Ämne är lika (exakt)",
            "microsoft.ai_mailboxes.settings.match_from_domain": "Från-domän",
            "microsoft.ai_mailboxes.settings.match_from_contains": "Från-adress innehåller",
            "microsoft.ai_mailboxes.settings.action_skip_case": "Skapa inte ärende",
            "microsoft.ai_mailboxes.settings.action_forward_to": "Vidarebefordra / skicka kopia till e-post",
            "microsoft.ai_mailboxes.settings.rule_forward_to_email": "Skicka till (e-post)",
            "microsoft.ai_mailboxes.settings.rule_forward_to_placeholder": "t.ex. 123@foretag.se",
            "microsoft.ai_mailboxes.settings.save": "Spara inställningar",
            "microsoft.ai_mailboxes.settings.saved": "Inställningar sparade.",
            "microsoft.ai_mailboxes.settings.save_failed": "Kunde inte spara inställningar.",
            "microsoft.ai_mailboxes.settings.ai_routing_heading": "AI-routing",
            "microsoft.ai_mailboxes.settings.ai_routing_hint":
              "Välj vad som ska hända per e-posttyp. Inställningarna sparas som JSON i bakgrunden. När routing är på används OpenAI/Grok (miljövariabler) för klassificering om tillgängligt — annars heuristik. Manuella regler har företräde.",
            "microsoft.ai_mailboxes.settings.ai_routing_invalid_json": "Ogiltig JSON för AI-routing.",
            "microsoft.ai_mailboxes.settings.ai_routing_raw_json": "Redigera som rå JSON (avancerat)",
            "microsoft.ai_mailboxes.settings.ai_routing_raw_json_hint":
              "Formuläret och JSON är likvärdiga. När du stänger av rå JSON läses texten in i formuläret (måste vara giltig JSON).",
            "microsoft.ai_mailboxes.ai_routing.master_enable": "Aktivera AI-routing och automatiska åtgärder",
            "microsoft.ai_mailboxes.ai_routing.master_hint":
              "Av: meddelanden klassificeras fortfarande för visning, men inga automatiska AI-åtgärder körs.",
            "microsoft.ai_mailboxes.ai_routing.reply_draft_title": "AI-utkast för svar (Outlook)",
            "microsoft.ai_mailboxes.ai_routing.reply_draft_desc":
              "Efter lyckad kundförfrågan eller ärendesvar skapas ett svarutkast i din Microsoft-postlåda. Du skickar när du är nöjd.",
            "microsoft.ai_mailboxes.ai_routing.reply_draft_enable": "Skapa AI-genererat svarutkast vid bearbetning",
            "microsoft.ai_mailboxes.ai_routing.reply_draft_requires_ai":
              "Slå på «Aktivera AI-routing» ovan för att använda detta (klassificering och ärende måste köras först).",
            "microsoft.ai_mailboxes.ai_routing.provider_label": "Klassificeringsleverantör",
            "microsoft.ai_mailboxes.ai_routing.provider_chatgpt": "ChatGPT (OpenAI)",
            "microsoft.ai_mailboxes.ai_routing.provider_grok": "Grok (xAI)",
            "microsoft.ai_mailboxes.ai_routing.model_label": "Modell (valfritt)",
            "microsoft.ai_mailboxes.ai_routing.model_placeholder": "t.ex. gpt-4o-mini",
            "microsoft.ai_mailboxes.ai_routing.model_hint": "Tomt = standard från server/miljö.",
            "microsoft.ai_mailboxes.ai_routing.action_label": "Åtgärd",
            "microsoft.ai_mailboxes.ai_routing.action_none": "Ingenting (bara klassificera)",
            "microsoft.ai_mailboxes.ai_routing.action_forward": "Vidarebefordra till e-post",
            "microsoft.ai_mailboxes.ai_routing.action_move_archive": "Flytta till arkivmapp",
            "microsoft.ai_mailboxes.ai_routing.action_move_junk": "Flytta till skräppost",
            "microsoft.ai_mailboxes.ai_routing.action_delete_graph": "Radera i Microsoft (Graph)",
            "microsoft.ai_mailboxes.ai_routing.action_move_folder": "Flytta till vald mapp",
            "microsoft.ai_mailboxes.ai_routing.action_create_case": "Skapa ärende i Promang",
            "microsoft.ai_mailboxes.ai_routing.action_append_case_note": "Lägg till ärendelinje (CAS / ärendenr)",
            "microsoft.ai_mailboxes.ai_routing.action_customer_communication": "Registrera som kundkommunikation på ärende",
            "microsoft.ai_mailboxes.ai_routing.action_reply_draft_only": "Bara logga kommunikation (och AI svarutkast om aktiverat)",
            "microsoft.ai_mailboxes.ai_routing.forward_to_label": "Vidarebefordra till (e-post)",
            "microsoft.ai_mailboxes.ai_routing.folder_optional_label": "Mappnamn (valfritt)",
            "microsoft.ai_mailboxes.ai_routing.folder_optional_hint": "Tomt använder standard (Archive / Junk Email).",
            "microsoft.ai_mailboxes.ai_routing.folder_placeholder_archive": "Archive",
            "microsoft.ai_mailboxes.ai_routing.folder_placeholder_junk": "Junk Email",
            "microsoft.ai_mailboxes.ai_routing.folder_name_label": "Mappens visningsnamn",
            "microsoft.ai_mailboxes.ai_routing.folder_placeholder_order": "Order",
            "microsoft.ai_mailboxes.ai_routing.folder_order_hint": "Mappen måste finnas i Microsoft-postlådan.",
            "microsoft.ai_mailboxes.ai_routing.cat_promotional_title": "Reklam / nyhetsbrev",
            "microsoft.ai_mailboxes.ai_routing.cat_promotional_desc": "Typisk massutsändning.",
            "microsoft.ai_mailboxes.ai_routing.cat_order_title": "Orderbekräftelse",
            "microsoft.ai_mailboxes.ai_routing.cat_order_desc": "Beställningar och orderdokument.",
            "microsoft.ai_mailboxes.ai_routing.cat_inquiry_title": "Ny kundförfrågan",
            "microsoft.ai_mailboxes.ai_routing.cat_inquiry_desc": "Allmän förfrågan utan befintligt ärendenummer i tråden.",
            "microsoft.ai_mailboxes.ai_routing.cat_inquiry_auto_reply_note":
              "Autosvar och signatur ställs in längre upp på sidan.",
            "microsoft.ai_mailboxes.ai_routing.cat_supplier_cas_title": "Leverantör (CAS-referens)",
            "microsoft.ai_mailboxes.ai_routing.cat_supplier_cas_desc":
              "Matchar ärende via CAS-token eller Promang-ärendenummer i innehållet. Fyll i «vid ingen träff».",
            "microsoft.ai_mailboxes.ai_routing.forward_unmatched_label": "Vid ingen träff — vidarebefordra till (e-post)",
            "microsoft.ai_mailboxes.ai_routing.forward_unmatched_hint": "Rekommenderas så mejl inte blir utan ärende.",
            "microsoft.ai_mailboxes.ai_routing.cas_reference_label": "Fast CAS-referens (valfritt)",
            "microsoft.ai_mailboxes.ai_routing.cas_reference_hint": "Bara om referensen inte finns i mejlet.",
            "microsoft.ai_mailboxes.ai_routing.case_number_fallback_label": "Fast ärendenummer (valfritt)",
            "microsoft.ai_mailboxes.ai_routing.case_number_fallback_hint": "Numerisk del, t.ex. 1234, om den inte hittas i text.",
            "microsoft.ai_mailboxes.ai_routing.cat_case_reply_title": "Svar på befintligt ärende",
            "microsoft.ai_mailboxes.ai_routing.cat_case_reply_desc": "Mejl som verkar gälla öppet ärende (SAK-nr i tråden).",
            "microsoft.ai_mailboxes.ai_routing.cat_project_title": "Projektkorrespondens",
            "microsoft.ai_mailboxes.ai_routing.cat_project_desc":
              "Mejl från känd kund/part om framdrift, avvikelser, byggledning m.m. — inte ny generell kundförfrågan.",
            "microsoft.ai_mailboxes.ai_routing.cat_project_reply_draft_note":
              "Kräver att avsändaren matchar en kund i Promang. Aktivera «AI svarutkast» ovan för utkast i Outlook.",
            "microsoft.ai_mailboxes.ai_routing.json_preview_toggle": "Visa JSON som sparas (endast läsning)",
            "microsoft.ai_mailboxes.process_inbox_hint":
              "Välj ett eller flera meddelanden och kör behandling (simulering skickar ingen e-post; «Kör» kan skicka vidarebefordran när en regel matchar).",
            "microsoft.ai_mailboxes.process_select_all": "Välj alla",
            "microsoft.ai_mailboxes.process_clear_selection": "Rensa val",
            "microsoft.ai_mailboxes.process_select_column": "Välj",
            "microsoft.ai_mailboxes.process_select_row": "Välj meddelande",
            "microsoft.ai_mailboxes.process_simulate": "Simulera jobb",
            "microsoft.ai_mailboxes.process_run": "Kör behandling",
            "microsoft.ai_mailboxes.process_need_selection": "Välj minst ett meddelande i listan.",
            "microsoft.ai_mailboxes.process_run_confirm":
              "Detta kan skicka riktig e-post (vidarebefordran) när regler matchar. Fortsätta?",
            "microsoft.ai_mailboxes.process_ok_simulated":
              "Simulering klar för {{count}} meddelande(n). Vidarebefordringsregler som skulle triggats: {{sim}}. «Skapa inte ärende»-träffar: {{skips}}.",
            "microsoft.ai_mailboxes.process_ok_executed":
              "Behandling klar för {{count}} meddelande(n). Vidarebefordran skickad: {{sent}}. «Skapa inte ärende»-träffar: {{skips}}.",
            "microsoft.ai_mailboxes.process_failed": "Kunde inte behandla valda meddelanden.",
            "microsoft.ai_mailboxes.processing_log.open_tooltip": "Visa behandlingslogg (utveckling)",
            "microsoft.ai_mailboxes.processing_log.title": "Behandlingslogg",
            "microsoft.ai_mailboxes.processing_log.close": "Stäng",
            "microsoft.ai_mailboxes.processing_log.load_failed": "Kunde inte läsa behandlingslogg.",
            "microsoft.ai_mailboxes.processing_log.empty":
              "Inga sparade körningar för detta meddelande ännu. Använd Simulera / Kör behandling, eller vänta på schemalagt jobb.",
            "microsoft.ai_mailboxes.processing_log.dry_run": "Simulering",
            "microsoft.ai_mailboxes.processing_log.live_run": "Skarp körning",
            "microsoft.ai_mailboxes.processing_log.failed": "Misslyckades",
            "microsoft.ai_mailboxes.processing_log.ok": "OK",
            "microsoft.ai_mailboxes.processing_log.ai_category": "Klassificering",
            "microsoft.ai_mailboxes.processing_log.confidence": "konfidens",
            "microsoft.ai_mailboxes.processing_log.actions": "Åtgärder",
            "microsoft.ai_mailboxes.processing_log.raw_json": "Rådata (JSON)",
            "microsoft.ai_mailboxes.processing_log.col_dev": "Logg",
            "microsoft.ai_mailboxes.processing_log.sum.ai_classification":
              "AI: {{category}} ({{source}}, konfidens {{confidence}})",
            "microsoft.ai_mailboxes.processing_log.sum.forward_dry": "Vidarebefordran (simulering) → {{to}}",
            "microsoft.ai_mailboxes.processing_log.sum.forward_sent": "Vidarebefordrat → {{to}}",
            "microsoft.ai_mailboxes.processing_log.sum.forward_failed":
              "Vidarebefordran misslyckades → {{to}}: {{error}}",
            "microsoft.ai_mailboxes.processing_log.sum.move_dry": "Flytt (simulering){{target}}",
            "microsoft.ai_mailboxes.processing_log.sum.move_ok": "Flyttat → {{folder}}",
            "microsoft.ai_mailboxes.processing_log.sum.move_failed": "Flytt misslyckades: {{error}}",
            "microsoft.ai_mailboxes.processing_log.sum.skip_case": "Regel: skapa inte ärende",
            "microsoft.ai_mailboxes.processing_log.sum.skip_case_unused": "skip_case (ej tillämpad)",
            "microsoft.ai_mailboxes.processing_log.sum.ai_routing_skipped": "AI-routing hoppades över: {{reason}}",
            "microsoft.ai_mailboxes.processing_log.sum.generic_error": "{{type}}: {{error}}",
            "microsoft.ai_mailboxes.processing_log.sum.generic_not_applied": "{{type}}: ej utförd",
            "subscription.ai_usage.loading": "Laddar…",
            "subscription.ai_usage.title": "AI-användning och uppskattning",
            "subscription.ai_usage.subtitle":
              "Tokenanvändning, vägledande kostnad och uppskattad sparad tid för företaget (endast lyckade AI-anrop).",
            "subscription.ai_usage.period.this_month": "Denna månad",
            "subscription.ai_usage.period.this_year": "Detta år",
            "subscription.ai_usage.period.last_30_days": "Senaste 30 dagarna",
            "subscription.ai_usage.period.last_12_months": "Senaste 12 månaderna",
            "subscription.ai_usage.load_failed": "Kunde inte hämta AI-användningsstatistik.",
            "subscription.ai_usage.forbidden": "Du har inte åtkomst till AI-användning för detta företag.",
            "subscription.ai_usage.empty": "Ingen AI-användning registrerad under perioden.",
            "subscription.ai_usage.tokens": "Tokens (totalt)",
            "subscription.ai_usage.calls_ok": "Lyckade anrop",
            "subscription.ai_usage.calls_fail": "Misslyckade anrop",
            "subscription.ai_usage.estimated_cost": "Uppskattad kostnad (NOK)",
            "subscription.ai_usage.cost_hint":
              "Intern uppskattning: {{rate}} NOK per 1M tokens. Inte en faktura — faktisk leverantörspris kan skilja sig.",
            "subscription.ai_usage.time_saved": "Uppskattad sparad tid",
            "subscription.ai_usage.time_hint":
              "Ungefärliga manuella minuter per lyckat anrop, per funktionstyp. Endast för översikt.",
            "subscription.ai_usage.minutes_only": "{{minutes}} min",
            "subscription.ai_usage.hours_minutes": "{{hours}} h {{minutes}} min",
            "subscription.ai_usage.by_feature": "Per funktion",
            "subscription.ai_usage.col_feature": "Funktion",
            "subscription.ai_usage.col_calls": "Anrop",
            "subscription.ai_usage.col_tokens": "Tokens",
            "subscription.ai_usage.col_cost": "Uppsk. NOK",
            "subscription.ai_usage.col_time": "Uppsk. sparad tid",
            "subscription.ai_usage.monthly_overview": "Per månad (i perioden)",
            "subscription.ai_usage.feature.microsoft_ai_mailbox_classify": "AI-inkorg — klassificering",
            "subscription.ai_usage.feature.microsoft_ai_mailbox_case_title": "AI-inkorg — ärendetitel",
            "subscription.ai_usage.feature.service_report_invoice_description_generate":
              "Servicerapport — fakturapunkter",
            "subscription.ai_usage.feature.service_report_invoice_description_format_report":
              "Servicerapport — HTML-format",
            "subscription.ai_usage.feature.ai_generator_todo": "Uppgifter — AI-assistent",
            "subscription.ai_usage.feature.ai_generator_hse_document": "HMS/KS — AI-fält i dokument",
            "subscription.ai_usage.feature.other": "{{feature}}",

            "todo.pageTitle": "Arbetsyta — uppgifter och dagbok",
            "todo.tabTasks": "Uppgifter",
            "todo.loadingMoreTodos": "Laddar fler uppgifter…",
            "todo.loadMoreError": "Kunde inte ladda fler uppgifter.",
            "todo.filterAll": "Alla",
            "todo.filterActive": "Aktiva",
            "todo.filterFinished": "Klara",
            "todo.filterMine": "Mina uppgifter",
            "todo.due": "Förfaller",
            "todo.todayPlanBadge": "Dagens plan",
            "todo.taskDetails": "Uppgiftsdetaljer",
            "todo.descriptionPlaceholder": "Lägg till beskrivning…",
            "todo.dueDate": "Förfallodatum",
            "todo.reminder": "Påminnelse",
            "todo.onTodayPlan": "På dagens plan",
            "todo.recurrence": "Upprepa vid slutförande",
            "todo.recurrenceNone": "Ingen",
            "todo.recurrenceDaily": "Dagligen",
            "todo.recurrenceWeekdays": "Vardagar",
            "todo.recurrenceWeekly": "Veckovis",
            "todo.recurrenceMonthly": "Månadsvis",
            "todo.estimatedHours": "Uppskattade timmar",
            "todo.labels": "Etiketter",
            "todo.aiAssistant": "AI-assistent",
            "todo.hoursAvailable": "Timmar tillgängliga idag (för dagsplan)",
            "todo.aiSuggestions": "Förslag",
            "todo.aiEstimate": "Tidsestimat",
            "todo.aiPlan": "Dagsplan",
            "todo.aiResultTitle": "AI-resultat",
            "todo.aiLoading": "Genererar…",
            "todo.aiError": "Kunde inte hämta AI-förslag.",
            "todo.hseDocumentTaskManualFinish":
              "HMS/KS-dokumentuppgifter kan inte markeras som klara här. Bekräfta att du har läst och förstått dokumentet på dokumentsidan.",
            "todo.hseDocumentOpenLink": "Öppna HMS/KS-dokument",
            "hse.document.acknowledge_read": "Jag bekräftar att jag har läst och förstått",
            "hse.document.acknowledge_read_submitting": "Registrerar…",
            "hse.document.acknowledge_read_success": "Registrerat som läst/förstått",
            "hse.document.acknowledge_read_error": "Kunde inte registrera läst/förstått",
            "hse.document.acknowledge_read_hint":
              "När du har gått igenom innehållet, bekräfta här. Uppgiften i att-göra-listan slutförs automatiskt.",
            "hse.document.acknowledge_read_done": "Du är registrerad som att ha läst och förstått denna version.",
            "hse.document.approval_stuck_retry_hint":
              "Godkänningen verkar ha stannat innan versionen publicerades. Klicka på «Godkänn version» igen för att slutföra.",
            "hse.document.file_missing": "Bifogad fil kunde inte hittas.",
            "hse.document.file_processing": "Filen bearbetas fortfarande. Försök igen om en stund.",
            "hse.document.file_failed": "Filuppladdningen misslyckades. Ladda upp dokumentet igen.",
            "hse.document.open_file": "Öppna fil",
            "hse.document.download_file": "Ladda ner fil",
            "hse.document.attached_file": "Bifogad fil",
            "todo.journalTitle": "Dagbok",
            "todo.journalDate": "Datum",
            "todo.journalHint": "Anteckningar för vald dag (HTML). Sparas automatiskt.",
            "todo.journalHintRich":
              "Markera text för att formatera (Notion-stil). Du kan klistra in HTML från webben eller OneNote — osäker kod tas bort vid sparning.",
            "todo.journalPlaceholder": "Skriv anteckningar för denna dag…",
            "todo.journalFullscreen": "Helskärm",
            "todo.journalExitFullscreen": "Stäng helskärm",
            "todo.journalOpenInFullscreen": "Du redigerar i helskärm. Stäng det fönstret när du är klar.",
            "todo.journalSaveError": "Kunde inte spara dagbok.",
            "todo.journalImageTitle": "Bild",
            "todo.journalImageWidth": "Bredd",
            "todo.journalImageWidthHint": "Pixlar (320) eller procent (50 %).",
            "todo.journalImageHeight": "Höjd",
            "todo.journalImageHeightPlaceholder": "Valfritt (tomt = automatiskt)",
            "todo.journalImageAlt": "Beskrivning (alt-text)",
            "todo.journalImageSizePresets": "Snabbstorlek",
            "todo.journalImageOriginal": "Återställ storlek",
            "todo.journalImageAlign": "Justering",
            "todo.journalImageAlignLeft": "Vänster",
            "todo.journalImageAlignCenter": "Centrera",
            "todo.journalImageAlignRight": "Höger",
            "todo.journalImageApply": "Verkställ",
            "todo.journalImageRemove": "Ta bort bild",
            "todo.digestTitle": "E-postpåminnelser",
            "todo.digestMorning": "Morgon (ca 07:00, din tidszon)",
            "todo.digestEvening": "Kväll (ca 17:00)",
            "todo.digestTimezone": "Tidszon",
            "todo.digestSaved": "Inställningar sparade",
            "todo.digestSaveError": "Kunde inte spara e-postinställningar.",
            "todo.prevDay": "Föregående dag",
            "todo.nextDay": "Nästa dag",
            "todo.today": "Idag",
            "richTextEditor.contextMenu.ariaLabel": "Åtgärder för formaterad text",
            "richTextEditor.contextMenu.insertImage": "Infoga bild…",
            "richTextEditor.contextMenu.moveSelectionToPage": "Flytta markering till sida…",
            "richTextEditor.contextMenu.createPageWithSelection": "Ny sida från markering…",
            "richTextEditor.contextMenu.handlerMissing": "Anslut en hanterare i förälderkomponenten för att aktivera den här åtgärden.",
            "richTextEditor.table.insert": "Infoga tabell",
            "richTextEditor.table.hint": "Lägger till en redigerbar 3 x 3-tabell.",
            "richTextEditor.table.defaultHeader": "Kolumn",
            "automile.checkoutConfirmTitle": "Checka ut från fordon?",
            "automile.checkoutConfirmMessage": "Är du säker på att du vill checka ut? Fordonet blir tillgängligt för andra förare.",
            "automile.checkoutConfirm": "Ja, checka ut",
            "automile.checkoutCancel": "Avbryt",
            "automile.checkInDriver": "Checka in förare",
            "automile.checkOutVehicle": "Checka ut förare",
            "automile.linkUser": "Koppla användare",
            "automile.selectEmployee": "Välj medarbetare",
            "automile.noVehiclesAvailable": "Inga lediga fordon (aktiva och utan incheckad förare).",
            "automile.settingsHint": "Slutför Automile under Företag → Integrationer.",
            "automile.driverNeedsSync": "Föraren måste synkas med Automile före incheckning.",
            "automile.onlyAvailableVehiclesSubtitle": "Endast aktiva fordon utan incheckad förare visas.",
            "automile.noDriversFreeForCheckin": "Inga förare utan incheckat fordon (med kopplad användare).",
            "automile.adminVehiclePickerSubtitle":
              "Alla aktiva fordon visas. Om fordonet är incheckat på någon annan flyttas det till den här föraren när du väljer det (för flåtansvariga).",
            "automile.noActiveVehiclesForFleet": "Inga aktiva fordon hittades.",
            "automile.vehicleOccupiedBadge": "Incheckad — omtilldelning checkar ut nuvarande förare först",

            "tool.open": "Öppna",
            "tool.back_to_overview": "Tillbaka till verktyg",
            "tool.assigned_user_column": "Tilldelad",
            "tool.assignment_heading": "Tilldelning",
            "tool.assignment_hint":
              "Tilldela verktyget till en medarbetare eller ta bort tilldelning (retur).",
            "tool.assigned_to": "Tilldelad till",
            "tool.not_assigned": "Ej tilldelad",
            "tool.assign_user": "Tilldela användare",
            "tool.reassign_user": "Byt innehavare",
            "tool.return_from_user": "Ta bort tilldelning (retur)",
            "tool.assign_saved": "Tilldelning uppdaterad",
            "tool.return_saved": "Verktyget returnerat",
            "tool.notes_heading": "Verktygsanteckningar",
            "tool.notes_hint":
              "Interna anteckningar om verktyget (visas inte i journal/service).",
            "tool.notes_placeholder": "Skriv anteckningar…",
            "tool.save_notes": "Spara anteckningar",
            "tool.notes_saved": "Anteckningar sparade",
            "tool.completed_service_intervals": "Genomförda serviceintervall",
            "tool.completed_service_intervals_hint":
              "Journalposter med status slutförd och «service» i titeln (samma regel som nästa service).",
            "tool.no_completed_service_intervals":
              "Inga genomförda serviceintervall är registrerade ännu.",
            "tool.journal_other_hint":
              "Övriga journalposter (aktiva, uppföljning, icke-service m.m.).",
            "tool.journal_empty_hint": "Skapa en journalpost för service eller anteckningar.",
            "tool.journal_no_other_entries": "Inga övriga journalposter.",
            "tool.print_label": "Skriv ut skylt / etikett",
            "tool.usage_history_heading": "Utlåningshistorik",
            "tool.usage_history_hint":
              "Vem som haft verktyget, hur många dagar (kalenderdagar, första och sista räknas), och om perioden avslutades med retur eller överlämning till annan användare.",
            "tool.usage_history_empty":
              "Ingen historik ännu. Historik skapas när du tilldelar, byter användare eller returnerar verktyget.",
            "tool.usage_user": "Användare",
            "tool.usage_from": "Från",
            "tool.usage_to": "Till",
            "tool.usage_days": "Dagar",
            "tool.usage_outcome": "Avslutning",
            "tool.usage_status": "Status",
            "tool.usage_status_active": "Aktivt lån",
            "tool.usage_status_ended": "Avslutad",
            "tool.usage_reason.return": "Returnerad (otilldelad)",
            "tool.usage_reason.reassign": "Överlämnad till annan användare",
            "tool.employee_tools_title": "Verktyg",
            "tool.employee_tools_intro_title": "Dina tilldelade verktyg",
            "tool.employee_tools_intro":
              "En enkel översikt över verktyg som är registrerade på dig, med tilldelningsdatum och nyckelinformation.",
            "tool.employee_tools_short": "Dina tilldelade verktyg.",
            "tool.employee_tools_loading": "Laddar verktyg...",
            "tool.employee_tools_load_error": "Kunde inte ladda verktyg.",
            "tool.employee_tools_empty_title": "Inga tilldelade verktyg",
            "tool.employee_tools_empty": "Det finns inga verktyg registrerade på dig.",
            "tool.employee_tools_assigned_on": "Tagen i bruk",
            "tool.employee_tools_unknown_date": "Okänt datum",
            "tool.employee_tools_no_service": "Ingen planerad service",
            "tool.employee_tools_days_held": "{{count}} dagar i bruk",

            // SaveBar / auto-save
            "Saving": "Lagrer",
            "Save": "Lagre",
            "Error saving changes": "Feil ved lagring",
            "Changes saved successfully": "Endringer lagret",
            "You have unsaved changes": "Du har ulagrede endringer",
            "Could not save": "Kunne ikke lagre",

            "platformBroadcast.scheduledLabel": "Planerad uppdatering",
            "platformBroadcast.countdownPrefix": "Om {{time}}",
            "platformBroadcast.scheduledOverdue": "Starttid är nådd — spara ditt arbete",
            "platformBroadcast.activeNoticesRegion": "Aktiva Promang-meddelanden",
            "platformBroadcast.noticeWarningTag": "Varning",
            "platformBroadcast.noticeInfoTag": "Info",
            "platformBroadcast.updatingTitle": "Promang uppdateras",
            "platformBroadcast.updatingHint": "Vi är snart tillbaka. Tack för ditt tålamod.",
            "platformBroadcast.updatingAdminHint":
              "Administratör: När utrullningen är klar, använd skiftnyckeln nere till höger och välj «Bekräfta att Promang har uppdaterats».",
            "platformBroadcast.dev.menuAria": "Plattform dev-meny",
            "platformBroadcast.dev.noActiveUpdate": "Ingen aktiv underhållssession.",
            "platformBroadcast.dev.statusLine": "{{phase}}: {{title}}",
            "platformBroadcast.dev.scheduleUpdate": "Planera uppdatering",
            "platformBroadcast.dev.startMaintenance": "Starta underhåll (uppdatering pågår)",
            "platformBroadcast.dev.confirmComplete": "Bekräfta att Promang har uppdaterats",
            "platformBroadcast.dev.addNotice": "Lägg till meddelande (info / varning)",
            "platformBroadcast.dev.manageNotices": "Hantera meddelanden",
            "platformBroadcast.dev.fieldTitle": "Titel",
            "platformBroadcast.dev.fieldDescription": "Beskrivning",
            "platformBroadcast.dev.fieldScheduledAt": "Tid för uppdatering",
            "platformBroadcast.dev.fieldExpectedEnd": "Förväntat kl. ca.",
            "platformBroadcast.dev.fieldKind": "Typ",
            "platformBroadcast.dev.kindInfo": "Info",
            "platformBroadcast.dev.kindWarning": "Varning",
            "platformBroadcast.dev.cancel": "Avbryt",
            "platformBroadcast.dev.save": "Spara",
            "platformBroadcast.dev.start": "Starta",
            "platformBroadcast.dev.close": "Stäng",
            "platformBroadcast.dev.maintenanceHint": "Användare ser helskärmsläget «Promang uppdateras» med nedräkning.",
            "platformBroadcast.dev.validationTitleTime": "Ange titel och tid.",
            "platformBroadcast.dev.validationTitle": "Ange titel.",
            "platformBroadcast.dev.invalidTime": "Ogiltig tid.",
            "platformBroadcast.dev.saved": "Planerad uppdatering sparad.",
            "platformBroadcast.dev.maintenanceStarted": "Underhåll startat.",
            "platformBroadcast.dev.confirmCompletePrompt": "Bekräfta att uppdateringen är klar och rensa denna runda för alla?",
            "platformBroadcast.dev.confirmed": "Bekräftat.",
            "platformBroadcast.dev.noticeCreated": "Meddelande skapat.",
            "platformBroadcast.dev.noticeHidden": "Meddelande dolt.",
            "platformBroadcast.dev.noticeShown": "Meddelande visas igen.",
            "platformBroadcast.dev.requestFailed": "Begäran misslyckades.",
            "platformBroadcast.dev.historyHint": "Dölj meddelanden när problemet är löst. Historik sparas i databasen.",
            "platformBroadcast.dev.recentUpdates": "Senaste planerade uppdateringar",
            "platformBroadcast.dev.allNotices": "Alla meddelanden",
            "platformBroadcast.dev.hidden": "dolt",
            "platformBroadcast.dev.hide": "Dölj",
            "platformBroadcast.dev.show": "Visa",
            "platformBroadcast.dev.roleViewMenu": "Simulera rollvy (endast UI)",
            "platformBroadcast.dev.roleViewTitle": "Hur Promang ser ut för dig",
            "platformBroadcast.dev.roleViewTabPresets": "Förval",
            "platformBroadcast.dev.roleViewTabCustom": "Anpassad (som användaradmin)",
            "platformBroadcast.dev.roleViewHintCustom":
              "Samma reglage som under Företag → Användare. Tryck «Verkställ simulering» längst ner när du är klar.",
            "platformBroadcast.dev.roleViewCustomApply": "Verkställ simulering",
            "platformBroadcast.dev.roleViewHint":
              "Gäller bara den här webbläsaren: meny, ruttgarder, RoleOnly och relaterade hooks. API:et använder fortfarande dina riktiga behörigheter.",
            "platformBroadcast.dev.roleViewApply": "Verkställ",
            "platformBroadcast.dev.roleViewReset": "Rensa simulering",
            "platformBroadcast.dev.roleViewResetNow": "Rensa simulering",
            "platformBroadcast.dev.roleViewActiveBanner":
              "Rollsimulering är på — gränssnittet speglar inte dina riktiga rättigheter.",
            "platformBroadcast.dev.roleViewToastApplied": "Rollsimulering uppdaterad.",
            "platformBroadcast.dev.roleViewToastReset": "Rollsimulering borttagen.",
            "platformBroadcast.dev.roleViewPreset.off.label": "Riktiga behörigheter",
            "platformBroadcast.dev.roleViewPreset.off.description":
              "Använd roller från servern (standard).",
            "platformBroadcast.dev.roleViewPreset.none.label": "Inga roller",
            "platformBroadcast.dev.roleViewPreset.none.description":
              "Tom rollista — nästan inga moduler i menyn.",
            "platformBroadcast.dev.roleViewPreset.hours_time_only.label":
              "Endast tidrapportering",
            "platformBroadcast.dev.roleViewPreset.hours_time_only.description":
              "Timmodul med registrering/redigering av egna timmar — inte godkännande, inställningar eller frånvaro.",
            "platformBroadcast.dev.roleViewPreset.hours_extended.label":
              "Timmar + godkännande och frånvaro",
            "platformBroadcast.dev.roleViewPreset.hours_extended.description":
              "Bred timprofil: listor, godkännande, läsning av inställningar, frånvaroregistrering.",
            "platformBroadcast.dev.roleViewPreset.service_field.label":
              "Service i fält",
            "platformBroadcast.dev.roleViewPreset.service_field.description":
              "Fokus på serviceöversikt och rapporter; begränsad avtalstillgång.",
            "platformBroadcast.dev.roleViewPreset.projects_participant.label":
              "Projektdeltagare",
            "platformBroadcast.dev.roleViewPreset.projects_participant.description":
              "Projekt och arbetsorder med typiska utföraråtgärder.",
            "Send Offer": "Skicka offert",
            "Choose recipient, offer PDF version and customer message before sending.":
              "Välj mottagare, PDF-version och kundmeddelande innan offerten skickas.",
            "Offer sending has been queued. You will be notified when it's complete.":
              "Offertsändningen har lagts i kö. Du får besked när den är klar.",
            "Something went wrong. Could not send offer.":
              "Något gick fel. Det gick inte att skicka offerten.",
            "Offer Type": "Offerttyp",
            "Internal offer": "Intern offert",
            "Customer offer": "Kundoffert",
            "Open selected offer PDF": "Öppna vald offert-PDF",
            "PDF preview will be available when the selected offer type is generated.":
              "PDF-förhandsvisning blir tillgänglig när vald offerttyp har genererats.",
            "Message to customer": "Meddelande till kund",
            "Offer sent successfully!": "Offerten har skickats.",
            "Offer sending queued...": "Offertsändningen har lagts i kö...",
            "Generating PDF and sending offer...":
              "Genererar PDF och skickar offert...",
            "Failed to send offer": "Det gick inte att skicka offerten",
            "Failed to send offer. Please try again.":
              "Det gick inte att skicka offerten. Försök igen.",
            "Request timed out. Please check the offer status manually.":
              "Begäran tog för lång tid. Kontrollera offertstatus manuellt.",
            "publicAppointment.title": "Bekräfta avtalet",
            "publicAppointment.subtitle": "Gå igenom uppgifterna och bekräfta att tiden fortfarande passar.",
            "publicAppointment.sectionAppointment": "Avtal",
            "publicAppointment.sectionWork": "Uppdraget",
            "publicAppointment.reportType": "Typ av uppdrag",
            "publicAppointment.serviceAddress": "Uppdragsadress",
            "publicAppointment.workDescription": "Beskrivning av uppdraget",
            "publicAppointment.timeExactHint": "Vi planerar att komma ungefär vid denna tid.",
            "publicAppointment.timeWindowHint": "Vi kommer någon gång inom denna tidsram.",
            "publicAppointment.reportNumber": "Uppdrag / rapportnr.",
            "publicAppointment.date": "Datum",
            "publicAppointment.time": "Tid",
            "publicAppointment.companyFallback": "Leverantör",
            "publicAppointment.confirmHint":
              "När du bekräftar registrerar vi avtalet som accepterat. Vid ändringsbehov, kontakta oss via telefon eller e-post.",
            "publicAppointment.termsAcceptPlain":
              "Genom att bekräfta avtalet godkänner du våra villkor för användning av tjänster, försäljning och serviceavtal.",
            "publicAppointment.termsAcceptPrefix": "Genom att bekräfta avtalet godkänner du våra ",
            "publicAppointment.termsAcceptLink": "villkor för användning av tjänster, försäljning och serviceavtal",
            "publicAppointment.termsAcceptSuffix": ".",
            "publicAppointment.confirmButton": "Bekräfta avtalet",
            "publicAppointment.submitting": "Bekräftar…",
            "publicAppointment.successTitle": "Tack — avtalet är bekräftat",
            "publicAppointment.successBody": "Du kan stänga sidan. Vid ändringar, kontakta företaget direkt.",
            "publicAppointment.alreadyConfirmed": "Detta avtal är redan bekräftat.",
            "publicAppointment.loadFailed": "Vi kunde inte hitta avtalet. Länken kan vara ogiltig eller utgången.",
            "publicAppointment.confirmFailed": "Vi kunde inte registrera bekräftelsen. Försök igen eller kontakta oss.",
            "publicAppointment.missingToken": "Bekräftelselänken saknar nödvändig information.",
    }
}
